import $ from 'jquery';
import ReactDOM from 'react-dom';
import {formStateStore} from '../../../Redux/Store/store';
import {updateComponentInJson}  from '../SectionLayoutLogic';
import moment from 'moment';
import {getFormJsonFromStore,updatedComponentInFormStates, 
  getOpenCanvasSubform, getAdvanceListViewFormJsonFromStore,
   getReduxContexts, getGdToken, getWIToken, updateSheetId, updateStepIndex, 
   setMandatoryControls1, getMandatoryControls, getStepName, getSubStepName, 
   gethandleEditor2FromRedux,getCurrentAdvanceListviewStateJsonFromStore, 
   getOpenCanvasForPreviewAdvanceSubform, getGlobalContext, getOpenCanvasForPreview, 
   getSubFormListviewJsonFromStore, getContainerId, getOpenCanvasForPreviewAdvance,
    fetchGridStates, getStepIndex, getSubStepIndex, createUniqueId, getColumnLayout,
     getCurrentDevice, changeControlProperty, getGridStates,
     getOpensubformCheck,
     getTabActiveIndex,
     updateRenderState,
     getFormMataData,
     updatePartialJSON,
     updateRowNColumn,updateRowNColumnOnSave,encrypt, getErrorState,
         getActiveStepId,
     getActiveSubStepId,
     makeChildrenEmpty} from '../IFormDesignerLogic';
import { deleteRowInGrid,clearTable,addRowInGrid,setValues,addDataToGrid,setTableCellData,refreshFrame,getSessionId,executeServerEvent,setTableMultiCellData,getAttributeXml,addDataToAdvancedGrid, reloadTab, getRichTxtData, saveRTEData, deleteDoc, saveApplicationData1, getGeneralData, userDefinedThemes} from '../RequestLogic';
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert"
import axios from "../../../axios"
import { Provider } from 'react-redux';
import secureLocalStorage from 'react-secure-storage';
import ErrorBoundary from '../../../ReusableComponents/ErrorBoundary';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../../i18n';
import Translation from '../../../ReusableComponents/Translation';
import {isDesktop, isMobile, isTablet } from "react-device-detect";
import { updateStore} from '../../../Redux';
import { GetState } from '../../CustomHooks/CustomHooks';
import { getHooksId } from '../../../Resources/globalFunctions';
import { updateFormStateWithoutRender, updateStateInRedux } from '../../../Redux/Actions/FormStateActions';
import { executeRouteJourney1} from "../../../ReusableComponents/Events/EventExecutionLogic";
import { z } from 'zod/v4';
import uuid from 'react-uuid';
import { ThemeJSON } from '../Theme/ThemeJSON';
import secureSessionStorage from '../../../utils/secureSessionStorage';

z.config({ jitless: true })

window["allWindows"] = [];
window["totalSubWindows"] = 0;

const containsSubsteps = (json, find) =>{
  const findKey=find?.toLowerCase();
  return json?.children?.findIndex(function(child){return child?.elem_type?.toLowerCase()=== findKey })!==-1
}
function countOccurrences(str, char) {
  let count = 0;
  for (let i = 0; i < str.length; i++) {
    if (str[i] === char) {
      count++;
    }
  }
  return count;
}

function notContainParent(data) {
  const store = functions.renderElementsArray;

  return (
    store?.has(data?.parentRowJson?.id) ||
    store?.has(data?.parentColumnJson?.id)
    //  ||
    // store?.has(data?.parentFrameJson?.id)
  );
}

const getUpdatedColumnIndex = (eleJSON = {}, formjson = {}, columnIndex) => {
  const updatedColumnIndex =
    eleJSON?.style?.ShowSerialNumber === "true" &&
    formjson.isIbpsForm === "Y" &&
    (typeof columnIndex === "number" || typeof columnIndex === "string") &&
    (columnIndex || columnIndex === 0)
      ? parseInt(columnIndex - 1)
      : columnIndex;

  return updatedColumnIndex;
};

// returns the index of the first child sheet in a tab that is not hidden via style.VisibleArr, or -1 if none are visible
const getFirstVisibleSheetIndex = (tabJSON) => {
  if(!tabJSON?.children) return -1;
  const hiddenArr = tabJSON.style?.VisibleArr || [];
  return tabJSON.children.findIndex((_, childIndex) => !hiddenArr.includes(childIndex));
};

// redirects a tab's active sheet to the first visible one, used whenever the previously active sheet gets hidden
const redirectActiveSheetIfHidden = (tabJSON) => {
  const firstVisibleIndex = getFirstVisibleSheetIndex(tabJSON);
  if(firstVisibleIndex !== -1) {
    tabJSON.setSheetIndex = firstVisibleIndex;
  }
};

export  const functions = {
  render: false,
  beforeFormLoadJSON: {},
  renderElementsArray: new Set(),
  fromRefreshFrame : false,
  fromExecuteServerEvent: false,
  getFormJsonFromStore: () => {
    if(Object.keys(functions.beforeFormLoadJSON).length > 0) 
        return functions.beforeFormLoadJSON;
    return getFormJsonFromStore();
  },
  renderParentFrame: false,
  showAlertMessage: true,
  readJson: function (formJSON,controlId) { 
    return recursiveJsonReader1(formJSON,controlId);
  },
  addWindowObject: function (win){
    if(window?.allWindows) {
      window.allWindows[window.totalSubWindows] = win;
      window.totalSubWindows += 1; 
    }
  },
  applyTheme: function (themeName) {
     userDefinedThemes()
     .then((response) => {
      Object.values(response.data).forEach((themeContent, themeIndex) => {
        try {
        const themeContentParsed=JSON.parse(themeContent)
        if(themeContentParsed?.themeName === themeName){
          const contexts = getGlobalContext();
          const { updateJson } = contexts;
          const { updatedComponentInFormState } = updateJson;
         window.formBuffer.themeName = themeContentParsed.themeName;
         window.formBuffer.theme = themeContentParsed;
         updatedComponentInFormState()
        }         
        } catch {
          console.log(
            "issue in theme reading",
            Object.keys(response.data)?.[themeIndex]
          );
        }
      });
    })
    .catch(function (error) {});
  },
  readNJson: function (controlId, formJSON) {
    const formBuffer = formJSON || window.formBuffer;
    return recursiveJsonReader1(formBuffer, controlId, "", true);
  },
  readJson1: function (controlId) { 
    return findElement1(controlId);
  },
  updateControlJson: function (controlJson){
    // let controlJson = recursiveJsonReader1(formJSON,controlId);
    // controlJson
    if(controlJson){

      const contexts = getGlobalContext();
      const { updateJson } = contexts;
      const { updatedComponentInFormState } = updateJson;
      
      updatedComponentInFormState(controlJson?.id, controlJson);
    }

  },
  renameNavigationList: function(json) {

    if(!validateParams(apiValidationObjects.renameNavigationList, {json}, "renameNavigationList")) return;

    let formjson = functions.getFormJsonFromStore();
    let wizardJson = recursiveJsonReader1(formjson,json.controlid);
    if(wizardJson && Object.keys(json.list)?.length > 0) {
      if(wizardJson.elem_type === "wizard_h" || wizardJson.elem_type === "wizard_v" || wizardJson.elem_type === "sidenavigation") {
        for(let i = 0; i < wizardJson.children?.length; i++) {
          if(json.list[wizardJson.children[i].stepName]) {
            wizardJson.children[i].stepName = json.list[wizardJson.children[i].stepName];
          }
          if(containsSubsteps(wizardJson.children[i],"substep")) {
            for(let j = 0; j < wizardJson.children[i].children.length; j++) {
              if(json.list[wizardJson.children[i].children[j].stepName]) {
                wizardJson.children[i].children[j].stepName = json.list[wizardJson.children[i].children[j].stepName];
              }
            }
          }
        }
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(wizardJson) && wizardJson?.id)
          functions.renderElementsArray.add(wizardJson?.id)
        // } else {
        //    updateRenderState(wizardJson?.id);
        // }
        functions.render = true;
      } else functions.showMess(["renameNavigationList","Not_Valid",json.controlId],"error")
    } else {
      functions.showMess(["The_Control",json.controlid,"Not_Present"],"error");
    }
  },
  loadSectionIcon: function(id, base64) {
    var formjson = functions.getFormJsonFromStore();
    let eleJSON = recursiveJsonReader1(formjson,id);
    if(eleJSON) {
      if(validControls.loadSectionIcon.includes(eleJSON?.elem_type)) {
        if(!eleJSON.style)
          eleJSON.style = {};
        eleJSON.style["iconFile"] = base64;
        eleJSON.style.dynamicIconUpload = true;
        updateRenderState(eleJSON?.id);
      }
      else functions.showMess(["Invalid_Operation"],"error");
    }
    else {
      functions.showMess(["loadSectionIcon","Not_Valid",id],"error");
    }
  },
   loadButtonIcon: function(buttonId, base64, alignment) {
    var formjson = functions.getFormJsonFromStore();
    let eleJSON = recursiveJsonReader1(formjson, buttonId);
    if (eleJSON) {
      if (validControls.loadButtonIcon.includes(eleJSON?.elem_type)) {
        if (!eleJSON.style)
          eleJSON.style = {};
        if (!eleJSON.style.icon)
          eleJSON.style.icon = {};

        const normalizedAlignment = (alignment || "").toLowerCase() === "right" ? "Right" : "Left";
        eleJSON.style.icon.file = base64;
        eleJSON.style["IconAlignment"] = normalizedAlignment;
        eleJSON.style["dynamicIcon"] = true;
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
      }
      else functions.showMess(["loadButtonIcon","Not_Valid",buttonId],"error");
    }
    else {
      functions.showMess(["The_Control",buttonId,"Not_Present"],"error");
    }
  },
  returnControlId: function (id,type) {
    var formjson = functions.getFormJsonFromStore();
    let eleJSON = recursiveJsonReader1(formjson,id);
    if(type?.toLowerCase() === "customid"){  
      if(!eleJSON?.style?.CustomId){
        // functions.showSplitMessage("Error","CustomId is not defined for the control","error",true,true,[]);
        if(!window?.psh_configs?.hideControlNotPresentAlert) {
          functions.showMess(["CustomId is not defined for the control"],"error");
        }
      } else
      return eleJSON?.style?.CustomId;
    }
    else if(type?.toLowerCase() === "dataclass"){
      if(!eleJSON?.dataclass){
        // functions.showSplitMessage("Error","Dataclass is not defined for the control","error",true,true,[]);
        functions.showMess(["Dataclass is not defined for the control"],"error");
      } else
      return eleJSON?.dataclass;
    }
    else return eleJSON?.id;
  },
  openExternalForm: function(folderName, cabinetName){
    openExternalForm(folderName, cabinetName)
  },
  getInterfaceData: function(){
    return getInterfaceData()
  },
  loadImageFromUrl: function(controlId, URL) {
    loadImageFromUrl(controlId, URL);
  },
  hideAlertMessage: function(toshow = false){
    hideAlertMessage(toshow)
  },
  saveApplicationData: function(isSubmit, cleanSession , eventSource, silentFlag = false) {
    saveApplicationData(isSubmit, cleanSession, eventSource, silentFlag)
  },


  setStyle: function (Id, attribute, value, forcefull) {
    setStyle({Id, attribute, value, forcefull});
  },
  executeRouteJourney:function(FormName,DecisionField,controlId)
  {
    executeRouteJourney(FormName,DecisionField,controlId);
  },
  openDoclistFunction : function(){
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";      
    const documentData = window?.documentViewData
    const ImageIndex= documentData?.documentIndex
    const volIndex= documentData?.volumeIndex
    const id=ImageIndex + '#' + volIndex + '#';
    const extension=documentData?.extension
    const docName=documentData?.documentname

    const doclistViewData = {
      direction: translationStyles1 ? "rtl" : "ltr",
      source: "IFORM",
      dms_type: "3",
      isPortal: true,
      documentInfoProps: {
        name: docName,
        id: id,
        i_s_index: id,
        extension: extension,
        get_document: `/wd-rest/app/getdocuments?ImgIndex=${ImageIndex}&VolIndex=${volIndex}&DocExt=${extension}&DocIndex=&PageNo=&docType=&DocSize=&ArchivalMode=N&ArchivalCabinet=&taskid=&DocumentName=${docName}`,
        dms_type: "3"
      },
      SetDocumentDataProps: {
        documents: [
          {
            name: docName,
            id: id,
            i_s_index: id,
            extension: extension,
            url_info: {
              get_document: `/wd-rest/app/getdocuments?ImgIndex=${ImageIndex}&VolIndex=${volIndex}&DocExt=${extension}&DocIndex=&PageNo=&docType=&DocSize=&ArchivalMode=N&ArchivalCabinet=&taskid=&DocumentName=${docName}`
            },
            dms_type: "3"
          }
        ]
      },
      Component: "DocumentViewer",
      Module: "WCL",
      InFrame: false,
      ContainerId: "doclistViewerMicro_id_form"
    };
    window.loadMicroFrontend(doclistViewData);  
  },
  openDoclistViewer : function(documentData={documentname:"bug6.png",documentIndex:"227",volumeIndex:"1",extension:"png"}) {
    if(window?.isPortalLive){
      formStateStore.dispatch(updateStateInRedux({name: "openDoclistViewerMicro", value: true})); 
      window.documentViewData=documentData    
    }else {
     functions.showMess(["openDoclistViewer","Only_Valid_Portal","error"])
    }
  },
  uploadDocumentWindowFunction: function(documentDataParam){
    const jwtToken =
    JSON.parse(
      secureLocalStorage.getItem(
        window.isPortalLive ? `launchpadKey_${window.applicationName}` || `launchpadKey_bypass_${window.applicationName}` || "launchpadKey" : "launchpadKey"
      )
    )?.token ||
    secureSessionStorage.getItem("Authorization") ||
    undefined;
    const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";    
    const documentData= documentDataParam || window.documentUploadWindowData;
    const available_doc_types = [];
    const dummyData = {
      max_file_size: documentData?.max_file_size || 5000000,
      allowed_file_types: documentData?.allowFileTypes,
      multiple_upload: documentData?.multipleUpload || false,
      enable_upload: true
    };

    if (documentData?.docTypes?.length > 0) {
      documentData?.docTypes?.forEach((doc, i) => {
        available_doc_types.push({
          id: i + 1,
          name: doc,
          description: doc,
          ...dummyData
        });
      });
    }
    const propsData = {
      openUploadWindowCustomInPortal: true,
      Module: "WCL",
      Component: "DocumentListViewer",
      Unmount: "",
      InFrame: false,
      ContainerId: "openDoclistUploadMicro",
      locale: "en",
      direction: translationStyles1 ? "rtl" : "ltr",
      data: {
        documents: [],
        available_doc_types: available_doc_types,
        doc_upload_options: {
          google_drive: false,
          camera: true,
          scan: false,
          omnidocs: false,
          system: true
        },
        upload_doc_as: {
          new: true,
          new_version: true,
          overwrite: true
        },
        docviewer_info: {
          viewer_location: "inline",
          ContainerId: "rdDIv",
          view_annotation: true,
          view_stamps: true,
          show_opall_menu: true,
          opall_params: {
            printOption: "false",
            TransformOption: ""
          }
        },
        enable_next: true,
        enable_prev: false,
        enable_search: false,
        enable_upload: true,
        enable_filter: false,
        enable_sorting: false,
        allow_comment:true,
        source: "APPLICATION",
        pid: "",
        wid: "",
        ext_data: {},
        dms_type: "3"
      },
      passedData: {
        documents: [],
        available_doc_types: available_doc_types,
        doc_upload_options: {
          google_drive: false,
          camera: true,
          scan: false,
          omnidocs: false,
          system: true
        },
        upload_doc_as: {
          new: true,
          new_version: true,
          overwrite: true
        },
        docviewer_info: {
          viewer_location: "inline",
          ContainerId: "rdDIv",
          view_annotation: true,
          view_stamps: true,
          show_opall_menu: true,
          opall_params: {
            printOption: "false",
            TransformOption: ""
          }
        },
        enable_next: true,
        enable_prev: false,
        enable_search: false,
        enable_upload: true,
        enable_filter: false,
        enable_sorting: false,
        allow_comment:true,
        source: "APPLICATION",
        pid: "",
        wid: "",
        token:jwtToken,
        ext_data: {},
        dms_type: "3"
      },
      Callback: window.callBackFunction
    };
    window.loadMicroFrontend(propsData);
  },
  uploadDocumentWindow: function (documentData = { allowFileTypes: [], docTypes: ["doc1", "doc2"],multipleUpload:false }) {
    if (window?.isPortalLive) {
      window.documentUploadWindowData=documentData;
      if(this?.uploadDocumentWindowFunction) {
        this.uploadDocumentWindowFunction(documentData);
      }
      // else {
      //   formStateStore.dispatch(updateStateInRedux({ name: "openDoclistUploadMicro", value: true }));
      // }
    } else {
      functions.showMess(["uploadDocumentWindow", "Only_Valid_Portal", "error"]);
    }
  },
  setTileProperty: function(controlId, tileIndex, propertyName,propertyValue) {
    if(!validateParams(apiValidationObjects.setTileProperty, {controlId, tileIndex, propertyName: propertyName?.toLowerCase(),propertyValue}, "setTileProperty")) return;
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId);
    if(eleJSON) {
      if(validControls.setTileProperty.includes(eleJSON.elem_type)) {
        if(eleJSON.tileContents[tileIndex]){   
          eleJSON.tileContents[tileIndex][propertyName] = propertyValue
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
    else{
      functions.showMess([tileIndex,"Not_Present"],"error");
    }
      }
      else {
        functions.showMess(["setTileProperty","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },
  
  rearrangeTileContents: function(controlId, tileContentsArrayIndexes) {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId);
    if(eleJSON) {
      const indexNotfound = tileContentsArrayIndexes.filter(ind => eleJSON?.tileContents?.[ind]?.id  === undefined );
      if(arguments.length>2){
        functions.showMess(["Number_of",'arguments',"more_than_2"],"error");
      }
      if(!Array.isArray(tileContentsArrayIndexes)){
        return functions.showMess(["Not_Array",tileContentsArrayIndexes,""],"error");
      }
      else if(eleJSON?.tileContents?.length!==tileContentsArrayIndexes?.length){
        return functions.showMess(["Index_Number",tileContentsArrayIndexes.length,"Tile_Group"],"error");
      }
      else if(indexNotfound.length > 0  ){
        functions.showMess(["Tile_rearrangeApi_Index_issue","Not_Valid",controlId],"error");
      }
      else if(validControls.rearrangeTileContents.includes(eleJSON.elem_type)) {
          let updatetileContentsArray= tileContentsArrayIndexes.map(contentIndex=>eleJSON.tileContents[contentIndex])
          updatetileContentsArray = [...updatetileContentsArray, ...eleJSON.tileContents.filter((_, index) => !tileContentsArrayIndexes.includes(index))];
          eleJSON.tileContents = updatetileContentsArray;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;    
      }
      else {
        functions.showMess(["rearrangeTileContents","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },
 
  reOrderControls: function (controlId, controlNames = []){
    const formjson = functions.getFormJsonFromStore();
    let eleJSON = recursiveJsonReader1(formjson, controlId, 'control');
    
    if(eleJSON){
      if(validControls.reOrderControls.includes(eleJSON?.elem_type)) {
        let childrens=eleJSON.children?.[0]?.children || [];
        const row = childrens.filter((child) => child?.children?.length > 0);
        const emptyRow = childrens.filter((child) => child?.children?.length === 0);
        let newControlObj = {};
        for(let i = 0; i < row?.length; i++) {
          if(row[i]?.children?.length > 0) {
            for(let j = 0; j < row[i]?.children?.length; j++) {
              if(controlNames.includes(row?.[i]?.children?.[j]?.style?.CustomId || row?.[i]?.children?.[j]?.dataclass || row?.[i]?.children?.[j]?.id)) {
                if(row?.[i]?.children?.[j]?.id) {
                  newControlObj[row?.[i]?.children?.[j]?.id] = row[i].children[j];
                  newControlObj[`column_${row?.[i]?.children?.[j]?.id}`] = row[i];
                }
                if(row?.[i]?.children?.[j]?.style?.CustomId) {
                  newControlObj[row?.[i]?.children?.[j]?.style?.CustomId] = row[i].children[j];
                  newControlObj[`column_${row?.[i]?.children?.[j]?.style?.CustomId}`] = row[i];
                }
                if(row?.[i]?.children?.[j]?.dataclass) {
                  newControlObj[row?.[i]?.children?.[j]?.dataclass] = row[i].children[j];
                  newControlObj[`column_${row?.[i]?.children?.[j]?.dataclass}`] = row[i];
                }

                if(row[i]?.children?.length > 1) {
                  row[i].children.splice(j,1);
                  j--;
                }
                else {
                  row.splice(i,1);
                  i--;
                }
              }
            }
          }
        }
        for(let i = controlNames?.length-1; i >= 0; i--)  {
          const isNewColumn = controlNames[i] === "_EMPTYCOLUMN_";
          if(newControlObj[controlNames[i]]) {
            let col = {};
            col.id = createUniqueId('column');//newElement;
            col.elem_type = 'column';
            col.md = newControlObj[`column_${controlNames[i]}`].md
            col.w = newControlObj[`column_${controlNames[i]}`].w
            col.xs = newControlObj[`column_${controlNames[i]}`].xs
            col.sm = newControlObj[`column_${controlNames[i]}`].sm
            col.children = [];
            col.style = {};
            col.style["heightselect"] = "set";
            col.frameIndex = eleJSON.frameIndex;
            col.children.push(newControlObj[controlNames[i]]);
            row?.unshift(col);
          } else if(isNewColumn) {
            let col = {};
            col.id = createUniqueId('column');//newElement;
            col.elem_type = 'column';
            col.md = getColumnLayout("web");
            col.w =  getColumnLayout(getCurrentDevice() || "web");
            col.xs = getColumnLayout("tablet");
            col.sm = getColumnLayout("mobile");
            col.children = [];
            col.style = {};
            col.style["heightselect"] = "set";
            col.frameIndex = eleJSON.frameIndex;
            row?.unshift(col);
          }
        }
        eleJSON.children[0].children = row;
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
      else {
        functions.showMess(["reOrderControls","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  changeFormLocale : function(lang, stayOnCurrentPage = false){
    const {
      openCanvasForPreviewAdvance = "",
      currentAdvanceListviewStateJson = {},
      subFormListviewJson = {},
      openCanvasForPreview = ""
    } = getGridStates();

    if(openCanvasForPreview === "showDataAdditonSection") {
      functions.showSplitMessage("", `Please close ${
        subFormListviewJson?.style?.Label || subFormListviewJson?.style?.CustomId || subFormListviewJson.id
      } first`, "error")
      return;
    }
    if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview") {
      functions.showSplitMessage("", `Please close ${
        currentAdvanceListviewStateJson?.style?.Label || currentAdvanceListviewStateJson?.style?.CustomId || currentAdvanceListviewStateJson.id
      } first`, "error")
      return;
    }
    window.setFormLang(lang);   

    const changePortalLang =()=>{
      return axios.post("/viewform/changeLocale", {locale: lang}, {withCredentials:true}).then((res) => {
        window.formLoaderRan = false;
        if(stayOnCurrentPage === true){
          formStateStore.dispatch(updateStateInRedux({name: "postChangeFormLang_samepage", value: true}));
        }
        else{
          formStateStore.dispatch(updateStateInRedux({name: "callHomePage", value: true}));
        }
        
      }) 
    }

    window.changeFormLocaleFunctionCalling = true;
    window.isPortalLive ? changePortalLang() : window.createModalCallHook(lang) 
    if(window.postHookChangeLocale)
    window.postHookChangeLocale(lang)
  },
  
  createIndicator : function(){
    window.setStartCustomAPILoader(true);
  },

  removeIndicator : function(givenTime) {
  if (givenTime) {
      setTimeout(() => {
        window.setStartCustomAPILoader(false);
      }, givenTime);
  }
  else{
      window.setStartCustomAPILoader(false);
    }
  },

    getSectionState : function (frameId)
    {
      var formjson = functions.getFormJsonFromStore();

      if( typeof(frameId) !== 'string' || ( typeof(frameId) === 'string' && frameId.length===0 ) ){
        functions.showMess(["GetSectionState_Invalid_parameter","Not_Valid","frameID"],"error");
      }
      else{
        var eleJSON=recursiveJsonReader1(formjson,frameId,'frame');
        if(eleJSON) {
          if(validControls.getSectionState.includes(eleJSON?.elem_type)) {
            return eleJSON?.style?.sectionState;
          }
          else {
            functions.showMess(["getSectionState","Not_Valid",frameId],"error");
          }
        }
        else {
          functions.showMess(["The_Control",frameId,"Not_Present"],"error");
        }
      }
    },

  setLabelLink :function(controlId,LinkURL){
    var formjson = functions.getFormJsonFromStore();
   var eleJSON = recursiveJsonReader1(formjson,controlId)
    if(eleJSON){
       eleJSON.style.LinkURL = LinkURL
      //  if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
       functions.render = true;
    }
    else {
  functions.showMess(["The_Control",controlId,"Not_Present"],"error");
   }
  },
  setRadioOptionsHideOrShow: function (Id, attribute, value, optionIndex) {
    setRadioOptionsHideOrShow(Id, attribute, value, optionIndex);
  },

  reOrderColumns: function (controlId, columnNames) {
    reOrderColumns(controlId, columnNames);
  },

  applyGridBatching: function (controlId, action) {
    applyGridBatching(controlId, action);
  },

  addDataToDoclist: function(docControlId,jsonArray) {
    addDataToDoclist(docControlId,jsonArray)
  },

  showHideDocumentTypes: function (docControlId, documentType, showHideFlag) {
    showHideDocumentTypes(docControlId, documentType, showHideFlag);
  },
  
  mandateDocTypes: function (docControlId, documentType, mandateDocFlag) {
    mandateDocTypes(docControlId, documentType, mandateDocFlag);
  },

  clearDocList: function (doclistId) {
    clearDocList(doclistId);
  },

  setStyle1: function (Id, attribute, value, showHideAddDelete) {

    
    var elem = document.getElementById(Id);
    var elem_type = elem?.getAttribute('elem_type');
    if (attribute === 'visible') {


      if (showHideAddDelete === -1) {

        if (value === 'false') {
          document.getElementById(Id + '_button').setAttribute('style', 'display:none !important');
        } else if (value === 'true') {
          document.getElementById(Id + '_button').setAttribute('style', 'display:block !important');
        }
      }

      else {
        if (value === 'false') {
          if(document.querySelector("[control_id="+Id+"]").parentElement.children.length===1){
            document.querySelector("[control_id="+Id+"]").parentElement.style.display='none';
          } else {
            //We need to check whether the control is having a parent div or not then we will hide it
            //temporarily
            document.querySelector("[control_id="+Id+"]").style.display='none';
          }
        } else if (value === 'true') {
          if(document.querySelector("[control_id="+Id+"]").parentElement.children.length===1){
            document.querySelector("[control_id="+Id+"]").parentElement.style.display='block';
          } else {
            //We need to check whether the control is having a parent div or not then we will hide it
            //temporarily
            if(elem_type==='toggle'){
              document.querySelector("[control_id="+Id+"]").style.display='flex';
            } else {
              document.querySelector("[control_id="+Id+"]").style.display='';
            }
          }
        }
      }
    }

    if (attribute === 'disable') {
      if (value === 'true') {
        document.getElementById(Id).disabled = true;
      } else if (value === 'false') {
        document.getElementById(Id).disabled = false;
      }
    }

    if (attribute === 'backcolor') {
      if(/(^[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value))
      {
        value='#'+value;
      }
      document.getElementById(Id).parentNode.style.backgroundColor = value;
    }

    if (attribute === 'charcase') {
      if(value === "up"){
      document.getElementById(Id).style.textTransform = "uppercase";
      }
      else if(value ==="low"){
      document.getElementById(Id).style.textTransform = "lowercase";
      }
    }

    if (attribute === 'fontcolor') {
      if(/(^[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value))
      {
        value='#'+value;
      }
      document.getElementById(Id).style.color = value;
    }

    if (attribute === 'fontfamily') {
      document.getElementById(Id).style.fontFamily = value;
    }

    if (attribute === 'fontweight') {
      document.getElementById(Id).style.fontWeight = value;
    }

    if (attribute === 'fontsize') {
      document.getElementById(Id).style.fontSize = value;
    }

    if (attribute === 'fontstyle') {
      document.getElementById(Id).style.fontStyle = value;
    }
    if (attribute === 'maxlength') {
      document.getElementById(Id).maxLength = value;
    }

    if (attribute === 'mandatory') {
      if (value === 'true') {
        document.getElementById(Id + '_label').required = true;
      } else {
        document.getElementById(Id + '_label').required = false;
      }
    }

    if (attribute === 'readonly') {
      if (value === 'true') {
        document.getElementById(Id).readOnly = true;
      } else {
        document.getElementById(Id).readOnly = false;
      }
    }

    if (attribute === 'title') {
      document.getElementById(Id).setAttribute('title', value);
    }
    if(attribute === 'sectionstate')
    {
      if(value === 'expanded')
      {
        
        if(document.getElementById(Id)?.getAttribute('sectionView') === 'collapsed')
        {
          (document.getElementById(Id)?.querySelectorAll("[variant='link']")[0]).click();
        }
      }
      else if(value === 'collapsed')
      {
        if(document.getElementById(Id)?.getAttribute('sectionView') === 'expanded')
        {
          (document.getElementById(Id).querySelectorAll("[variant='link']")[0]).click()
        }
      }
    }
    if(attribute === 'lock')
    {
      if(value === 'true')
      {
        (document.getElementById(Id).querySelectorAll("[variant='link']")[0]).style.display='none';
      }
      else if(value === 'false')
      {
        (document.getElementById(Id).querySelectorAll("[variant='link']")[0]).style.display='';
      }
    }
  },

  changeStepName: function(stepIndex,stepName) {
    var formJSON = functions.getFormJsonFromStore();
    var eleJSON = findWizard(formJSON.children[1].children);
    if(eleJSON && (eleJSON.elem_type === 'wizard_h' || eleJSON.elem_type === 'wizard_v' || eleJSON.elem_type === 'sidenavigation')) {
      if(eleJSON?.children?.[stepIndex]) {
        eleJSON.children[stepIndex].stepName = stepName;
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      } else {
        functions.showMess(["Step_Index",stepIndex,"Not_Present"],"error");
      }
    }
    else {
      functions.showMess(["changeStepName","Not_Valid"],"error");
    }
  },

  changeSubStepName: function(stepIndex,subStepIndex,stepName) {
    var formJSON = functions.getFormJsonFromStore();
    var eleJSON = findWizard(formJSON.children[1].children);
    if(eleJSON && (eleJSON.elem_type === 'wizard_h' || eleJSON.elem_type === 'wizard_v' || eleJSON.elem_type === 'sidenavigation')) {
      if(eleJSON?.children?.[stepIndex]) {
        if(containsSubsteps(eleJSON?.children?.[stepIndex],"substep")) {
          if(eleJSON?.children?.[stepIndex]?.children?.[subStepIndex]) {
            eleJSON.children[stepIndex].children[subStepIndex].substepName = stepName;
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
            functions.render = true;
          } else {
            functions.showMess(["Substep_Index",subStepIndex,"Not_Present"],"error");
          }
        } else {
          functions.showMess(["Substep","Not_Present"],"error");
        }
      } else {
        functions.showMess(["Step_Index",stepIndex,"Not_Present"],"error");
      }
    }
    else {
      functions.showMess(["changeStepName","Not_Valid"],"error");
    }
  },

  getCurrentStepName: function() {
    var formjson = functions.getFormJsonFromStore();
    if(formjson.containerControl === 'wizard_h' || formjson.containerControl === 'wizard_v' || formjson.containerControl === 'sidenavigation')
      return getStepName();
    else {
      functions.showMess(["getCurrentStepName","Not_Valid"],"error");
    }
  },


  getCurrentLocale: function(){
    return window.psh_configs.selectedLanguage;
  },
  
  getCurrentLocale: function(){
    return window.psh_configs.selectedLanguage;
  },
  
  getCurrentSubStepName: function() {
    var formjson = functions.getFormJsonFromStore();
    if(formjson.containerControl === 'wizard_h' || formjson.containerControl === 'wizard_v' || formjson.containerControl === 'sidenavigation')
      return getSubStepName();
    else {
      functions.showMess(["getCurrentSubStepName","Not_Valid"],"error");
    }
  },

  getCurrentStepIndex: function() {
    var formjson = functions.getFormJsonFromStore();
    if(formjson.containerControl === 'wizard_h' || formjson.containerControl === 'wizard_v' || formjson.containerControl === 'sidenavigation')
      return getStepIndex();
    else {
      functions.showMess(["getCurrentStepIndex","Not_Valid"],"error");
    }
  },

  getCurrentSubStepIndex: function() {
    var formjson = functions.getFormJsonFromStore();
    if(formjson.containerControl === 'wizard_h' || formjson.containerControl === 'wizard_v' || formjson.containerControl === 'sidenavigation')
      return getSubStepIndex();
    else {
      functions.showMess(["getCurrentSubStepIndex","Not_Valid"],"error");
    }
  },

  setFocus: function (controlId, json, isCalledInDesigner = false) {
    var formjson1 =functions.getFormJsonFromStore(); 
    var formjson = json || formjson1;
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    const { openCanvasForPreviewAdvance, currentAdvanceListviewStateJson, openCanvasForPreview, subFormListviewJson } = getGridStates();
    const {openSubformCheck } = getOpensubformCheck()
    if(eleJSON){
      if(validControls.setFocus.includes(eleJSON?.elem_type) || isCalledInDesigner) {        
        var elemType = eleJSON?.elem_type;
        var parents = getParentIds(formjson, controlId);
        var parentList = parents?.array?.reverse();
        for(let i=0; i<parentList.length; i++) {
          if(parentList[i].includes("frame")) {
            // let elem1 = document.getElementById(parentList[i] + "_collapseToggle");
            if(functions.getSectionState(parentList[i]) === "collapsed" && !isCalledInDesigner) {
              let frameJSON = recursiveJsonReader1(formjson,parentList[i]);
              functions.setStyle(parentList[i],"sectionstate","expanded");
              frameJSON.style.controlFocus = eleJSON?.dataclass || eleJSON?.style?.CustomId || controlId;
              frameJSON.style.controlElemType = elemType;
              functions.render = true;
              functions.updateJSON();
            }
          } else if(parentList[i].includes("tab")) {
            let tabId = parentList[i];
            let tabJson = recursiveJsonReader1(formjson,parentList[i]);
            const tabActiveIndex = getTabActiveIndex();
            const currentTabActiveIndex = tabActiveIndex[tabId];
            let sheetIndex = tabJson?.children?.findIndex(function(child){return child.id.toLowerCase()=== parentList[i+1] })
            let sheetName = tabJson?.children?.[eleJSON.sheetIndex || sheetIndex]?.tabChildName;
            if(currentTabActiveIndex.toString() !== sheetIndex.toString()) {
              functions.selectSheetByName(tabId, sheetName, [() => {document.getElementById(eleJSON?.dataclass || eleJSON?.style?.CustomId || controlId)?.focus();}]);
              functions.render = true;
              functions.updateJSON();
            }
          }

          if((formjson.containerControl === "wizard_h" ||
            formjson.containerControl === "wizard_v" ||
            formjson.containerControl === 'sidenavigation') &&
            ((!eleJSON.isSubForm && !eleJSON.isAdvanceListview) || (!openCanvasForPreview && !openCanvasForPreviewAdvance && !openSubformCheck))){
            let stepIndex = parseInt(eleJSON.stepIndex);
            let subStepIndex = parseInt(eleJSON.subStepIndex);
            let wizardJSON, wizardJSON2 = recursiveJsonReader1(formjson, "wizard","control");
            if(window.changeNavigtionJSON)
              wizardJSON = {"children" : window.changeNavigtionJSON};              
            else wizardJSON = recursiveJsonReader1(formjson, "wizard", "control");
            const activeStepIndex = getStepIndex();
            const activeSubStepIndex = getSubStepIndex();
            let activeStepId;
            if(window.changeNavigtionJSON)
              activeStepId = window.changeNavigtionJSON?.[activeStepIndex]?.id;
            else activeStepId = wizardJSON?.[activeStepIndex]?.id;
            let activeSubStepId = '';
            if(parseInt(activeSubStepIndex) >= 0){
              if(window.changeNavigtionJSON)
                activeSubStepId = window.changeNavigtionJSON?.[activeStepIndex]?.children?.[activeSubStepIndex]?.id;
              else activeSubStepId = wizardJSON?.[activeStepIndex]?.children?.[activeSubStepIndex]?.id;
            }
            let wizardElemId, wizardSubElemId, stepIndex1, subStepIndex1;
            for(let i = 0; i < wizardJSON.children?.length; i++) {
              if(parseInt(wizardJSON.children[i].StepIndex) === stepIndex) {
                wizardElemId = wizardJSON.children[i]?.id;
                stepIndex1 = i;
                if(subStepIndex >= 0) {
                  for(let j = 0 ; j < wizardJSON.children[i]?.children?.length ; j++) {
                    if(parseInt(wizardJSON.children[i]?.children[j].SubStepIndex) === subStepIndex) {
                          wizardSubElemId = wizardJSON.children[i]?.children?.[j]?.id;
                          subStepIndex1 = j;
                        }
                      }  
                    }
                }
              }
            if(wizardJSON2 && (wizardSubElemId !== activeSubStepId || wizardElemId !== activeStepId)) {
              if(subStepIndex >= 0) {
                // window.setIndex(wizardElemId,stepIndex1+"",true,wizardSubElemId,subStepIndex1+"",true);
                wizardJSON2.setIndex = {
                  stepId: wizardElemId,
                  stepIndex: stepIndex1 + "",
                  check: true,
                  subStepId: wizardSubElemId,
                  subStepIndex: subStepIndex1+ ""
                }
              }
              else {
                // window.setIndex(wizardElemId,stepIndex1+"", undefined, undefined, undefined, true);
                wizardJSON2.setIndex = {
                  stepId: wizardElemId,
                  stepIndex: stepIndex1 + "",
                  check:false,
                  subStepIndex: ""
                }
              }
              updateRenderState("wizard");
              // functions.renderElementsArray.push("wizard")
            }
          } else if(formjson.containerControl === "Menu") {
            const stepIndex = parseInt(eleJSON.stepIndex);
            const subStepIndex = parseInt(eleJSON.subStepIndex);
            const subChildMenuIndex = parseInt(eleJSON.subChildMenuIndex);
            const menuJson = recursiveJsonReader1(formjson, "wizard", "control");

            if(menuJson) {
              let menuElemId = menuJson.children?.[stepIndex]?.id;
  
              if(subStepIndex >= 0) {
                menuElemId = menuJson.children?.[stepIndex]?.children?.[subStepIndex]?.id;
              }
              if(subChildMenuIndex >= 0) {
                menuElemId = menuJson.children?.[stepIndex]?.children?.[subStepIndex]?.children?.[subChildMenuIndex]?.id;
              }
              if(menuElemId) {
                window.openMenuItem(menuElemId);
              }
            }
          }
          if(eleJSON?.controlName==="richtexteditor"){
            const handleEditor2=gethandleEditor2FromRedux();
            handleEditor2();
          }
          if(elemType === 'doclist') {
            document.getElementById(`${controlId}_parent`).focus();
            document.getElementById(`${controlId}_parent`).scrollIntoView({ block: 'nearest'});
          }
          if(elemType === 'toggle') {
            document.getElementById(`${eleJSON?.id}span`)?.focus();
          }
          else if(elemType === 'table' || elemType === 'listview' || elemType === 'advancelistView' || elemType === 'advancelistview') {
            document.getElementById(eleJSON.id)?.focus();
            document.getElementById(eleJSON.id)?.scrollIntoViewIfNeeded();
          }
          else if(elemType === 'datepick' && eleJSON?.style?.PickerType == "2") {
            eleJSON.style.isFocused = true;
            if(!notContainParent(eleJSON) && eleJSON?.id){
              functions.renderElementsArray.add(eleJSON.id);
              functions.render = true
            }
          }
          else
            document.getElementById(eleJSON?.dataclass || eleJSON?.style?.CustomId || controlId)?.focus();
          if(elemType !== 'toggle' && elemType !== 'checkbox' && elemType !== 'radio' && elemType !== 'slider' && elemType !== 'CustomControl' && !(elemType === 'listbox' && eleJSON?.style?.ComboType==="checkBox"))
            document.getElementById(eleJSON?.dataclass || eleJSON?.style?.CustomId ||  controlId)?.click();
          document.getElementById(eleJSON?.dataclass || eleJSON?.style?.CustomId ||  controlId)?.scrollIntoView({ block: 'nearest'});

        }
      }
      else {
        functions.showMess(["setFocus","Not_Valid",controlId],"error");
      }  
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
},

  setSliderCustomDefaultUnit: function(controlId, symbol){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON){
      eleJSON.style.DefaultUnit = "CustomDefaultUnit";
      eleJSON.style.CustomSliderSymbol = symbol;
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  addZone: function(zoneName, top, left, width, height, controlId) {
   return addZone(zoneName,top, left, width, height, controlId);
  },

  setReport: function(controlId,url) {
    let formjson = functions.getFormJsonFromStore();
    let eleJSON = recursiveJsonReader1(formjson, controlId, 'control');
    if(eleJSON) {
      if(validControls.setReport.includes(eleJSON?.elem_type)) {
        if(eleJSON.style) {
          eleJSON.style.SourceURL = url;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
      }
      else {
        functions.showMess(["setReport","Not_Valid",controlId],"error");
      }  
    } 
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  showGridAddDeleteButtons: function (controlId, showHideAddDelete, flag){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if(eleJSON){
      if(validControls.showGridAddDeleteButtons.includes(eleJSON?.elem_type)) {
        if(showHideAddDelete != null && showHideAddDelete != undefined){
          if(showHideAddDelete == 1){
            eleJSON.style.HideAdd = true;
            eleJSON.style.HideDelete = false;
          } else if(showHideAddDelete == 2){
            eleJSON.style.HideAdd = false;
            eleJSON.style.HideDelete = true;
          } else if(showHideAddDelete == 3){
            eleJSON.style.HideAdd = false;
            eleJSON.style.HideDelete = false;
          } else if(showHideAddDelete == -1){
            eleJSON.style.HideAdd = true;
            eleJSON.style.HideDelete = true;
          } else if(showHideAddDelete == 4) {
            eleJSON.style.AllowUpload = flag === "true" || flag === true;
          } else if(showHideAddDelete == 5) {
            eleJSON.style.AllowDownload = flag === "true" || flag === true;
          }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
      }
      else {
        functions.showMess(["showGridAddDeleteButtons","Not_Valid",controlId],"error");
      }  
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  },
  disableGridModalButtons: function (controlId, buttonType, disableFlag){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if(eleJSON){
      if(validControls.disableGridModalButtons.includes(eleJSON?.elem_type)) {
        if(buttonType){
          const flag = disableFlag === undefined ? undefined : (disableFlag === true || disableFlag === "true");
          if(buttonType == 1){
            eleJSON.style.DisableSaveAndContinue = flag;
          } else if(buttonType == 2){
            eleJSON.style.DisableSaveChanges = flag;
          } else if(buttonType == 3){
            eleJSON.style.DisableSaveNClose = flag;
          } else if(buttonType == 4){
            eleJSON.style.DisableDuplicateRow = flag;
          } else if(buttonType == 5){
            eleJSON.style.DisableNextRow = flag;
          } else if(buttonType == 6){
            eleJSON.style.DisablePreviousRow = flag;
          } else if(buttonType == 7){
            eleJSON.style.DisableClose = flag;
          }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
      }
      else {
        functions.showMess(["disableGridModalButtons","Not_Valid",controlId],"error");
      }  
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  },

  showGridCheckBoxes: function (controlId, showHideAddDelete){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if(eleJSON){
      if(validControls.showGridCheckBoxes.includes(eleJSON?.elem_type)) {
        if(showHideAddDelete != null && showHideAddDelete != undefined){
          if(showHideAddDelete === true || showHideAddDelete === "true")
          eleJSON.style.ShowCheckbox = "true";
        else if(showHideAddDelete === false || showHideAddDelete === "false")
          eleJSON.style.ShowCheckbox = "false";
          functions.render = true;
        }
      }
      else {
        functions.showMess(["showGridCheckBoxes","Not_Valid",controlId],"error");
      }  
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  },
  showGridMoreOptionsInHeader: function (controlId, showHideMoreOptions){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if(eleJSON){
      if(validControls.showGridMoreOptionsInHeader.includes(eleJSON?.elem_type)) {
        if(showHideMoreOptions != null && showHideMoreOptions != undefined){
          if(showHideMoreOptions == true || showHideMoreOptions == "true"){
            eleJSON.style.HideMoreOptions = false;
          }
          else{
            eleJSON.style.HideMoreOptions = true;
          } 
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
      }
      else {
        functions.showMess(["showGridAddDeleteButtons","Not_Valid",controlId],"error");
      }  
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  },

  setMaskingPattern: function(controlId, pattern){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if(eleJSON){
      if(validControls.setMaskingPattern.includes(eleJSON?.elem_type)) {
        if(eleJSON?.elem_type === "textbox"){
          if(pattern === "Mobile"){
            eleJSON.style.MaskingValue = "(00) 0000000000";
          } else if(pattern === "Percentage"){
            eleJSON.style.MaskingValue = "percentage";
          } else if(pattern === "Pincode"){
            eleJSON.style.MaskingValue = "000-000";
          } else if(pattern === "Email"){
            eleJSON.style.MaskingValue = "email";
          } else if(pattern === "Password"){
            eleJSON.style.MaskingValue = "password";
          } else if(pattern === "Dollar"){
            eleJSON.style.MaskingValue = "currency_dollar";
          } else if(pattern === "Rupees"){
            eleJSON.style.MaskingValue = "currency_rupees";
          } else if(pattern === "Yen"){
            eleJSON.style.MaskingValue = "currency_yen";
          } else if(pattern === "Euro"){
            eleJSON.style.MaskingValue = "currency_euro";
          } else if(pattern === "USFormat"){
            eleJSON.style.MaskingValue = "dgroup3";
          } else if(pattern === "French"){
            eleJSON.style.MaskingValue = "currency_french";
          } else if(pattern === "Naira"){
            eleJSON.style.MaskingValue = "currency_naira";
          } else if(pattern === "Bahamas"){
            eleJSON.style.MaskingValue = "currency_bahamas";
          } else if(pattern === "IndianFormat"){
            eleJSON.style.MaskingValue = "dgroup2";
          } else if(pattern === "NoZeroPadding"){
            eleJSON.style.MaskingValue = "NZP";
          } else if(pattern === "" || pattern === "Clear"){
            eleJSON.style.MaskingValue = "nomasking";
          }
          functions.render = true;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          eleJSON.style.updateFormState = Date.now();
        }
      }
      else {
        functions.showMess(["setMaskingPattern","Not_Valid",controlId],"error");
      } 
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  },

  setStatusTag : function(controlId,StatusMsg,Status)
  {
    setStatusTagImpl(controlId,StatusMsg,Status);
  },

  setCustomPattern: function (controlId, pattern,alreadyUpdated = false){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if(eleJSON){
      if(validControls.setCustomPattern.includes(eleJSON?.elem_type)) {
        if(eleJSON && eleJSON?.elem_type === "textbox"){
          eleJSON.style.CustomPattern = pattern;
          functions.render = true;

          eleJSON.calledFromAPI = true;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          eleJSON.style.updateFormState = Date.now();
        }
      }
      else {
        functions.showMess(["setCustomPattern","Not_Valid",controlId],"error");
      } 
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
    
  },

  closeApplication: function() {
    window.close();
  },

  setCustomMasking: function (controlId = "", dgroup, adec, asep, asign, psign, decimal){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if(eleJSON){
      if(validControls.setCustomMasking.includes(eleJSON?.elem_type)) {
        if(eleJSON && eleJSON?.elem_type === "textbox"){
          eleJSON.style.MaskingValue = "CustomMasking"
          eleJSON.style.CustomMasking = {};
          eleJSON.style.CustomMasking["dgroup"] = dgroup || "3";
          eleJSON.style.CustomMasking["adec"] = adec;
          eleJSON.style.CustomMasking["asep"] = asep;
          eleJSON.style.CustomMasking["asign"] = psign?.toLowerCase() === "p" ? asign + " " : " " + asign;
          eleJSON.style.CustomMasking["psign"] = psign || "p";
          eleJSON.style.CustomMasking["decimal"] = decimal || "2";
          functions.render = true;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          eleJSON.style.updateFormState = Date.now();
        }
      }
      else {
        functions.showMess(["setCustomMasking","Not_Valid",controlId],"error");
      } 
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  } 
  },
  setCustomMaskingInGrid: function (controlId = "", columnName, dgroup, adec, asep, asign, psign, decimal, gridName, tableId){
    var formjson = functions.getFormJsonFromStore();
    let joinName = controlId;
    var eleJSON = {}
    if(gridName?.toLowerCase() === "listview"){
      joinName = controlId + "_" + columnName;
      eleJSON = recursiveJsonReader1(formjson, joinName, "control");
    }
    else if(gridName?.toLowerCase() === "table"){
      joinName = tableId
      eleJSON = recursiveJsonReader1(formjson, joinName, "control");
      if(eleJSON && eleJSON?.columnList?.length > 0){
        for(let column of eleJSON?.columnList){
          if(column?.style?.ColumnName === columnName){
            console.log("heu")
            column.style.ColumnMasking = asign
            column.style.CustomMasking = {};
            column.style.CustomMasking["dgroup"] = dgroup || "3";
            column.style.CustomMasking["adec"] = adec;
            column.style.CustomMasking["asep"] = asep;
            column.style.CustomMasking["asign"] = psign?.toLowerCase() === "p" ? asign + " " : " " + asign;
            column.style.CustomMasking["psign"] = psign || "p";
            column.style.CustomMasking["decimal"] = decimal || "2";
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
              if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
            functions.render = true;
          }
        }
        return
      }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
      return
    } 
    }
    else if(gridName?.toLowerCase() === "advancelistview"){
      eleJSON = recursiveJsonReader1(formjson, joinName, "control");
    }
    if(eleJSON && (gridName?.toLowerCase() === "listview" || gridName?.toLowerCase() === "advancelistview")){
      if(validControls.setCustomMasking.includes(eleJSON?.elem_type)) {
        if(eleJSON && eleJSON?.elem_type === "textbox"){
          eleJSON.style.MaskingValue = "CustomMasking"
          eleJSON.style.CustomMasking = {};
          eleJSON.style.CustomMasking["dgroup"] = dgroup || "3";
          eleJSON.style.CustomMasking["adec"] = adec;
          eleJSON.style.CustomMasking["asep"] = asep;
          eleJSON.style.CustomMasking["asign"] = psign?.toLowerCase() === "p" ? asign + " " : " " + asign;
          eleJSON.style.CustomMasking["psign"] = psign || "p";
          eleJSON.style.CustomMasking["decimal"] = decimal || "2";
          functions.render = true;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          eleJSON.style.updateFormState = Date.now();
        }
      }
      else {
        functions.showMess(["setCustomMasking","Not_Valid",controlId],"error");
        return
      }
      eleJSON =  recursiveJsonReader1(formjson, tableId, "control");
      if(eleJSON && eleJSON?.columnList?.length > 0){
        for(let column of eleJSON?.columnList){
          if(column?.style?.ColumnName === columnName){
            console.log("heu1")
            column.style.ColumnMasking = asign
            column.style.CustomMasking = {};
            column.style.CustomMasking["dgroup"] = dgroup || "3";
            column.style.CustomMasking["adec"] = adec;
            column.style.CustomMasking["asep"] = asep;
            column.style.CustomMasking["asign"] = psign?.toLowerCase() === "p" ? asign + " " : " " + asign;
            column.style.CustomMasking["psign"] = psign || "p";
            column.style.CustomMasking["decimal"] = decimal || "2";
          }
        }
      }

  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  } 
  },

  apiErrors: {},

  updateJSON: function (callingFromFormLoad = false) {
    const render = functions.render;
    functions.render = false;
    if(this.renderParentFrame) {
      window.opener.functions.updateJSON(callingFromFormLoad);
    } 
    else functions.updateJSON2(callingFromFormLoad, render);
      //Check for any api errors, if the exist convert to required format and send to api
    if(Object.keys(functions.apiErrors).length > 0) {
      const uniqueId = uuid();
      let errorMsg = ""
      Object.keys(functions.apiErrors).forEach((api) => {
        if(functions.apiErrors[api] && functions.apiErrors[api].length > 0) {
          functions.apiErrors[api].forEach((message, index) => {
            errorMsg = errorMsg + `\n ${api} ${index + 1}: `+ message
          })
        }
      })
      generalError_fn("Reference: "+ uniqueId + "\n\t" + errorMsg, 
        `There is an issue in the supplied parameters. Please check logs with reference ${uniqueId} for more details`, "error", null);
      
      functions.apiErrors = {}
    }
    window.loading(false)
  },
  updateJSON2: function(callingFromFormLoad = false, render = false) {
    let {updatedComponentInFormState} = updatedComponentInFormStates();
    window.loading(false);
    if(render){
      //console.log("aa giya5", functions.render, updatedComponentInFormState)
      if(window.childComp2 === "subForm"){
        // if(window.updatedComponentInFormState2){
        //   window.updatedComponentInFormState2(undefined,undefined,undefined,undefined,true)
        // }
        // if(!functions.fromExecuteServerEvent || functions.fromRefreshFrame){
        //   if(window.updatedComponentInFormState2)
        //     window.updatedComponentInFormState2(undefined,undefined,undefined,undefined,true)
        //   if(functions.fromRefreshFrame){
        //     functions.fromRefreshFrame = false;
        //   }
        //   if(functions.fromExecuteServerEvent){
        //     functions.fromExecuteServerEvent = false;
        //     if(functions.renderElementsArray?.length > 0){
        //       let renderingArray = functions.renderElementsArray
        //       for(let j = 0; j <= renderingArray?.length; j++){
        //         console.log("inside renderExecuteServerEvent renderingarray refreshFrame", renderingArray, j)
        //         updateRenderState(renderingArray[j])
        //       }
        //     }
        //     functions.renderElementsArray = [];
        //   }
        // }
        // else{
          let b = [...functions.renderElementsArray]
          if(b?.length > 0){
            let renderingArray = b
            for(let j = 0; j < renderingArray?.length; j++){
              console.log("inside renderExecuteServerEvent renderingarray", renderingArray, j)
              updateRenderState(renderingArray[j],callingFromFormLoad)
            }
          }
          // functions.fromExecuteServerEvent = false;
          if (window?.opener?.functions && b?.length) {
            window.opener.functions.render = true;
            const parentSet = window.opener.functions?.renderElementsArray || new Set();
            functions.renderElementsArray.forEach(id => parentSet.add(id));
            window.opener.functions.renderElementsArray = parentSet;

            if (window.opener && !window.opener.closed && window.opener.functions?.updateJSON) {
              window.opener.functions.updateJSON(callingFromFormLoad);
            }
          }
          functions.renderElementsArray = new Set();
          if(window.updatePartialJSON){
            let openCanvasForPreviewAdvance = getOpenCanvasForPreviewAdvance();
            let openCanvasForPreview = getOpenCanvasForPreview();
            if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" || openCanvasForPreview === "showDataAdditonSection")
              window.updatePartialJSON(undefined, undefined, false)
            else{
              window.updatePartialJSON()
            }
          }
        // }
      }
      else{
        // updatedComponentInFormState(undefined,undefined,undefined,undefined,true);
        // if(!functions.fromExecuteServerEvent || functions.fromRefreshFrame){
        //   updatedComponentInFormState(undefined,undefined,undefined,undefined,true);
        //   if(functions.fromRefreshFrame){
        //     functions.fromRefreshFrame = false;
        //   }
        //   if(functions.fromExecuteServerEvent){
        //     functions.fromExecuteServerEvent = false;
        //     if(functions.renderElementsArray?.length > 0){
        //       let renderingArray = functions.renderElementsArray
        //       for(let j = 0; j <= renderingArray?.length; j++){
        //         console.log("inside renderExecuteServerEvent renderingarray refreshFrame", renderingArray, j)
        //         updateRenderState(renderingArray[j])
        //       }
        //     }
        //     functions.renderElementsArray = [];
        //   }
        // }
        // else{
          let b = [...functions.renderElementsArray]
          if(b?.length > 0){
          let renderingArray = b;
          for(let j = 0; j < renderingArray?.length; j++){
            console.log("inside renderExecuteServerEvent renderingarray", renderingArray, j)
            updateRenderState(renderingArray[j],callingFromFormLoad)
          }
        }
        // functions.fromExecuteServerEvent = false;
        functions.renderElementsArray = new Set();
        let openCanvasForPreviewAdvance = getOpenCanvasForPreviewAdvance();
        let openCanvasForPreview = getOpenCanvasForPreview();
        if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" || openCanvasForPreview === "showDataAdditonSection")
          updatePartialJSON(undefined, undefined, false)
        else{
          updatePartialJSON()
        }
      // }
      }
      functions.render = false;
    }
  },
  showMess: function (message, alertType) {
    let showAlert = true;
    if(window?.psh_configs?.hideControlNotPresentAlert && message?.[0].includes("The_Control") && message?.[2].includes("Not_Present")){
      console.log(`${message?.join(" ") || ""}`)
    } else {
      if(window.suppressErrorMessage)
        showAlert = window.suppressErrorMessage();
      if(showAlert || window.psh_configs?.developer_mode === "development") {
        const elem = document.getElementById("canvasId")
        var div = document.createElement("div");
        const alertElem =
        <Provider store={formStateStore}>
        <ErrorBoundary >
        <I18nextProvider i18n={i18n}>
        <Translation message={message} alertType={alertType} />
        </I18nextProvider>
        </ErrorBoundary>
        </Provider>
        const root = ReactDOM.createRoot(div);
        root.render(alertElem); 
        // store root reference on the div
        div._reactRoot = root;

        // append to the canvas
        elem.appendChild(div);

        // ⏳ Auto-remove THIS div only after 4s
        setTimeout(() => {
          if (div._reactRoot) {
            div._reactRoot.unmount();
            delete div._reactRoot;
          }
          if (div.parentNode) {
            div.parentNode.removeChild(div); // removes only this message
          }
        }, 4000);
      }
  }
  },

  showSplitMessage: function (messageTitle, message, alertType, isClose = true, showIcon = true,
    buttons=[], placement={},duration, styleObj = {
    confirmTitle: {},
    confirmBody: {},
    button1Style : {},
    button2Style : {},
    confirmFooter: {},
    additionalButtons: {},
    alert : {}
  }) {
    if(functions.showAlertMessage)
    {
    if(!validateParams(apiValidationObjects.showSplitMessage, {messageTitle, message, alertType, isClose, showIcon, buttons, placement,duration, styleObj}, "showSplitMessage")) return;

    let elem = document.getElementById("canvasId");
    const uniqueID = new Date().getTime();
    const { openCanvasForPreviewAdvance, currentAdvanceListviewStateJson, subFormListviewJson,openCanvasForPreview } = getGridStates()
    const { subFormStateJson } = getReduxContexts();
   const openSubformCheck = getOpensubformCheck()
    if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview") {
      const externalIformUrl = document?.URL || document?.baseURI || document?.documentURI;
      if (currentAdvanceListviewStateJson?.style?.GridModalType !== "belowSection" && currentAdvanceListviewStateJson?.data?.style?.GridModalType !== "aboveSection" && !externalIformUrl?.includes("afb_subform")) {
        elem = document.getElementById(`${currentAdvanceListviewStateJson.id}_advListviewPopup`)
      } 
      if ( openCanvasForPreview === "showDataAdditonSection" ){
        if (subFormListviewJson?.style["additionmethods"] !== "Section above Listview" && subFormListviewJson?.style["additionmethods"] !== "Section below Listview") {
          elem = document.getElementById(`${subFormListviewJson.id}_listviewPopup`)
        } 
      }
    }
    else if ( openCanvasForPreview === "showDataAdditonSection" ){
      if (subFormListviewJson?.style["additionmethods"] !== "Section above Listview" && subFormListviewJson?.style["additionmethods"] !== "Section below Listview") {
        elem = document.getElementById(`${subFormListviewJson.id}_listviewPopup`)
      } 
    }
      else if
      (openSubformCheck === "subform")
      if (subFormStateJson?.id) {
      elem = document.querySelector(`[id='${subFormStateJson?.id}']`);
       } else {
      console.error("subFormStateJson is missing or has no id:", subFormStateJson);
       }
      var div = document.createElement("div");
      div.setAttribute("id", `custom-alert-${uniqueID}`); 
      elem?.appendChild(div);

     if(placement?.vertical === "center" && placement?.horizontal === "center"){
      div.style.top = '50%';
      div.style.left = '50%';
      div.style.transform = "translate(-50%, -50%)";
      div.style.position ="absolute";
      div.style.zIndex = '999999999'
     }
     if(placement?.vertical === "top" && placement?.horizontal === "center"){
      // div.style.top = '8px';
       div.style.zIndex = '999999999';
      //  div.style.left = '50%';
      // //  div.style.transform = "translate(-50%, -50%)";
      // div.style.position ="absolute";
     }
     if(placement?.vertical === "bottom" && placement?.horizontal === "center"){
      // div.style.left = '50%';
      // div.style.bottom ="0px";
      // div.style.transform = "translate(-50%, -50%)";
      // div.style.position ="absolute";
       div.style.zIndex = '999999999'
     }
     if(placement?.vertical === "center" && placement?.horizontal === "right"){
      div.style.top = '50%';
      div.style.right = '15%';
      div.style.transform = "translate(-50%, -50%)";
      div.style.position ="absolute";
      div.style.zIndex = '999999999'
     }
     if(placement?.vertical === "center" && placement?.horizontal === "left"){
      div.style.top = '50%';
      div.style.left = '14%';
      div.style.transform = "translate(-50%, -50%)";
      div.style.position ="absolute";
      div.style.zIndex = '999999999'
     }
    const dynamicStyles = (() => {
      const { vertical, horizontal } = placement || {};
      let styles = {
        position: "absolute", 
        zIndex: 9999999, 
        background: "transparent", 
        width: "auto",  
        height: "auto",  
        maxWidth: "90vw", 
        maxHeight: "90vh", 
        overflow: "hidden", 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        boxSizing: "border-box", 
      };

      // if (vertical === "top") {
      //   styles.top = "45%";
      //   styles.alignItems = "flex-start"; 
      // } else if (vertical === "bottom") {
      //   styles.bottom = "10px";
      //   styles.alignItems = "flex-end"; 
      // } else if (vertical === "center") {
      // }
    
      // if (horizontal === "left") {
      //   styles.left = "10px";
      //   styles.justifyContent = "flex-start"; 
      // } else if (horizontal === "right") {
      //   styles.right = "10px";
      //   styles.justifyContent = "flex-end"; 
      // } else if (horizontal === "center") {
      // }
      return styles;
    })();

    let primaryButtons = buttons.filter((element) => element.active === "true" || element.active === true);
    let additionalButtons = buttons.filter((element) => element.active === "false" || element.active === false);
    let alertData = {};
    const isPlacementPassed = Object.keys(placement).length;

    if(isPlacementPassed) {
      if(!placement.vertical && placement.horizontal) {
        functions.showMess(["Vertical placement is mandatory"],"error");
        return;
      }
      if(!placement.horizontal && placement.vertical) {
        functions.showMess(["Horizontal placement is mandatory"],"error");
        return;
      }
    }

    const root = ReactDOM.createRoot(div);

    const removeAlertNode = () => {
      const alertNode = document.getElementById(`custom-alert-${uniqueID}`);
      if (alertNode) {
        console.log("Removing alert...");
        root.unmount() 
        alertNode.remove(); 
      } else {
        console.error("Alert container not found");
      }
    }
  
    if(alertType?.toLowerCase() === "confirm") {
      alertData = {
        'open': true,
        'showIcon': showIcon,
        'showConfirm':'showconformationDialogBox',
        'alertContentMsg': message,
        'alertTitleMsg':messageTitle,
        "Button1" : primaryButtons?.[0],
        "Button2" : primaryButtons?.[1],
        "additionalButtons": additionalButtons,
        "isClose" : isClose,
        "placement" : {
          ...(isPlacementPassed ? placement :
            { vertical: "center", horizontal: "center" }),
            keyAdded: true
        },
        styleObj,
        uniqueID
      };
    }
    else if(alertType?.toLowerCase() === "success") {
      alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType':'success',
        'alertContentMsg': message,
        'autoHideDuration': duration,
        'showIcon': showIcon,
        'alertTitleMsg':messageTitle, 
        "isClose" : isClose,
        "placement" : {
          ...(isPlacementPassed ? placement :
            { vertical: "bottom", horizontal: "left" }),
            keyAdded: true
        },
        styleObj,
        ...(duration === null ? {onClose: removeAlertNode} : {}),
        uniqueID
      };
    }
     else if(alertType?.toLowerCase() === "error") {
      alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType':'error',
        'alertContentMsg': message,
        'showIcon': showIcon,
        'autoHideDuration': duration,
        'alertTitleMsg':messageTitle, 
        "isClose" : isClose,
        "placement" : {
          ...(isPlacementPassed ? placement :
            { vertical: "top", horizontal: "center" }),
            keyAdded: true
        },
        styleObj,
        ...(duration === null ? {onClose: removeAlertNode} : {}),
        uniqueID
      };
    } else if(alertType?.toLowerCase() === "info") {
      alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType':'info',
        'autoHideDuration': duration,
        'alertContentMsg': message,
        'showIcon': showIcon,
        'alertTitleMsg':messageTitle, 
        "isClose" : isClose,
        "placement" : {
          ...(isPlacementPassed ? placement :
            { vertical: "center", horizontal: "center" }),
            keyAdded: true
        },
        styleObj,
        ...(duration === null ? {onClose: removeAlertNode} : {}),
        uniqueID
      };
    }
    else {
      alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType':'warning',
        'showIcon': showIcon,
        'autoHideDuration': duration,
        'alertContentMsg': message,
        'alertTitleMsg':messageTitle, 
        "isClose" : isClose,
        "placement" : {
          ...(isPlacementPassed ? placement :
            { vertical: "center", horizontal: "center" }),
            keyAdded: true
        },
        styleObj,
        ...(duration === null ? {onClose: removeAlertNode} : {}),
        uniqueID
      };
    }
    const alertElem =
      <Provider store={formStateStore}>
        <ErrorBoundary >
          <I18nextProvider i18n={i18n}>
            <CustomizedAlert alertData={alertData} isCalledFromAPI/>
          </I18nextProvider>
        </ErrorBoundary>
      </Provider>

    root.render(alertElem);
    // elem.appendChild(div);
    if((alertType?.toLowerCase() !== "confirm")) {
      if(duration !== null) {
        setTimeout(() => {
          removeAlertNode()
        }, duration || 5000); 
      }
    }
  }
},
  
  
  showMessage: function (controlId, message, alertType) {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    
    const elem = document.getElementById("canvasId")
    var div = document.createElement("div");
    let alertData;
    if(alertType === "confirm") {
      alertData = {
        'open': true,
        'showConfirm':'showconformationDialogBox',
        'alertContentMsg': message,
        'alertTitleMsg':'ShowMessageConfirm', 
        "Button1Key" : 'Cancel',
        "Button2Key" : 'Yes, Exit',
        "icon1" : true,
        "Id" : controlId,
      };
    } else if(alertType === "error") {
      alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType':'error',
        'alertContentMsg': message,
      };
    }else if(alertType === "success"){
      alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType':'success',
        'alertContentMsg': message,
      };
    }
    else if(alertType === "info"){
      alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType':'info',
        'alertContentMsg': message,
      };
    }   
    const alertElem =
    <Provider store={formStateStore}>
    <ErrorBoundary >
     <I18nextProvider i18n={i18n}>
    <CustomizedAlert alertData={alertData}/>
    </I18nextProvider>
    </ErrorBoundary>
    </Provider>
    const root = ReactDOM.createRoot(div);
    root.render(alertElem); 
    elem.appendChild(div);
  },

  showMandatoryNotification: function (message) {
    const contexts = getGlobalContext();
    const { showAlertConfirmNotifications } = contexts;

    showAlertConfirmNotifications({
      open: true,
      showConfirm: "showNotification",
      alertType: "info",
      autoHideDuration: 3000,
      alertContentKey: `${message}`,
      bodyStyle: {
          background: "#FAE18E 0% 0% no-repeat padding-box",
          boxSizing: "border-box"           
      },
      contentTextStyle: {
        color: "black",
      },
      icon1Src : {
        src: require("../../../../src/ReusableComponents/Alert/Icons/Warning.svg"),
      },
      icon2Src : {
        src: require("../../../../src/Icons/BlackCross.svg"),
        styleData : {
          filter: "invert(1)",
        }
      }
    });
  },

  showAlertDialog(message, isClose){
    const elem = document.getElementById("canvasId");
    var div = document.createElement("div");
    let alertData = {
      'open': true,
      'showConfirm':'showNotification',
      'alertType':'info',
      'alertContentMsg': message,
      'isClose': isClose,
    };
    const alertElem =
    <Provider store={formStateStore}>
    <ErrorBoundary >
     <I18nextProvider i18n={i18n}>
       <CustomizedAlert alertData={alertData}/>
     </I18nextProvider>
     </ErrorBoundary>
     </Provider>
    const root = ReactDOM.createRoot(div);
    root.render(alertElem);
    elem.appendChild(div);

  },
  
  checkForNonFilledMandatoryFieldsIn: function(controlId, elemType){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = findTheControlFrom(formjson, controlId, elemType);
    if(eleJSON){
    let mandatoryFieldsArray = [];
    
    //returns the json having the collapsed/expanded state of the sections
    let sectionInitiallyCollapsedStateVar = (formStateStore.getState())?.contexts?.sectionInitiallyCollapsedState;
// setSectionInitiallyCollapsedState
  
    let sendCallToBackend=false;

    //if checking for the whole form , then iterate through the children of RootControl for Section only
    if(eleJSON?.id==='RootControl'){
      let sections = eleJSON?.children;
      if(sections && sections.length>0){
        // sections.map(
          outsideSectionLoop:
          for(let index=0;index<sections.length;index++){
            let section = sections[index];
            let sectionCollapsed = checkForSectionCollapse(section?.id, sectionInitiallyCollapsedStateVar);
            if(sectionCollapsed){
              sendCallToBackend = true;
              break outsideSectionLoop;
            }
            // if(index===0){
              if(!sectionCollapsed){
                //directly send the call
                sendCallToBackend= true;
                break outsideSectionLoop;
              } else {
                checkForAllNonFilledMandatoryFields(section,mandatoryFieldsArray);
                if(mandatoryFieldsArray.length>0){
                //shows the error with respective fields
                  let setAllNonFilledMandatoryFields = (formStateStore.getState())?.contexts?.setAllNonFilledMandatoryFields;
                  setAllNonFilledMandatoryFields(mandatoryFieldsArray);
                  //will get the first non filled mandatory control to focus
                  let elementToFocus = mandatoryFieldsArray[0];
                  //will get the json to get the parent of it , to focus that control in case it is in some non rendered part, for ex. inactive sheet
                  let elementToFocusJson = findTheControlFrom(formjson, elementToFocus);
                  //after getting the josn of that control, will focus at it
                  setFocusOnElement(elementToFocusJson , formjson);
                } else {
                  sendCallToBackend= true;
                  break outsideSectionLoop;
                }
              }
          }
          
      }
    } else {

      let sectionCollapsed = checkForSectionCollapse(eleJSON?.id, sectionInitiallyCollapsedStateVar);
      if(sectionCollapsed){
        sendCallToBackend= true;
      } else {

        //checks for mandatory fields in the given json
        checkForAllNonFilledMandatoryFields(eleJSON,mandatoryFieldsArray);
    
        if(mandatoryFieldsArray.length>0){
        //shows the error with respective fields
          let setAllNonFilledMandatoryFields = (formStateStore.getState())?.contexts?.setAllNonFilledMandatoryFields;
          setAllNonFilledMandatoryFields(mandatoryFieldsArray);
          //will get the first non filled mandatory control to focus
          let elementToFocus = mandatoryFieldsArray[0];
          //will get the json to get the parent of it , to focus that control in case it is in some non rendered part, for ex. inactive sheet
          let elementToFocusJson = findTheControlFrom(formjson, elementToFocus);
          //after getting the josn of that control, will focus at it
          setFocusOnElement(elementToFocusJson, formjson);
        } else {
          //send call to backend
          sendCallToBackend= true;
        }
      }
    }
    if(sendCallToBackend){
      //send the request to the backend
    }
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  },

  findFamilyPathFor: function(controlId){
    var formjson = functions.getFormJsonFromStore();
    return getFamilyTreePath(formjson, controlId);
  },

  showConfirmDialog(message, btns, callback, isClose = true, dialogType = "confirm", alertTitleMsg){
    const buttons = [
      { name: btns?.cancel?.label, callback: () => callback?.(false), active: true },
      { name: btns?.confirm?.label, callback: () => callback?.(true), active: true }
    ];
    functions.showSplitMessage(alertTitleMsg || ' ', message, dialogType, isClose, true, buttons);
  },

  setTabStyle1: function (tabId, index, attributeName, attributeValue) {

    
     if (attributeName === 'visible') {
      if (attributeValue === 'true')
      {
        document.querySelectorAll(`#${tabId} > * button`)[index].setAttribute('style', 'display:block !important');
      }
      if (attributeValue === 'false')
      {
        document.querySelectorAll(`#${tabId} > * button`)[index].setAttribute('style', 'display:none !important');
      }
      }


      if (attributeName === 'disable') {
        if (attributeValue === 'true')
        {
          document.querySelectorAll(`#${tabId} > * button`)[index].disabled=true;
        }
        if (attributeValue === 'false')
        {
          document.querySelectorAll(`#${tabId} > * button`)[index].disabled=false;
        }
        }


  },

  getSectionList: function(){
    let sectionList=document.getElementsByClassName("SectionControl");
    let sectionJson={};
    for(let i=0;i<sectionList.length;i++)
    {
      sectionJson[sectionList[i].id]=sectionList[i].getAttribute('sectionView');
    }
    return sectionJson;
  },
  
  changeNavigationList: function(json) {
    var formjson = functions.getFormJsonFromStore();
    const wizardJSON = recursiveJsonReader1(formjson, "wizard", "control");
    wizardJSON.changeNavigation = json;
    // if(!functions.fromExecuteServerEvent){
    //   updateRenderState(wizardJSON?.id);
    // }
    // if(functions.fromExecuteServerEvent){
      if(!notContainParent(wizardJSON) && wizardJSON?.id)
        functions.renderElementsArray.add(wizardJSON?.id)
    // }
    functions.render = true;
  },

  changeSectionCaption: function(frameId,Caption){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, frameId, "control");
    if(eleJSON) {
      if(validControls.changeSectionCaption.includes(eleJSON?.elem_type)) {
        eleJSON.style.Label = Caption;
        functions.render = true;
        eleJSON.calledFromAPI = true;
        eleJSON.style.updateFormState = Date.now();
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      }
      else {
        functions.showMess(["changeSectionCaption","Not_Valid",frameId],"error");
      }
    }
    else {
      functions.showMess(["changeSectionCaption","Not_Valid",frameId],"error");
    }
  },
  setSheetCaption: function(tabId, sheetIndex, caption) {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson,tabId);
    if(eleJSON) {
      if(validControls.setSheetCaption.includes(eleJSON?.elem_type)) {
        const sheetData = eleJSON?.children[sheetIndex];
        if(sheetData.style)
          sheetData.style.Label = caption;
        sheetData.tabChildName = caption;
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
      else {
        functions.showMess(["setSheetCaption","Not_Valid",tabId],"error"); 
      }
    }
    else {
      functions.showMess(["The_Control",tabId,"Not_Present"],"error");
    }
  },

  selectSheet: function(tabId,sheetIndex){
      var formjson = functions.getFormJsonFromStore();
      var eleJSON=recursiveJsonReader1(formjson,tabId,'control');
      if(validControls.selectSheet.includes(eleJSON?.elem_type)) {
        if(eleJSON){
        if(eleJSON.children[sheetIndex]) {
          eleJSON.setSheetIndex = sheetIndex;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
          functions.render = true;
        }
        else  {
          functions.showMess(["The_Sheet",sheetIndex,"Not_Present"],"error");
        }
        }
        else {
            functions.showMess(["The_Control",tabId,"Not_Present"],"error");
        }
      }
      else {
        functions.showMess(["selectSheet","Not_Valid",tabId],"error");
      }
  },

  selectSheetByName: function(tabId,sheetName, callBackQueue){
      var formjson = functions.getFormJsonFromStore();
      var eleJSON=recursiveJsonReader1(formjson,tabId,'control');
      if(validControls.selectSheetByName.includes(eleJSON?.elem_type)) {
        if(eleJSON){
        let newJSON = eleJSON.children.filter(ele => ele.tabChildName === sheetName);
          if(newJSON[0]?.id) {
            eleJSON.setSheetIndex = newJSON[0]?.sheetIndex;
            if(callBackQueue && callBackQueue.length > 0) {
              eleJSON.callBackQueue = callBackQueue;
            }
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            functions.render = true;
          } else {
            functions.showMess([sheetName,"Not_Present"],"error");
          }
        }
        else {
          functions.showMess(["The_Control",tabId,"Not_Present"],"error");
        }
      }
      else {
        functions.showMess(["selectSheetByName","Not_Valid",tabId],"error");
      }
  },

  getSheetIndex:function(tabId){
      var formjson = functions.getFormJsonFromStore();
      var eleJSON=recursiveJsonReader1(formjson,tabId,'control');
      if(validControls.getSheetIndex.includes(eleJSON?.elem_type)) {
          if(eleJSON){
          // let result;
          // eleJSON = eleJSON.children.map((sheet, index) => {
          //   let element = document.getElementById(sheet.id).parentNode.parentNode.classList
          //   if(element[element.length-1].startsWith("makeStyles-selectedMenu")){
          //     result = index
          //   }
          // })
          return eleJSON.currentActiveIndex ? eleJSON.currentActiveIndex : 0;
        }
        else {
          functions.showMess(["The_Control",tabId,"Not_Present"],"error");
        }
      }
      else {
        functions.showMess(["getSheetIndex","Not_Valid",tabId],"error");
      }
  },

  setPickListHeader: function(controlId, Header){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON) {
      if(validControls.setPickListHeader.includes(eleJSON?.elem_type)) {
        if(eleJSON.style) {
          eleJSON.style.PopupTextTouched = Header;
        } else {
          eleJSON.style = {
            PopupTextTouched: Header
          }
        }
        functions.render = true;
        eleJSON.calledFromAPI = true;
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        eleJSON.style.updateFormState = Date.now();
      }
      else {
        functions.showMess(["setPickListHeader","Not_Valid",controlId],"error"); 
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },
  setCaption: function(controlId, Caption) {
    setCaption(controlId, Caption);
},
removeError:function(controlId){
  removeError(controlId);
},
helperTextExistsOrNot:function(controlId){
  return helperTextExistsOrNot(controlId);
},
showMessageBelow:function(controlId,helpertextmessage,color){
  showMessageBelow(controlId,helpertextmessage,color);
},
setinputvalidation: function(Id, attribute, value) {
  setinputvalidation(Id, attribute, value);
},
  setDateRange: function(controlId, minDate, maxDate)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'datepick');
    console.log(eleJSON)
    if(eleJSON){
      if(validControls.setDateRange.includes(eleJSON?.elem_type)) {
        eleJSON.style.MinDate=minDate;
        eleJSON.style.MaxDate=maxDate;
        functions.render = true;
        eleJSON.calledFromAPI = true;
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        eleJSON.style.updateFormState = Date.now();
      }
      else {
        functions.showMess(["setDateRange","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  getZoneList: function(){
    var formjson = functions.getFormJsonFromStore();
    var zoneListarr=formjson?.Zonelist||[];
    var zoneList={};
    for(var i=0; i < zoneListarr.length;i++)
    {
      
        var temp =zoneListarr[i];
        var zoneName=temp.name;
        delete temp.name;
        zoneList[zoneName]=temp;
    }
    return zoneList;
  },

  addItemInCombo:function(comboId,label,value,tooltip,optionControlId){
    addItemInComboImpl(comboId,label,value,tooltip,optionControlId);
  },

  addItemInRadio:function(radioId,label,value,tooltip){
    addItemInRadioImpl(radioId,label,value,tooltip);
  },

  removeItemFromCombo:function(comboId,itemIndex)
  {
    removeItemFromComboImpl(comboId,itemIndex);
  },
  removeItemFromRadio:function(radioId,itemIndex)
  {
    removeItemFromRadioImpl(radioId,itemIndex);
  },
  getItemCountInCombo : function(comboId)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,comboId,'combo');
    if(eleJSON)
      if(validControls.getItemCountInCombo.includes(eleJSON?.elem_type))
        return eleJSON?.options?.length||0;
        else {
          functions.showMess(["getItemCountInCombo","Not_Valid",comboId],"error");
        }
    else {
      functions.showMess(["The_Control",comboId,"Not_Present"],"error");
    }
  },
  getComboOptions:  function(comboId) {

    if(!validateParams(apiValidationObjects.getComboOptions, {comboId}, "getComboOptions")) return;

    var formJson = functions.getFormJsonFromStore();
    var eleJson = recursiveJsonReader1(formJson, comboId, 'combo');
    if(eleJson) {
      if(validControls.getComboOptions.includes(eleJson?.elem_type)) {
        var comboOptions = eleJson?.options || [];
        return comboOptions;
      } else {
        functions.showMess(["getComboOptions", "Not_Valid", comboId], "error");
      }
    } else {
      functions.showMess(["The_Control", comboId, "Not_Present"], "error");
    }
  },
  getItemLabel: function (comboId, index) {

    if(!validateParams(apiValidationObjects.getItemLabel, {comboId,index}, "getItemLabel")) return;

    if (index < 0) {
      functions.showMess(["Invalid Index"], "error");
      return "";
    }
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, comboId, 'combo');
    if (eleJSON)
      if (validControls.getItemLabel.includes(eleJSON?.elem_type))
        return eleJSON?.options?.[index]?.label || undefined;
      else {
        functions.showMess(["getItemLabel", "Not_Valid", comboId], "error");
      }
    else {
      functions.showMess(["The_Control", comboId, "Not_Present"], "error");
    }
  },

  getSelectedItemLabel : function(comboId)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,comboId,'combo');
    if(eleJSON){
      if(validControls.getSelectedItemLabel.includes(eleJSON?.elem_type)) {
        if(eleJSON?.elem_type === "combo"){
          if(eleJSON.value){
            let options = eleJSON?.options.find((option)=> {
              return option.value === eleJSON.value
            }) 
            console.log("gotcha", options)
            return options.label
          }
        }
        else if(eleJSON?.elem_type === "listbox"){
          var valueArr=[];
          if(eleJSON.value)
          {
            var tempList=eleJSON.value;
            for(var i=0;i<tempList.length;i++)
            {
              let options = eleJSON?.options.find((option)=> {
                return option.value === tempList[i]
              }) 
              console.log("gotcha1", options)
              valueArr.push(options.label);
            }
          }
           return valueArr;
        }
      }
      else {
        functions.showMess(["getSelectedItemLabel","Not_Valid",comboId],"error");
      }
  }
  else {
      functions.showMess(["The_Control",comboId,"Not_Present"],"error");
    }
  },

  getSelectedItemValue : function(comboId)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,comboId,'combo');
    if(eleJSON){
      if(validControls.getSelectedItemLabel.includes(eleJSON?.elem_type)) {
        if(eleJSON?.elem_type === "combo"){
          if(eleJSON.value)
            return eleJSON.value;
          else return "";
        }
        else if(eleJSON?.elem_type === "listbox"){
          var valueArr=[];
          if(eleJSON.value)
          {
            var tempList=eleJSON.value;
            for(var i=0;i<tempList.length;i++)
            {
              valueArr.push(tempList[i]);
            }
          }
           return valueArr;
        }
      }
      else {
        functions.showMess(["getSelectedItemLabel","Not_Valid",comboId],"error");
      }
  }
  else {
      functions.showMess(["The_Control",comboId,"Not_Present"],"error");
    }
  },

  clearComboOptions : function(controlId,isClear)
  {
    clearComboOptionsImpl(controlId,isClear);
  },
    clearRadio : function(controlId)
  {
    clearRadioImpl(controlId);
  },

  refreshFrame: function (frameId, syncFlag, callEvents = true)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,frameId,'frame');
    if(eleJSON) {
      if(validControls.refreshFrame.includes(eleJSON?.elem_type)) {
        var jsonToSend={
          "frameId":frameId,
          "stepIndex":eleJSON?.stepIndex,
          "stepSubIndex":eleJSON?.substepIndex || eleJSON?.subStepIndex,
          "subChildMenuIndex":eleJSON?.subChildMenuIndex
        }
        if(syncFlag) {
          const response = refreshFrame(jsonToSend,syncFlag);
            if(response && response.data){
              eleJSON.children = [];
              eleJSON.children.push(...response.data.frameJson.children);
              if(eleJSON.style.EnableUpdatedFromAPI && (eleJSON.style.EnableUpdatedFromAPI === "false" || eleJSON.style.EnableUpdatedFromAPI === false)){
                changeControlProperty("false", "Enable", eleJSON)
              }else if(eleJSON.style.EnableUpdatedFromAPI && (eleJSON.style.EnableUpdatedFromAPI === "true" || eleJSON.style.EnableUpdatedFromAPI === true)){
                changeControlProperty("true", "Enable", eleJSON)
              }
              if(callEvents)
              eleJSON.style.callSectionLoad = true;
              // if(!functions.fromExecuteServerEvent){
              //   updateRenderState(eleJSON?.id);
              // }
              // if(functions.fromExecuteServerEvent){
                if(!notContainParent(eleJSON) && eleJSON?.id)
                  functions.renderElementsArray.add(eleJSON?.id)
              // }
              // functions.fromRefreshFrame = true;
            }
        }
        else {
          refreshFrame(jsonToSend).then((response) => {
            if(response && response.data){
              eleJSON.children = [];
              eleJSON.children.push(...response.data.frameJson.children);
              if(eleJSON.style.EnableUpdatedFromAPI && (eleJSON.style.EnableUpdatedFromAPI === "false" || eleJSON.style.EnableUpdatedFromAPI === false)){
                changeControlProperty("false", "Enable", eleJSON)
              }else if(eleJSON.style.EnableUpdatedFromAPI && (eleJSON.style.EnableUpdatedFromAPI === "true" || eleJSON.style.EnableUpdatedFromAPI === true)){
                changeControlProperty("true", "Enable", eleJSON)
              }
              if(callEvents)
              eleJSON.style.callSectionLoad = true;
              // if(!functions.fromExecuteServerEvent){
              //   updateRenderState(eleJSON?.id);
              // }
              // if(functions.fromExecuteServerEvent){
                if(!notContainParent(eleJSON) && eleJSON?.id)
                  functions.renderElementsArray.add(eleJSON?.id)
              // }
              // functions.fromRefreshFrame = true;
            }
          })
        }
        functions.render = true;
      }
      else {
        functions.showMess(["refreshFrame","Not_Valid",frameId],"error");
      }
    }
    else
    {
      functions.showMess(["The_Control",frameId,"Not_Present"],"error"); 
    }
  },

  getMandatoryFieldList: function(controlId, index)
  {
      var formjson = functions.getFormJsonFromStore();
      var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
      if(eleJSON){
      if(index !== undefined && index !== null && eleJSON?.elem_type === "tab"){
        eleJSON = eleJSON.children[index];
      } 
      let result = []
      checkForAllNonFilledMandatoryFields(eleJSON, result, {}, "section");
      return result;
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  isSectionCompleted: function(frameId){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, frameId, 'control');
    if(eleJSON){
      if(validControls.isSectionCompleted.includes(eleJSON?.elem_type)) {
        const SectionControlError = [];
        const stack = [...(eleJSON.children[0]?.children || [])];
        while (stack.length > 0) {
          const current = stack.pop();
          if (current && typeof current === 'object') {
            if ('id' in current) {
              SectionControlError.push(current.id);
            }
            for (const key in current) {
              const value = current[key];
              if (Array.isArray(value)) {
                stack.push(...value);
              } else if (typeof value === 'object' && value !== null) {
                stack.push(value);
              }
            }
          }
        }
        console.log(stack);
        console.log(SectionControlError)
        const errorState = getErrorState();
        const sectionError = errorState?.some(errId => SectionControlError.includes(errId));
        if (sectionError) {
            return false;
        }
        let mandateArr = [];
        let skipControlValidation = []
        if (window.skipControlValidation) {
          skipControlValidation = window.skipControlValidation("frame", frameId);
        }
        checkForAllNonFilledMandatoryFields(eleJSON.children[0], mandateArr,{},"section",{skipControlValidation});
        return  mandateArr?.length === 0;
      }
      else {
        functions.showMess(["isSectionCompleted","Not_Valid",frameId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",frameId,"Not_Present"],"error");
    }
  },

  validateMandatoryFields: function() {
    if(window.isComponentValidated)
      return window.isComponentValidated();
  },
  
  showMandatoryError: function(controlids) {
    setMandatoryControls1(controlids);
    functions.setFocus(controlids[0]);
  },

  saveWorkItem : function(bshowMsg)
  {
    if (bshowMsg === undefined)
            bshowMsg = true;
         if (window.parent && window.parent.WFSave) {
              window.parent.WFSave(bshowMsg)
          }
  },

  completeWorkItem : function ()
  {
     if( window.parent &&  window.parent.WFDone){
        window.parent.WFDone();
     }
  },
  
  saveRichTextData: async function(controlId,HTMLData){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'richtext');
    if (eleJSON) {
      const mandatoryControls = getMandatoryControls();
      function removeIdFromMandatoryControl(value) {
        if (mandatoryControls.includes(eleJSON.id)) {
          if (value.length > 0) {
            const newMandatoryList = mandatoryControls.filter((item) => item !== eleJSON.id);
            setMandatoryControls1([...newMandatoryList]);
          }
        }
      }

      const jsonToSend = {
        controlId: eleJSON.id,
        richTextEditorJSON: [{ id: eleJSON.id, data: HTMLData, IndexString: "" }],
        gdtoken: getGdToken(),
        witoken: getWIToken()
      };
      const response = saveRTEData(jsonToSend);
      if(response.data?.status === "error") {
        functions.showMess( response.data?.message || "There was some error in saving data","error");
        return;
      }
      eleJSON.value = response.data.message;
      eleJSON.savedRichtextTime = new Date();
      removeIdFromMandatoryControl(eleJSON.value);
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    } else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
      return;
    }
    var richTextEditor= document.getElementById(controlId);
    if(richTextEditor !== null && richTextEditor !== undefined){
      richTextEditor.setAttribute("contentChanged","true");
    }
    
    
  },

  getRichTextData: function(textareaId)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,textareaId,'richtext');
    let RichTextData;
    if(eleJSON){
        textareaId = eleJSON.id;
        let jsonToSend = {
          "controlId": textareaId,
          "richTextEditorJSON": [{ "id": textareaId, "IndexString": "" }],
          "gdtoken": getGdToken(),
          "witoken": getWIToken()
        }
  
        const response = getRichTxtData(jsonToSend);
        if(response?.data?.value?.[0]?.value){
          RichTextData=response?.data?.value?.[0]?.value;
          console.log("getRichTextData",response?.data?.value?.[0]?.value)                
        }
        return RichTextData;    
    }
    else {
      functions.showMess(["The_Control",textareaId,"Not_Present"],"error");
    }
  },

  toggleRichTextEditor : function(textareaId,state)
  {
    if(!validateParams(apiValidationObjects.toggleRichTextEditor, {textareaId,state}, "toggleRichTextEditor")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,textareaId,'richtext');
    if(eleJSON){
      if(validControls.toggleRichTextEditor.includes("richtexteditor")) {
        eleJSON.calledFromAPI = true;
        if(state==="collapsed"){
          eleJSON.showEditor= false
        }
        else if(state==="expanded"){
          eleJSON.showEditor= true
        }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
      else {
        functions.showMess(["toggleRichTextEditor","Not_Valid",textareaId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",textareaId,"Not_Present"],"error");
  }

  },

  setTableCellColor1 : function(tableId,rowIndex,colIndex,color)
  {
        var table = document.getElementById(tableId);
        if(table != null && table !=undefined)
        {
        var row = table.tBodies[0].getElementsByTagName("tr")[rowIndex];
        var col = row.getElementsByTagName("td")[colIndex+1];
        col.style.backgroundColor = "#"+color;
        }
        else {
          functions.showMess(["The_Control",tableId,"Not_Present"],"error");
        }
  },

  getValueFromTable : function(tableId)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON){
      if(validControls.getValueFromTable.includes(eleJSON?.elem_type)) {
        var rowData=eleJSON.rowData;
        if(rowData && rowData.length >=1){
          var XMLString = "";
          XMLString += "<ListItems>\n";
        for(var i=0;i<rowData.length;i++)
        {
          XMLString += "<ListItem>\n";
          for(var j=0;j<Object.keys(rowData[i]).length;j++)
          {
          if(rowData[i][j]){
            XMLString += `<SubItem ColumnName="${rowData[i][j]?.name}">`;
            var cellValue=eleJSON.rowData[i][j]?.value;
            if(cellValue != undefined &&  cellValue!= null)
            cellValue =cellValue.toString().replace(/&/g,"&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;");
            XMLString += cellValue;
             XMLString += "</SubItem>\n";
          }
        }
        XMLString += "</ListItem>\n";
        }
        XMLString += "</ListItems>\n";
        return XMLString;
      }
      }
      else {
        functions.showMess(["getValueFromTable","Not_Valid",tableId],"error");     
      }
}
else {
  functions.showMess(["The_Control",tableId,"Not_Present"],"error");
}
  },

  getValueFromTableCell : function(tableId,rowIndex,colIndex)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON){
      if(validControls.getValueFromTableCell.includes(eleJSON?.elem_type)) {
          const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        var data="";
          if(eleJSON.rowData && eleJSON.rowData[rowIndex] && eleJSON.rowData[rowIndex][updatedColumnIndex])
          data=eleJSON.rowData[rowIndex][updatedColumnIndex].value;
        return data;
      }
      else {
        functions.showMess(["getValueFromTableCell","Not_Valid",tableId],"error");    
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  },

  setColumnVisible : function(tableId,colIndex,visibleFlag,sync)
  {
    setColumnVisible(tableId,colIndex,visibleFlag,sync);
  },

  setColumnDisable : function(tableId,colIndex,disableFlag,sync)
  {
    setColumnDisable(tableId,colIndex,disableFlag,sync);
  },
  setColumnStyle : function(tableId, colIndex, propertyName, propertyValue)
  {
    setColumnStyle(tableId,colIndex,propertyName,propertyValue);
  },
  sortGridColumn : function(tableId, colIndex, sortOrder)
  {
    sortGridColumn(tableId,colIndex,sortOrder);
  },
  findColName: function (colList,colName){
    for(let col of colList){
      if(col.style.ColumnName === colName){
        return col.style.complexFieldName
      }
    }
  },
  getFormName: function() {
    if(window.isPortalLive){
      var formjson = functions.getFormJsonFromStore();
      return formjson.formName;
    }
    else{
      return this.getWorkItemData("formname");
    }
  },
  getValueFromColumnName : function(tableId,rowIndex,colName)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON && eleJSON.rowData && eleJSON?.rowData?.[rowIndex]){
      if(validControls.getValueFromColumnName.includes(eleJSON?.elem_type)) {
        if(eleJSON.elem_type.toLowerCase() === "advancelistview"){
          let complexName = this.findColName(eleJSON.columnList,colName)
          colName = complexName;
        } else if (eleJSON.elem_type.toLowerCase() === "listview" && eleJSON?.dataclass) {
          let complexField = this.findColName(eleJSON.columnList, colName)
          colName = eleJSON.dataclass + '.' + complexField 
        } 

        const columnData = Object.values(eleJSON.rowData[rowIndex])?.find(col => col.name === colName)
        if (columnData) {
          return columnData?.value
        }
      }
      else {
        functions.showMess(["getValueFromColumnName","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  },

  // displayTableCells1 : function(controlId,rowIndex,colIndices,displayFlag)
  // {
  //   var tableRef = document.getElementById(controlId);
  //   if(tableRef) {
  //     var row = tableRef.tBodies[0].getElementsByTagName("tr")[rowIndex];
  //     var cells = row.getElementsByTagName("td");
  //     for(var i=1;i<=cells.length;i++){
  //         for(var j=0;j<colIndices.length;j++){
  //             if((i-1)==colIndices[j])
  //                 cells[i].style.display=displayFlag?"":"none";
  //         }
  //     }
  //   }
  //   else {
  //     functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  //   }
  // },
  getSelectedRowsIndex : function(tableId)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson,tableId);
    if(eleJSON){
        const rowIndices = getSelectedRowsIndexes(eleJSON);
        return rowIndices;
    }
  },
  getDeviceType : function (){
    if(isMobile){
      return "mobile"
    }
    else if(isTablet){
      return "tablet"
    }
    else if(isDesktop){
      return "web"
    }
  },
  
getSelectedRowsUtil:function(container = document) {
  // Find all *checked* checkboxes inside this container
  
const nativeChecked = Array.from(
    container.querySelectorAll('input[type="checkbox"]:checked')
  );

  // Also include aria-checked="true" (RSuite sometimes uses this)
  const ariaChecked = Array.from(
    container.querySelectorAll('input[type="checkbox"][aria-checked="true"]')
  );

  // Merge & de-dupe inputs
  const inputs = Array.from(new Set([...nativeChecked, ...ariaChecked]));

  // For each input, find the closest ancestor that has a `rowindex` attribute
  const rowIndexValues = inputs
    .map((cb) => cb.closest('[rowindex]'))        // <-- key part
    .filter(Boolean)
    .map((el) => el.getAttribute('rowindex'))
    .filter((v) => v != null && v !== '');

  // Optional: normalize to numbers (and sort)
  // const numeric = Array.from(new Set(rowIndexValues.map((v) => Number(v)))).sort((a, b) => a - b);
  // return numeric;

  // If you want them as strings (as-is):
  return Array.from(new Set(rowIndexValues)); // de-dup

},

getSelectedRowsDataFromTable : function(tableId, propArray=[]){
    let dataArray = [];
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON){
      //new code
      const tableRoot = document.querySelector(`[control_id="${eleJSON?.style?.MappingId || eleJSON?.style?.CustomId || eleJSON?.id}"][role="grid"]`)
      const indexArray = this.getSelectedRowsUtil(tableRoot);

      const selectedRows = propArray.length > 0 ? propArray : (indexArray.length > 0 ? indexArray : (getSelectedRowsIndexes(eleJSON)));
      dataArray = new Array(selectedRows.length);

     
      if(validControls.getSelectedRowsDataFromTable.includes(eleJSON?.elem_type)) {
        for(let i=0;i<selectedRows.length;i++)
        {
          const rowData=eleJSON.rowData[selectedRows[i]];
          if(rowData) {
            dataArray[i] = new Array(Object.keys(rowData).length);
            for(let j=0; j <Object.keys(rowData).length; j++)
            {
              if(rowData[j] !== undefined) {
                dataArray[i][j] = rowData[j].value;
              }
            }

          }
        }
      }
      else {
        functions.showMess(["getSelectedRowsDataFromTable","Not_Valid",tableId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
    return dataArray;
  },

  getGridRowCount : function(tableId){

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON) {
      if(validControls.getGridRowCount.includes(eleJSON?.elem_type)) {
        if(eleJSON.rowData)
          return eleJSON.rowData.length;
        else return 0;
      }
      else {
        functions.showMess(["getGridRowCount","Not_Valid",tableId],"error");
      } 
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  },

  deleteRowsFromGrid : function(tableId,rowIndices)
  {
    if(!validateParams(apiValidationObjects.deleteRowsfromgrid, {tableId, rowIndices}, "deleteRowsFromGrid")) return;

    var jsonToSend={
      "controlId":tableId,
      "rowIndices":rowIndices.toString(),
    }
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON){
      if(validControls.deleteRowsFromGrid.includes(eleJSON?.elem_type)) {
        try {
          const response = deleteRowInGrid(jsonToSend,true);
          if(response && response.data && response.data.status === "0"){
            rowIndices.sort((a, b) => b - a);
            for (let i = 0; i < rowIndices.length; i++) {
              eleJSON.rowData.splice(rowIndices[i], 1);
            }

            eleJSON.style.updateFormState = Date.now();
            eleJSON.style.updateFormState1 = Date.now();
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
              if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
            functions.render = true;
          }
          else {
            functions.showMess(["Invalid_Operation"],"error"); 
          }
        }
        catch(err) {
            functions.showMess([tableId,"No_Rows_To_Select"],"error"); 
        }
      }
      else {
        functions.showMess(["deleteRowsFromGrid","Not_Valid",tableId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
  },

  clearTable : function(controlId,sync,gridEmptyMessage="")
  {

    if(!validateParams(apiValidationObjects.clearTable, {controlId, sync}, "clearTable")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId);
    if(eleJSON) {
      if(validControls.clearTable.includes(eleJSON?.elem_type)) {
        const jsonToSend={
          "controlId":controlId,
        }
        try {
          const onSuccess = () => {
            eleJSON.rowData = [];
            eleJSON.style.gridEmptyMessage = gridEmptyMessage;
            eleJSON.style.updateFormState = Date.now();
            eleJSON.style.updateFormState1 = Date.now();
          };
          if(sync) {
            const response = clearTable(jsonToSend,sync);
              if(response && response.data && response.data.status === "0"){
                onSuccess();
              }
          }
          else {
            clearTable(jsonToSend,sync).then((response) => {
              if(response && response.data && response.data.status === "0"){
                onSuccess();
                updateRenderState(eleJSON?.id);
              }
            });
          }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
        catch(err) {
          functions.showMess([controlId,"No_Rows_To_Select"],"error"); 
        }
      }
      else {
        functions.showMess(["clearTable","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  addBlankRowToTable : function(tableId)
  {
    let result=true;
    if(window.tableOperation)
    { // tableId,operationType
        result = window.tableOperation(tableId, "AddRow");
    }

    var jsonToSend={
      "controlId":tableId
    };
    if(document.getElementById(tableId)!=null){
      if(document.getElementById(tableId).getAttribute("elem_type")==="listview"){
        jsonToSend.dataValue={};
      }
    }
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');

    if(result && eleJSON) {
      if(validControls.addBlankRowToTable.includes(eleJSON?.elem_type)) {
        const response = addRowInGrid(jsonToSend,true);
          if(response && response.data && response.data.status === "0"){
            if(!eleJSON.rowData) 
              eleJSON.rowData = [];
            eleJSON.rowData.push(response?.data?.valueJson || {})
           // eleJSON.isCustomData = true;
           const { setRecordCount } = getReduxContexts();
              if(setRecordCount) {
                setRecordCount(eleJSON.id, true);
              }
            eleJSON.style.updateFormState = Date.now();
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
              if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
            functions.render = true;
          }
      }
      else {
        functions.showMess(["addBlankRowToTable","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  },
  setCustomLogoutRedirection : function(url){
    window.customLogoutRedirectionURL = url;
  },
  executeLogoutRedirection : function(){
    window.location.replace(window.setCustomLogoutRedirection);
  },
  validateJourney: function() {
    return window?.validationWizardSteps();
  },
  checkMandatoryColumns: function getControls(children,arr,columnNames){
    for(let child of children){
      if(child.children){
        getControls(child.children,arr,columnNames)
      }else{
        if(columnNames.includes(child.style.ColumnName) && child.style.Mandatory === "true"){
        arr.push(child.style.ColumnName)
        }
      }
    }
  },
  getColumnNames : function(columnList){
    let result = [];
    for(let column of columnList){
      result.push(column.style.ColumnName)
    }
    return result;
  },
  validateJsonData: function(jsonData,mandatoryControls,tableId){
    for(let row of jsonData){
      let columnsObject = mandatoryControls.reduce((acc, column) => {
        acc[column] = false;
        return acc;
      }, {});
      for(let col in row){
          columnsObject[col] = true;
      }
      let hasTrueValue = Object.values(columnsObject).includes(false);
      if(hasTrueValue){
        functions.showMess(["addDataToGrid","Please fill all the mandatory fields",tableId],"error")
        return false
      }
    }
    return true
  },
  addDataToGrid : function(tableId,jsonData)
  {
    var jsonToSend={
      "controlId":tableId,
      "jsonData":jsonData
    };
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');

    if(eleJSON){
      //checkMandatoryControl
      if(eleJSON?.elem_type === "listview"){
        let columnName = this.getColumnNames(eleJSON.columnList);
        //get mandatory controls
        let mandatoryControls = [];
        this.checkMandatoryColumns(eleJSON.listviewFrameLayoutJson.children,mandatoryControls,columnName)
        let isValid = this.validateJsonData(jsonData,mandatoryControls,eleJSON.id)
        if(!isValid) return
      }
  
      if(eleJSON){
        if(validControls.addDataToGrid.includes(eleJSON?.elem_type)) {
          const response = addDataToGrid(jsonToSend,true);
          if(response && response.data && response.data.status === "0"){
            if(response.data.dataValue != null && response.data.dataValue != undefined && response.data.dataValue.length >0){
                if(!eleJSON.rowData)
                  eleJSON.rowData = [];
                eleJSON.rowData.push(...response.data.dataValue)
               // eleJSON.isCustomData = true;
                eleJSON.style.updateFormState = Date.now();
                const { setRecordCount } = getReduxContexts();
                if(setRecordCount) {
                  setRecordCount(eleJSON.id, true);
                }
                if (window.addRowPostHook) {
                  window.addRowPostHook(getHooksId(eleJSON), "customAPI");
                  // functions.updateJSON()
                }
                // if(!functions.fromExecuteServerEvent){
                //   updateRenderState(eleJSON?.id);
                // }
                  if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
                functions.render = true;
              }
            }
        }
        else {
          functions.showMess(["addDataToGrid","Not_Valid",tableId],"error");
        }
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  },

  addDataToAdvancedGrid : function(tableId,jsonData)
  {
    var jsonToSend={
      "controlId":tableId,
      "jsonData":jsonData
    };
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.addDataToAdvancedGrid.includes(eleJSON?.elem_type)) {
        const response = addDataToAdvancedGrid(jsonToSend,true);
          if(response && response.data && response.data.status === "0"){
            if(response.data.dataValue != null && response.data.dataValue != undefined && response.data.dataValue.length >0){
              if(!eleJSON.rowData)
                eleJSON.rowData = [];
              eleJSON.rowData.push(...response.data.dataValue)
              //eleJSON.isCustomData = true;
              eleJSON.style.updateFormState = Date.now();
              const { setRecordCount } = getReduxContexts();
              if(setRecordCount) {
                setRecordCount(eleJSON.id, true);
              }
              if (window.addRowPostHook) {
                window.addRowPostHook(getHooksId(eleJSON), "customAPI");
                // functions.updateJSON();
              }
              // if(!functions.fromExecuteServerEvent){
              //   updateRenderState(eleJSON?.id);
              // }
                if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
              functions.render = true;
            }
          }
      }
      else {
        functions.showMess(["addDataToAdvancedGrid","Not_Valid",tableId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
  },

  getValue : function (controlId)
  {
    const containerId = getContainerId()
    var formjson = functions.getFormJsonFromStore(containerId);
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON) {
      if(validControls.getValue.includes(eleJSON?.elem_type)) {
        if(eleJSON?.elem_type === "tile") {
          return eleJSON.selectedTile;
        } else if(eleJSON?.elem_type === "label") {
          return eleJSON?.style?.Label;
        }  else if( eleJSON?.elem_type === "datepick"){
          if(eleJSON?.value){
            if(typeof eleJSON?.value === "string"){
              let DateinFormat;
              DateinFormat = eleJSON.value.replace(/,/g, '');
              if(countOccurrences(DateinFormat, ":") > 1){
                const lastIndex = DateinFormat.lastIndexOf(":");
                DateinFormat = DateinFormat.slice(0,lastIndex);
              }
              return (DateinFormat || eleJSON.value);
            } else {
              let formattedDate = "";
              const formState2 = functions.getFormJsonFromStore(); 
              const controlThemeData = formState2.theme?.['InputStyle']
              const datepickerType = eleJSON?.style?.PickerType;
              const dateSeprator1 =controlThemeData?.["DateSeperator"] === "1" ? "/" : controlThemeData?.["DateSeperator"] === "2" ? "-" :controlThemeData?.["DateSeperator"] === "3" ?"." :"/"
              const dateTimeSeprator =controlThemeData?.["DateTimeSeperator"] === "1" ? "/" : controlThemeData?.["DateTimeSeperator"] === "2" ? "-" :controlThemeData?.["DateTimeSeperator"] === "3" ?"." :"/"
              const dateFormat1 = eleJSON?.style["DateFormat"] || (eleJSON?.style?.PickerType === "1" ? controlThemeData?.['ThemeDateFormat'] : eleJSON?.style?.PickerType === "2" ? controlThemeData?.['ThemeDateFormat2'] : controlThemeData?.['ThemeDateFormat'])
    
              if(datepickerType === "1"){
                if(dateFormat1 === "1"){
                  formattedDate = eleJSON.value?.ddmmyyyy(dateSeprator1);
                }else if(dateFormat1 === "2"){
                  formattedDate = eleJSON.value?.mmddyyyy(dateSeprator1);
                }else if(dateFormat1 === "3"){
                  formattedDate = eleJSON.value?.yyyymmdd(dateSeprator1);
                }else if(dateFormat1 === "4"){
                  formattedDate = eleJSON.value?.ddmmmyyyy(dateSeprator1);
                }else{
                  formattedDate = eleJSON.value?.ddmmyyyy(dateSeprator1);
                }
              } else {
                if(dateFormat1 === "5"){
                  formattedDate = eleJSON.value?.ddmmyyyyhhmm(dateTimeSeprator);
                }else if(dateFormat1 === "6"){
                  formattedDate = eleJSON.value?.mmddyyyyhhmm(dateTimeSeprator);
                }else if(dateFormat1 === "7"){
                  formattedDate = eleJSON.value?.yyyymmddhhmm(dateTimeSeprator);
                }else if(dateFormat1 === "8"){
                  formattedDate = eleJSON.value?.ddmmmyyyyhhmm(dateTimeSeprator);
                }else{
                  formattedDate = eleJSON.value?.ddmmyyyyhhmm(dateTimeSeprator);
                }
              }
              return formattedDate;
            }
          } else {
            return eleJSON.value;
          }
        } else if(eleJSON?.elem_type === "slider" || eleJSON?.controlName === "slider") {
          return (eleJSON?.value !== undefined && eleJSON?.value !== null)
          ? eleJSON?.value : eleJSON?.style?.DefaultValueSlider? eleJSON?.style?.DefaultValueSlider: "";
        } 
        else {
          if(eleJSON?.elem_type === "checkbox" || eleJSON?.elem_type === "toggle")
            return eleJSON?.value  === "true" || eleJSON?.value === true ? true : false;
          else if(eleJSON?.elem_type === "doclist") {
            const docValues = [];
            if(eleJSON?.value?.length > 0 ) {
              eleJSON?.value?.map((doc) => {
                docValues.unshift({"name": doc.name, "id": doc.id, "version": doc.version, "no_of_pages": doc.no_of_pages, "doc_type": doc.doc_type, "size": doc.size, "actualSize":doc?.actualSize,"extension":doc?.extension });
              })
            }
            return docValues;
          }
          // return (eleJSON?.value || eleJSON?.value === false || eleJSON?.value === "false") 
          // ? eleJSON?.value : (eleJSON?.elem_type === "combo") ?
          //  eleJSON?.style?.DefaultSelect : eleJSON?.style?.DefaultValueSlider;
          return (eleJSON?.value !== undefined && eleJSON?.value !== null) 
          ? eleJSON?.value 
           : (eleJSON?.elem_type === "combo" ||eleJSON?.elem_type === "listbox" ) 
              ? eleJSON?.style?.DefaultSelect
              : (eleJSON?.value === undefined)
                ? "" 
             : eleJSON?.style?.DefaultValueSlider;

        }
      }
      else {
        functions.showMess(["getValue","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

   updateIFrameUrl: function (iframeid, url, containerId) {
     try {
       if (iframeid && url) {
         var formjson = functions.getFormJsonFromStore(containerId);
         const iframeJson = functions.readJson(formjson, iframeid);

         if (iframeJson) {
           iframeJson.style.SourceURL = url;

          //  if (!functions.fromExecuteServerEvent) {
            //  updateRenderState(iframeJson?.id);
          //  }
               if(!notContainParent(iframeJson) && iframeJson?.id)
            functions.renderElementsArray.add(iframeJson?.id)
           functions.render = true;
         }
       }
       else {
        const message = !iframeid ? 'Iframe Id is not valid' : 'Url is not valid';
         generalError_fn(message, 'Invalid Parameters', 'error')
       }
     } catch (error) {
       const exceptionString = error?.stack || error?.message || String(error);
       generalError_fn(exceptionString, "Something went wrong while updating the iframe URL", 'error');
     } 
  },
  
  getFormattedValue : function (controlId) {
    const containerId = getContainerId()
    var formjson = functions.getFormJsonFromStore(containerId);
    var eleJSON = recursiveJsonReader1(formjson,controlId,'control');
    const emojiRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
    if(eleJSON) {
      if(validControls.getFormattedValue.includes(eleJSON?.elem_type)) {
        if(!eleJSON?.value) {
          return "";
        }
        const strippedValue = eleJSON?.value.replace(emojiRegex, "");
        let fieldValue = strippedValue;
        if(eleJSON && eleJSON?.elem_type === "textbox"){
          if(eleJSON?.style?.MaskingValue === "000-000"){
            fieldValue = fieldValue.replace(/[^\d]/g, "");
            return fieldValue;
          }
          if(eleJSON?.datamapVariableType === "Float") {
            return fieldValue.replace(/[^\d.-]/g, "");
          }
          return fieldValue.replace(/[^\d-]/g, "");;
        }
      }
      else {
        functions.showMess(["getFormattedValue","Not_Valid",controlId],"error");
      }
    } else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  // setValue : function(controlName, controlValue,containerId)
  // {
  //   setValueImpl(controlName,controlValue,containerId);
  // },

  clearValue : function(controlId,sync)
  {
    console.log(controlId)
    clearValueImpl(controlId,sync);
  },

  setValues : async function(jsonObj,sync)
  {
    console.log(jsonObj)
    if(sync) 
      await setValuesImpl(jsonObj,sync);
    else setValuesImpl(jsonObj);
  },
  setListViewTableData : function(jsonobj,tableId,sync){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.setListViewTableData.includes(eleJSON?.elem_type)) {
        for(let i of jsonobj){
          eleJSON.rowData.push(i)
         // eleJSON.isCustomData = true;
        }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
      else {
        functions.showMess(["setListViewTableData","Not_Valid",tableId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
  },
  setMultipleTableCellData : function(tableId,dataObj,sync)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.setMultipleTableCellData.includes(eleJSON?.elem_type)) {
        const updatedDataObj = dataObj.map((temp) => ({
          ...temp,
          colIndex: getUpdatedColumnIndex(eleJSON, formjson, temp.colIndex)
        }));
        var jsonToSend={
          "controlId":tableId,
          "multipleData":JSON.stringify(updatedDataObj)
        };
        if(sync) {
          const response = setTableMultiCellData(jsonToSend,sync);
            if(response && response.data && response.data.status === "0"){
            for(var i=0;i < updatedDataObj.length ;i++)
            {
              var temp=updatedDataObj[i];
              eleJSON.rowData[temp.rowIndex][temp.colIndex].value=temp.cellData;
            }
            }
        }
        else {
          setTableMultiCellData(jsonToSend,sync).then((response) => {
            if(response && response.data && response.data.status === "0"){
              for(var i=0;i < updatedDataObj.length ;i++)
              {
                var temp=updatedDataObj[i];
                eleJSON.rowData[temp.rowIndex][temp.colIndex].value=temp.cellData;
              }
              }
          })
        }
        functions.render = true;
      }
      else {
        functions.showMess(["setMultipleTableCellData","Not_Valid",tableId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
  },

  setReadOnlyStyleOnTextarea : function(textareaId,readOnlyFlag, typeOfReadOnly = 0, charactersToBeShown){
    if(!validateParams(apiValidationObjects.setReadOnlyStyleOnTextarea, {textareaId,readOnlyFlag,typeOfReadOnly, charactersToBeShown}, "setReadOnlyStyleOnTextarea")) return;
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,textareaId,'control');
    if(eleJSON){
      if(validControls.setReadOnlyStyleOnTextarea.includes(eleJSON?.elem_type)) {
        if(readOnlyFlag === true || readOnlyFlag === "true"){
          if(typeOfReadOnly == 1){
            eleJSON.style.ReadOnlyStyle = true;
            eleJSON.style.TextOverflowBehaviour = "Truncate";
            if(charactersToBeShown)
            eleJSON.style.CharactersToBeShown = charactersToBeShown?.toString();
          } else if(typeOfReadOnly == 2){
            eleJSON.style.ReadOnlyStyle = true;
            eleJSON.style.TextOverflowBehaviour = "Viewmore/less";
            if(charactersToBeShown)
            eleJSON.style.CharactersToBeShown = charactersToBeShown?.toString();
          }
          else if(typeOfReadOnly == 0){
            eleJSON.style.ReadOnlyStyle = true;
            eleJSON.style.TextOverflowBehaviour = "";
            eleJSON.style.CharactersToBeShown = "";
          }
        }
        else{
          eleJSON.style.ReadOnlyStyle = false;
        }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
      }
      else {
        functions.showMess(["setReadOnlyStyleOnTextarea","Not_Valid",textareaId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",textareaId,"Not_Present"],"error");
    }
  },

  setTableCellData : function (tableId,rowIndex,colIndex,cellData,sync=true)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      var jsonToSend={
        "controlId":tableId,
        "rowIndex": isNaN(rowIndex) ? rowIndex: parseInt(rowIndex),
        "colIndex": updatedColumnIndex,
        "cellData":cellData
      };
      if(validControls.setTableCellData.includes(eleJSON?.elem_type)) {
        const mappingCheck = mappingValidation(eleJSON, updatedColumnIndex, cellData);
        if (!mappingCheck) {
          functions.showMess(["setTableCellData","Invalid_Data_Type",tableId],"error");
          console.error("Invalid Data Type");
          return;
        }
        if(sync) {
          const response = setTableCellData(jsonToSend,sync);
            if(response && response.data && response.data.status === "0"){
              eleJSON.rowData[rowIndex][updatedColumnIndex].value=response.data.value;
              eleJSON.style.updateFormState = Date.now();
            }
        }
        else {
          setTableCellData(jsonToSend).then((response) => {
            if(response && response.data && response.data.status === "0"){
              eleJSON.rowData[rowIndex][updatedColumnIndex].value=response.data.value;
              eleJSON.style.updateFormState = Date.now();
            }
          })
        }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        // }
        functions.render = true;
      }
      else {
        functions.showMess(["setTableCellData","Not_Valid",tableId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
  },

  setTabStyle: function (tabId, index, attribute, attributeValue) { 
    setTabStyle(tabId, index, attribute, attributeValue);
  },
  setTabStyleByName: function (tabId, name, attribute, attributeValue) { 
    setTabStyleByName(tabId, name, attribute, attributeValue);
  },
  setButtonDropDown: function (controlId, jsonObj) {
    setButtonDropDown(controlId, jsonObj);
  },
  setCellDisabled1 : function(tableId,rowIndex,colIndex,flag)
  {
    var table = document.getElementById(tableId);
    if (table != null && table != undefined)
        {
          var row = table.tBodies[0].getElementsByTagName("tr")[rowIndex];
            var col = row.getElementsByTagName("td")[colIndex + 1];
            if(row != null && row != undefined )
            {
              var control = col.getElementsByClassName("control-class")[0];
            if (col != null && col != undefined)
            {
              if (flag==="true" || flag==true){
                control.disabled = "true";
                $(control).parent().css("pointerEvents","none");
                 $(control).css("pointerEvents","none");
                    $(control).parent().css("cursor","default");
              }
              else if(flag==="false" || flag==false)
              {
                control.removeAttribute("disabled");
                $(control).parent().css("pointerEvents","auto");
                    $(control).parent().css("cursor","");
                    $(control).css("pointerEvents","auto");
                    $(control).css("cursor","");
              }
            }
          }
        }
        else {
          functions.showMess(["The_Control",tableId,"Not_Present"],"error");
        }
  },
  autoCompleteAPI : function(enable,controlId) 
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON) {
      if(validControls.autoCompleteAPI.includes(eleJSON?.elem_type)) {
        if(enable === "true" || enable === true || enable === "false" || enable === false) {
          eleJSON.style.AllowSearching = enable +"";
          functions.render = true;
          eleJSON.calledFromAPI = true;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          eleJSON.style.updateFormState = Date.now();
        }
        else functions.showMess(["Invalid_Operation"],"error");
      }
      else {
        functions.showMess(["autoCompleteAPI","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },
  getWorkItemData : function(property)
  {
    let  containerId = getContainerId()
    const externalIformUrl = document?.URL || document?.baseURI || document?.documentURI
    let externalFormResponse = {}

    if(externalIformUrl?.includes("openExtInterface")){
      const params = (new URL(externalIformUrl))?.searchParams
      const obj = {
        userName: params?.get("userName"),
        userIndex: params?.get("userIndex"),
        cabinetName: params?.get("cabinetName"),
        sessionId: params?.get("sessionId")
      }
      externalFormResponse = obj
    }

    let info_filtered = (formStateStore.getState()).data;

    var generalData = {};
    var generalData1 ={};
    // if(containerId===undefined){
    //   containerId = getContainerId();
    // }

    if(containerId!==undefined){
      generalData= info_filtered.find(json => json.key === containerId)?.generalData;
    }
    else{
      let newInfo_Filtered = info_filtered.find(info => (info?.generalData && Object.keys(info?.generalData).length !== 0) );
      let newInfo_Filtered1 = info_filtered.filter(info => (info?.generalData && Object.keys(info?.generalData).length !== 0));
      
      generalData = newInfo_Filtered?.generalData;
      generalData1 = newInfo_Filtered1?.generalData;
    }

   
  if(window.isPortalLive || externalIformUrl?.includes("openExtInterface")) {
    const getGeneralDataJSON_payload = {
      gdtoken: getGdToken(),
      token: axios.defaults.headers.common["Authorization"],
    };
    let response = getGeneralData(getGeneralDataJSON_payload,true);
    generalData = response.data;
  } 
  
  if(property.toLowerCase()=="processinstanceid"){
      return generalData.processinstanceid;
  }
  else if(property.toLowerCase() == "workitemid"){
      return generalData.workitemid;
  }

  else if(property.toLowerCase() == "mode"){
      console.log("formStateStore4", generalData?.mode)
    return generalData.mode;
  }

  else if(property.toLowerCase() == "taskid"){
      return generalData.taskid;
  }

  else if(property.toLowerCase() == "activityname"){
      return generalData?.activityname;
  }

  else if(property.toLowerCase() == "appserverip"){
      return generalData.appserverip;
  }

  else if(property.toLowerCase() == "appserverport"){
      return generalData.appserverport;
  }

  else if(property.toLowerCase() == "username"){
      return generalData.userName || generalData.username
  }

  else if(property.toLowerCase() == "sessionid"){
      return generalData.sessionid
  }
  else if(property.toLowerCase() == "cabinetname"){
      return generalData.cabinetname
  }

  else if(property.toLowerCase() == "processname"){
      return generalData.processname;
  }

  else if(property.toLowerCase() == "subtaskid"){
      return generalData.subtaskid;
  }

  else if(property.toLowerCase() == "taskname"){
      return generalData.taskname;
  }
  else if(property.toLowerCase() == "assignedto"){
      return generalData.assignedto;
  }

  else if(property.toLowerCase() == "prioritylevel"){
      return generalData.prioritylevel;
  }
  
  else if(property.toLowerCase() == "lockedbyname"){
      return generalData.lockedbyname;
  }
  
  else if(property.toLowerCase() == "processedby"){
      return generalData.processedby;
  }
  
  else if(property.toLowerCase() == "introductiondatetime"){
      return generalData.introductiondatetime;
  }
  
  else if(property.toLowerCase() == "introducedat"){
      return generalData.introducedat;
  }
  
  else if(property.toLowerCase() == "queueid"){
      return generalData.queueid;
  }
  
  else if(property.toLowerCase() == "lockstatus"){
      return generalData.lockstatus;
  }
  
  else if(property.toLowerCase() == "useremailid"){
      return generalData.useremailid;
  }
  
  else if(property.toLowerCase() == "userpersonalname"){
      return generalData.userpersonalname;
  }
  
  else if(property.toLowerCase() == "userfamilyname"){
      return generalData.userfamilyname;
  }
  
  else if(property.toLowerCase() == "userindex"){
      return generalData.userindex
  }
else if(property.toLowerCase() == "queuename"){
      return generalData.queuename;
  }
  else if(property.toLowerCase() == "activityid") {
    return generalData.activityid;
  }
  else if(property.toLowerCase() == "processdefid") {
    return generalData.processdefid;
  }
  else if(property.toLowerCase() == "queuetype") {
    return generalData.queuetype;
  }
  else if(property.toLowerCase() == "queueactivityname") {
    return generalData.queueactivityname;
  }
  else if(property.toLowerCase() == "formname") {
    return generalData.formname;
  } 
  else if(property.toLowerCase() == "folderindex") {
    return generalData.folderindex;
  }
  else {
    functions.showMess(["The_Attribute",property,"Invalid_WorkItem_Data"],"error");
  }
  },

  reloadTabSheet : function(tabId, sheetIndex, sheetId)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tabId,'control');
    if(eleJSON){
      if(validControls.reloadTabSheet.includes(eleJSON?.elem_type)) {
          
        var sheetId=eleJSON.children[sheetIndex].id;
        var tab= document.getElementById(tabId);
        var jsonToSend={
          "sheetID":sheetId,
          "sheetIndex":sheetIndex,
          "controlId": tabId
        }
        const response = reloadTab(jsonToSend,true);
        if(response && response.data){
              eleJSON.children[sheetIndex].children = [];
              eleJSON.children?.[sheetIndex]?.children.push(...response.data.sheetJson.children);
              // if(!functions.fromExecuteServerEvent){
              //   updateRenderState(eleJSON?.id);
              // }
                if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
              functions.render = true;
        }
      }
      else {
        functions.showMess(["reloadTabSheet","Not_Valid",tabId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tabId,"Not_Present"],"error");
    }
  },

  setCellDisableTable: function(controlId,rowIndex,colIndex,disableFlag)
  {
    setCellDisableTable(controlId,rowIndex,colIndex,disableFlag);
  },

  setCellDisabled : function(tableId,rowIndex,colIndex,flag)
  {
    setCellDisabled(tableId,rowIndex,colIndex,flag);
  },
  setCellContentVisible : function(tableId,rowIndex,colIndex,flag)
  {
    setCellContentVisible(tableId,rowIndex,colIndex,flag);
  },
  setColumnHeaderVisible : function(tableId,columnIndex,flag)
  {
    setColumnHeaderVisible(tableId,columnIndex,flag);
  },
  setCellLabelColor: function(tableId,rowIndex,colIndex, color)
  {
    setCellLabelColor(tableId,rowIndex,colIndex, color)
  },
  setCellBackgroundColor: function(tableId, rowIndex, colIndex, color){
    setCellBackgroundColor(tableId,rowIndex,colIndex,color)
  },
  setCellStyle: function (tableId, rowIndex, colIndex, attributeName, attributeValue) {
    setCellStyle(tableId, rowIndex, colIndex, attributeName, attributeValue)
  },
  setCellBorderRadius: function(tableId, rowIndex, colIndex, borderRadius){
    setCellBorderRadius(tableId,rowIndex,colIndex,borderRadius)
  },
  disableCheckboxColumn: function(tableId, flag){
    disableCheckboxColumn(tableId, flag)
  },
  setTableCellFocus: function(tableId, rowIndex, colIndex) {
    setTableCellFocus(tableId, rowIndex, colIndex)
  },
  setListviewModalHeader: function(tableId,header){
    setListviewModalHeader(tableId,header)
  },
  setCellButtonBGColor : function(tableId,rowIndex,colIndex,bgColor)
  {
    setCellButtonBGColor(tableId,rowIndex,colIndex,bgColor)
  },
  setCellButtonCaption : function(tableId,rowIndex,colIndex,newCaption)
  {
    setCellButtonCaption(tableId, rowIndex, colIndex, newCaption)
  },
  getCellButtonCaption : function(tableId,rowIndex,colIndex)
  {
    return getCellButtonCaption(tableId, rowIndex, colIndex)
  },
  setTableColumnName : function(tableId, columnArray)
  {
    setTableColumnName(tableId, columnArray)
  },

  setRowsDisabled : function(tableId,rowIndices,disableSelectCheckbox)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.setRowsDisabled.includes(eleJSON?.elem_type)) {
        for (var i = 0; i < rowIndices.length; i++) 
        {
          var row=rowIndices[i];
          this.setRowStyle(tableId,row,"disable",disableSelectCheckbox);
          //  if(disableSelectCheckbox){
          //    if(eleJSON.rowData[row].style == undefined)
          //    eleJSON.rowData[row].style={};
          //  eleJSON.rowData[row].style.disableSelectCheckbox="true";
          //  }
        }
        functions.render = true;
      }
      else {
        functions.showMess(["setRowsDisabled","Not_Valid",tableId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
  },

  setTableCellColor : function (tableId,rowIndex,colIndex,color)
  {
    setTableCellColor(tableId,rowIndex,colIndex,color)
  },
  getInterfaceJwtToken: function () {
    const secureAutherization = secureSessionStorage.getItem("Authorization");
    const secureAutherization1 = window.isPortalLive ? secureLocalStorage.getItem(`launchpadKey_${window.applicationName}`) || secureLocalStorage.getItem(`launchpadKey_bypass_${window.applicationName}`) || secureLocalStorage.getItem("launchpadKey") : secureLocalStorage.getItem("launchpadKey");
    return secureAutherization || JSON.parse(secureAutherization1)?.token || undefined;
  },
  setRowColorInListView : function (tableId,rowIndex,color)
  {
    if(!validateParams(apiValidationObjects.setRowColorInListView, {tableId,rowIndex,color}, "setRowColorInListView")) return;
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.setRowColorInListView.includes(eleJSON?.elem_type)) {
        if(eleJSON.rowData[rowIndex]) {
          for(var i=0; i<  Object.keys(eleJSON.rowData[rowIndex]).length ; i++){
            if(eleJSON.rowData[rowIndex]?.[i]?.style)
              eleJSON.rowData[rowIndex][i].style.BackColor = "#"+color;
          }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        } else {
          functions.showMess([tableId," does not have row with index: ",rowIndex],"error")          
        }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
      else {
        functions.showMess(["setRowColorInListView","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  },
  // displayTableCells : function(controlId,rowIndex,colIndices,displayFlag)
  // {
  //   var formjson = functions.getFormJsonFromStore();
  //   var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
  //   if(eleJSON){
  //     if(validControls.displayTableCells.includes(eleJSON?.elem_type)) {
  //       for(var cell=0;cell<colIndices.length;cell++)
  //       {
  //         eleJSON.rowData[rowIndex][colIndices[cell]].style.VisibleOnTable=displayFlag;
  //       }
  //       // if(!functions.fromExecuteServerEvent){
  //       //   updateRenderState(eleJSON?.id);
  //       // }
  //         if(!functions.renderElementsArray?.includes(eleJSON?.id))
  //           functions.renderElementsArray.push(eleJSON?.id)
  //       functions.render = true;
  //     }
  //     else {
  //       functions.showMess(["displayTableCells","Not_Valid",controlId],"error");
  //     }
  // }
  // else {
  //   functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  // }
  // },
  setRowSelectionInListView: function (controlId,rowIndices, callPostHook)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON) {
      if(validControls.setRowSelectionInListView.includes(eleJSON?.elem_type)) {
        if(eleJSON?.rowData) {
          if(rowIndices[0] !== -1) {
            let invalidIndices = [];
            rowIndices.forEach((val) => {
              if(val >= eleJSON.rowData.length) {
                if(!invalidIndices.includes(val))
                  invalidIndices.push(val);
                rowIndices = rowIndices.filter((item) => {return item !== val});
              }
            })
            if(invalidIndices.length > 0) {
              functions.showMess([invalidIndices.toString(),"Not_Valid_Control",controlId],"error");
            }
          }
          if(eleJSON?.style?.rowsToDeSelect) {
            delete eleJSON?.style?.rowsToDeSelect
          }
          eleJSON.style.rowsToSelect = rowIndices;
          eleJSON.style.callPostHook = callPostHook;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
        else {
          functions.showMess([controlId,"No_Rows_To_Select"],"error");
        }
      }
      else {
        functions.showMess(["setRowSelectionInListView","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  setRowDeSelectionInListView: function (controlId,rowIndices)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON) {
      if(validControls.setRowDeSelectionInListView.includes(eleJSON?.elem_type)) {
        if(eleJSON?.rowData) {
          if(rowIndices[0] !== -1) {
            let invalidIndices = [];
            rowIndices.forEach((val) => {
              if(val >= eleJSON.rowData.length) {
                if(!invalidIndices.includes(val))
                  invalidIndices.push(val);
                rowIndices = rowIndices.filter((item) => {return item !== val});
              }
            })
            if(invalidIndices.length > 0) {
              functions.showMess([invalidIndices.toString(),"Not_Valid_Control",controlId],"error");
            }
          }
          eleJSON.style.rowsToDeSelect = rowIndices;
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
        else {
          functions.showMess([controlId,"No_Rows_To_Select"],"error");
        }
      }
      else {
        functions.showMess(["setRowSelectionInListView","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  setCellImageInGrid : function(tableId, rowIndex, colIndex, {imageName, processName, formName})
  {
    const remainingURL = `${window.apb_backend_app_context}/idesign/getImage/${processName}/${formName}/${window?.activeCabinet_formbuilder}/${imageName}`;
    setCellImageInGrid(tableId,rowIndex,colIndex,remainingURL)
  },

  setRowSelectionInGrid: function (controlId,rowIndices, callPostHook)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON) {
      if(validControls?.setRowSelectionInGrid?.includes(eleJSON?.elem_type)) {
        if(eleJSON?.rowData) {
          if(rowIndices[0] !== -1) {
            let invalidIndices = [];
            rowIndices?.forEach((val) => {
              if(val >= eleJSON?.rowData?.length) {
                if(!invalidIndices?.includes(val))
                  invalidIndices?.push(val);
                rowIndices = rowIndices?.filter((item) => {return item !== val});
              }
            })
            if(invalidIndices?.length > 0) {
              functions.showMess([invalidIndices.toString(),"Not_Valid_Control",controlId],"error");
            }
          }
          if(eleJSON?.style?.rowsToDeSelect) {
            delete eleJSON?.style?.rowsToDeSelect
          }
          eleJSON.style.rowsToSelect = rowIndices;
          eleJSON.style.callPostHook = callPostHook;
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
        else {
          functions.showMess([controlId,"No_Rows_To_Select"],"error");
        }
      }
      else {
        functions.showMess(["setRowSelectionInGrid","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  },

  setTableCellDateRange : function (tableId, rowIndex, colIndex, minDate, maxDate)
  {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    
    if(eleJSON){
      if(validControls.setTableCellDateRange.includes(eleJSON?.elem_type)) {
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        eleJSON.rowData[rowIndex][updatedColumnIndex].style.minDate=minDate;
        eleJSON.rowData[rowIndex][updatedColumnIndex].style.maxDate=maxDate;
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        eleJSON.style.updateFormState = Date.now();
        functions.render = true;
      }
      else {
        functions.showMess(["setTableCellDateRange","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  },

  addItemInTableCellCombo : function (tableId,rowIndex,colIndex,label,value,tooltip,optionControlId)
  {
    addItemInTableCellCombo(tableId,rowIndex,colIndex,label,value,tooltip,optionControlId);
  },
  removeItemFromTableCellCombo : function(tableId,rowIndex,colIndex,itemIndex)
  {
    removeItemFromTableCellCombo(tableId,rowIndex,colIndex,itemIndex);
  },
  clearTableCellCombo : function(tableId,rowIndex,colIndex){
    clearTableCellCombo(tableId,rowIndex,colIndex);
  },
  setRowStyle : function(tableId,rowIndex,attributeName,attributeValue)
  {

    if(!validateParams(apiValidationObjects.setRowStyle, {tableId,rowIndex,attributeName,attributeValue}, "setRowStyle")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.setRowStyle.includes(eleJSON?.elem_type)) {
        if(eleJSON?.rowData?.[rowIndex]) {
          if (attributeName.toLowerCase() === "disable") {
            const curRow = eleJSON.rowData[rowIndex];
            if(curRow) {
              let finalValue = false;
              if(attributeValue === "true" || attributeValue === true)
                finalValue = true;
              else if(attributeValue === "false" || attributeValue === false)
                finalValue = false;

              curRow.Disabled = finalValue;
              for (var i = 0; i < Object.keys(curRow).length; i++) {
                const curCell = curRow?.[i]?.style;
                if(curCell) {
                  curCell.Disabled=finalValue;
                }
              }
            }
          }
          else if(attributeName.toLowerCase() === "visible")
          { 
            if(attributeValue === "true" || attributeValue === true){
              eleJSON.rowData[rowIndex].Visible=true;
            }else if(attributeValue === "false" || attributeValue === false){
              eleJSON.rowData[rowIndex].Visible=false;
            }
          }
          // if(functions.fromExecuteServerEvent){
            eleJSON.style.updateFormState = Date.now();
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          functions.render = true;
        }
        else {
          functions.showMess([tableId," does not have row with index: ",rowIndex],"error")          
        }
      }
      else {
        functions.showMess(["setRowStyle","Not_Valid",tableId],"error")
      }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
  },
  executeServerEvent : function(controlName, eventType , stringifyData , sync ,containerId, renderFlag)
  {
    containerId = containerId ? containerId : getContainerId()
    if(renderFlag === undefined) {
      if(!sync) {
        renderFlag = true;
      }
    };

    var jsonToSend={
      "fromEvent":"executeServerEvent",
      "controlName":controlName,
      "eventType":eventType,
      "eventData": typeof stringifyData === "string" && stringifyData ? stringifyData: JSON.stringify(stringifyData)
    };

    if(sync) {
      const response = executeServerEvent(jsonToSend,sync);
      if(response && response.data && response.data.status === "0"){
        console.log("inside executeServerEvent", response.data);

        if(response.data.error === "false")
        {
          var apiArray=response.data.APIData;
          // if(apiArray != null)
          // functions.fromExecuteServerEvent = true
          renderExecuteServerEventAPIData({outputArray:apiArray,sync, renderFlag});
          window.loading(false);
          if(window.getServerReturnedValue) {
            if(window.getServerReturnedValue()){
              if(window.postServerEventHandler){
                window.postServerEventHandler(jsonToSend.controlName,jsonToSend.eventType,response.data.responseData, renderFlag);
              }
              return response.data.responseData;
            }              
            else {
              if(window.postServerEventHandler){
                window.postServerEventHandler(jsonToSend.controlName,jsonToSend.eventType,response.data, renderFlag);
            };
            return response.data;
            }       
            
          }
          else {
            if(window.postServerEventHandler){
              window.postServerEventHandler(jsonToSend.controlName,jsonToSend.eventType,response.data, renderFlag);
            };
            return response.data;
          }
        }        
      }
    } else {
      executeServerEvent(jsonToSend,sync).then((response) => {
        if(response && response.data && response.data.status === "0"){
          if(response.data.error === "false")
          {
            var apiArray=response.data.APIData;
            // if(apiArray != null)
              renderExecuteServerEventAPIData({outputArray:apiArray,sync, renderFlag}, containerId)
            // .then(() => {
                if(window.getServerReturnedValue) {
                  if(window.getServerReturnedValue()){
                    if(window.postServerEventHandler){
                      window.postServerEventHandler(jsonToSend.controlName,jsonToSend.eventType,response.data.responseData, renderFlag);
                    }
                    window.loading(false);
                    if(renderFlag === true || renderFlag === "true"){
                      functions.updateJSON();
                      functions.beforeFormLoadJSON = {};
                    }
                    else{
                      window.loading(false)
                    }
                    return response.data.responseData;
                  }              
                  else {
                    if(window.postServerEventHandler){
                      window.postServerEventHandler(jsonToSend.controlName,jsonToSend.eventType,response.data, renderFlag);
                  };
                  window.loading(false);
                  if(renderFlag === true || renderFlag === "true"){
                    functions.updateJSON();
                    functions.beforeFormLoadJSON = {};
                  }
                  else{
                    window.loading(false)
                  }
                  return response.data;
                  }       
                  
                }
                else {
                  if(window.postServerEventHandler){
                    window.postServerEventHandler(jsonToSend.controlName,jsonToSend.eventType,response.data, renderFlag);
                  };
                  window.loading(false);
                  if(renderFlag === true || renderFlag === "true"){
                    functions.updateJSON();
                    functions.beforeFormLoadJSON = {};
                  }
                  else{
                    window.loading(false)
                  }
                  return response.data;
                }
              // });
          }
        }        
      })
    }

  },
  saveForm : function(flag,silentSaveFlag)
  {
    if(window.parent && window.parent.WFSave){
      window.parent.WFSave("save",silentSaveFlag);
      }
  },
  executeNavButton : function(action, passedFunction){
    if(action==="next"){
      document.querySelector("footer.wizard_h_footer button.nextButtonThemeStyle")?.addEventListener("click",passedFunction);
    }
    else if (action==="back"){
      document.querySelector("footer.wizard_h_footer button.backButtonThemeStyle")?.addEventListener("click",passedFunction);
    }
  },
  getAdditionParams: function(encryptMethod){
    const urlParams = new URLSearchParams(window.location.search);
    const additionalParam = urlParams.get('additionalParam');
    return additionalParam
  },
  fixElementIndex: function () {
    let formState = functions.getFormJsonFromStore();
    let count3 = 0;
    // updateRowNColumnOnSave(formState)
    const updateSheetFrameElementIndex = (child, count) => {
      if (Array.isArray(child)) {
        for (let item of child) {
          if (item.children) {
            item.sheetElementIndex = count+ "";
            updateSheetFrameElementIndex(item.children, count);
          }
          if (!item.children && item.elem_type !== 'row' && item.elem_type !== 'column') {
              item.sheetElementIndex = count+"";
              item.sheetFrameElementIndex = count3+"";
              if(!item.tileContents)
                count3++;
              if(item.tileContents) {
                for(const element of item.tileContents) {
                    element.sheetElementIndex = count + "";
                    element.sheetFrameElementIndex = count3 + "";
                    count3++;
                }
              }
              if(item.columnList) {
                let countNew = 0;
                for(const element of item.columnList) {
                  if(element.elementJson)
                    element.elementJson.elementIndex = countNew++;
                }
              }
          }
          
        }
      } else if (child.children) {
        updateSheetFrameElementIndex(child.children, count);
      }
    };
    let count2 = 0;
    const updateSheetElementIndex = (child) => {
      if (Array.isArray(child)) {
        for (let item of child) {
          let flag = false;
          if (!item.children && item.elem_type !== 'row' && item.elem_type !== 'column') {
            item.sheetElementIndex = count2 + "";
            if(!item.tileContents)
              count2++;
            if(item.tileContents) {
              for(const element of item.tileContents) {
                  element.sheetElementIndex = count2+"";
                  count2++;
              }
            }
            if(item.columnList) {
              let countNew = 0;
              for(const element of item.columnList) {
                if(element.elementJson)
                  element.elementJson.elementIndex = countNew++;
              }
            }
          } 
          else if((item.elem_type === 'row' || item.elem_type === 'column') && item.children) {
            if(item.sheetElementIndex)
              delete item.sheetElementIndex;
            updateSheetElementIndex(item.children);
          } 
          else if (item.children) {
              if(item.elem_type !== 'row' && item.elem_type !== 'column') {
                item.sheetElementIndex = count2 + "";
                flag = true;
                updateSheetFrameElementIndex(item.children, count2);
                count3 = 0;
                count2++;
              }
          }
        }
      } else if (child.children) {
        updateSheetFrameElementIndex(child.children, count2);
        count3 = 0;
      }
    };

    const updateFrameElementIndex = (child, frameIndex, elementIndex,type,stepIndex,subStepIndex) => {
      for (let item of child) {
            if (!item.children && item.id !== 'GroupInfo' && item.id !== 'Event') {
              if(item.tileContents) {
              for(let i = 0 ; i < item.tileContents.length; i++) {
                  item.tileContents[i][type] = elementIndex + "";
                  if(type === "stepIndex") {
                    item.subStepIndex = '-1';
                    item.subChildMenuIndex = '-1';
                  }
                  else if(type === "subStepIndex") {
                    item.subChildMenuIndex = "-1";
                  }
                  item.tileContents[i].frameIndex = frameIndex + "";
              }
            }
            item[type] = elementIndex+"";
            if(item.columnList) {
              let countNew = 0;
              for(const element of item.columnList) {
                if(element.elementJson)
                  element.elementJson.elementIndex = countNew++;
              }
            }
            if(type === "stepIndex") {
              item.subStepIndex = '-1';
              item.subChildMenuIndex = '-1';
            }
            else if(type === "subStepIndex") {
              item.stepIndex = stepIndex + '';
              item.subChildMenuIndex = "-1";
            }
            else if(type === "subChildMenuIndex") {
              item.stepIndex = stepIndex + '';
              item.subStepIndex = subStepIndex + '';
            }
            item.frameIndex = frameIndex+"";
        }
        if (item.children) {
          item[type] = elementIndex+"";
          if(type === "stepIndex") {
            item.subStepIndex = '-1';
            item.subChildMenuIndex = '-1';
          }
          else if(type === "subStepIndex") {
            item.stepIndex = stepIndex + "";
            item.subChildMenuIndex = "-1";
          }
          else if(type === "subChildMenuIndex") {
            item.stepIndex = stepIndex + '';
            item.subStepIndex = subStepIndex + '';
          }
          item.frameIndex = frameIndex + "";
          updateFrameElementIndex(item.children, frameIndex, elementIndex,type,stepIndex,subStepIndex);
        }
      }
    };

    const updateIndexInTab = (child,frameIndex,elementIndex) => {
      updateFrameElementIndex(child,frameIndex,elementIndex,"elementIndex");
      for (let i = 0; i < child.length; i++) {
        updateSheetId(child[i],i+"");
        updateSheetElementIndex(child[i].children);
        count2 = 0;
      }
    };

    const updateElementsInFrame = (child, frameIndex) => {
      for (let item of child) {
        if (item.elem_type === "tab") {
          item.elementIndex = count + "";
          if(frameIndex)
            item.frameIndex = frameIndex;
          updateIndexInTab(item.children, frameIndex,count);
          count++;
        }
        if (!item.children) {
          if(frameIndex)
            item.frameIndex = frameIndex;
          if(!item.tileContents) {
            item.elementIndex = count + "";
            count++;
          }
          if(item.tileContents) {
            for(const element of item.tileContents) {
                element.elementIndex = count+"";
                if(frameIndex)
                  element.frameIndex = frameIndex;
                count++;
            }
          }
          if(item.columnList) {
            let countNew = 0;
            for(const element of item.columnList) {
              if(element.elementJson)
                element.elementJson.elementIndex = countNew++;
            }
          }
        }
        if (item.children && item.elem_type !== 'tab') {
          if(item.elem_type === 'row' || item.elem_type === 'column') {
            if(frameIndex) {
              item.frameIndex = frameIndex; 
            }
          } 
          updateElementsInFrame(item.children,frameIndex);
        }
      }
    };

    const updateIsSubAdvCheck = (formState,isSubForm,isAdvanceListview) => {
      if(formState?.children) {
        for(let i = 0; i < formState.children.length; i++) {
            if(formState.children[i] && formState.children[i].id !== 'GroupInfo' && formState.children[i].id !== 'Event') {
              if(formState.children[i].elem_type?.toLowerCase() !== "column" && formState.children[i].elem_type?.toLowerCase() !== "row")
                formState.children[i].isSubForm = isSubForm; 
                formState.children[i].isAdvanceListview = isAdvanceListview; 
                updateIsSubAdvCheck(formState.children[i],isSubForm,isAdvanceListview);    
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
              updateIsSubAdvCheck(formState.children[i].subform,isSubForm,isAdvanceListview);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type === "advancelistView") {
              updateIsSubAdvCheck(formState.children[i].listviewFrameLayoutJson,isSubForm,isAdvanceListview);
            }    
            else {
              updateIsSubAdvCheck(formState.children[i],isSubForm,isAdvanceListview);
            }
        }
    }
  };


    const fixWizardIndexes = (child) => {
      for (let i = 0; i < child.length; i++) {
        if(!containsSubsteps(child[i],"substep") && !containsSubsteps(child[i],"submenu")) {
          if(child[i].elem_type === "MainMenu") {
            child[i].MainMenuIndex = i+"";
          }
          else {
            child[i].StepIndex = i+"";
            delete child[i].isTraversed;
          }
          child[i].stepIndex = i+"";
          for(let j = 0; j < child[i]?.children?.length; j++) {
            if(!child[i].children[j].subformName) {
              child[i].children[j].frameIndex = j+"";
              if(child[i].children[j].idNew)
                delete child[i].children[j].idNew;
              if(child[i]?.children[j]?.style?.sectionState)
               delete child[i].children[j].style.sectionState;
          
              updateFrameElementIndex(child[i]?.children[j]?.children, j, i,"stepIndex");
              updateElementsInFrame(child[i]?.children[j]?.children);
              count= 0;
            }
          }
        } else {
          for(let j = 0; j < child[i]?.children?.length; j++) {
            if(!containsSubsteps(child[i].children[j],"subchildmenu")) {
              if(child[i].elem_type === "MainMenu") {
                child[i].MainMenuIndex = i+"";
              }
              else {
                child[i].StepIndex = i+"";
                delete child[i].isTraversed;
              }

              if(child[i].children[j].elem_type === "SubMenu") {
                child[i].children[j].MainMenuIndex = i+"";
                child[i].children[j].SubMenuIndex = j+"";
              }
              else {
                child[i].children[j].StepIndex = i+"";
                child[i].children[j].SubStepIndex = j+"";
                delete child[i].children[j].isTraversed;
              }
              child[i].stepIndex = i+"";
              child[i].children[j].stepIndex = i+"";
              child[i].children[j].subStepIndex = j+"";
              for(let k = 0; k < child?.[i]?.children[j]?.children?.length; k++) {
                if(!child[i].children[j].children[k].subformName) {
                  child[i].children[j].children[k].frameIndex = k+"";
                  if(child[i].children[j].children[k].idNew)
                    delete child[i].children[j].children[k].idNew;
                  if(child[i]?.children[j]?.children[k]?.style?.sectionState)
                    delete child[i].children[j].children[k].style.sectionState;
                  updateFrameElementIndex(child[i]?.children[j]?.children[k]?.children,k,j,"subStepIndex",i);
                  updateElementsInFrame(child[i].children[j].children[k]?.children);
                  count=0;
                }
              }
            }
            else {
              for(let k = 0; k < child[i]?.children[j]?.children?.length; k++) {

                if(child[i].elem_type === "MainMenu") {
                  child[i].MainMenuIndex = i+"";
                }
                else {
                  child[i].StepIndex = i+"";
                }
  
                if(child[i].children[j].elem_type === "SubMenu") {
                  child[i].children[j].MainMenuIndex = i+"";
                  child[i].children[j].SubMenuIndex = j+"";
                }
                else {
                  child[i].children[j].StepIndex = i+"";
                  child[i].children[j].SubStepIndex = j+"";
                }
                
                if(child[i].children[j].children[k].elem_type === "SubChildMenu") {
                  child[i].children[j].children[k].MainMenuIndex = i+"";
                  child[i].children[j].children[k].SubMenuIndex = j+"";
                }
                
                child[i].stepIndex = i+"";
                child[i].children[j].stepIndex = i+"";
                child[i].children[j].subStepIndex = j+"";
                child[i].children[j].children[k].stepIndex = i+"";
                child[i].children[j].children[k].subStepIndex = j+"";
                child[i].children[j].children[k].subChildMenuIndex = k+"";
                for(let l = 0; l < child[i].children[j].children[k]?.children?.length;l++) {
                  if(!child[i].children[j].children[k].children[l].subformName) {
                    child[i].children[j].children[k].children[l].frameIndex = l+"";
                    updateFrameElementIndex(child[i].children[j].children[k].children[l]?.children,l,k,"subChildMenuIndex",i,j);
                    updateElementsInFrame(child[i].children[j].children[k].children[l]?.children);
                    count=0;
                  }
                }   
              }
            }
          }
        }
      }
    }

    let [allFrames,subformAdv,frameJSON] = findFrames(formState.children, [],{},{});
    let findWiz = findWizard(formState.children[1].children);
    var count = 0;
    let frameIndex = 0;
    let frameIndexSub = 0;
    let frameIndexAdv = 0;
    for (let frame of allFrames) {
      let result = findFrame(formState.children, frame);
      result.frameIndex = frameIndex + "";
      if(result?.style?.sectionState)
        delete result.style.sectionState;
      updateElementsInFrame(result.children,frameIndex+"");
      frameIndex++;
      count = 0;
    }
    for(let key in subformAdv) {
      for(let frame1 of subformAdv[key]) {
        let result = findFrame(formState.children, frame1);
        if(frameJSON[frame1]) {
          result.isSubForm = frameJSON[frame1]?.isSubForm;
          result.isAdvanceListview = frameJSON[frame1]?.isAdvanceListview;
          if(result?.style?.sectionState)
          delete result.style.sectionState;
          updateIsSubAdvCheck(result,frameJSON[frame1]?.isSubForm,frameJSON[frame1]?.isAdvanceListview);
        }
        if(result.isSubForm) {
          result.frameIndex = frameIndexSub + "";
          if(result?.style?.sectionState)
          delete result.style.sectionState;
          updateElementsInFrame(result.children,frameIndexSub+"");
          frameIndexSub++;
        }
        else if(result.isAdvanceListview) {
          result.frameIndex = frameIndexAdv + "";
          if(result?.style?.sectionState)
          delete result.style.sectionState;          
          updateElementsInFrame(result.children,frameIndexAdv+"");
          frameIndexAdv++;
        }
        count = 0;
      }
      frameIndexSub = 0;
      frameIndexAdv = 0;
    }
    if(findWiz) {
      fixWizardIndexes(findWiz.children);
    }
    updateRowNColumnOnSave(formState);
    functions.render = true;
    this.updateJSON(formState);
  }
}

const validChangeControlElemType = ['frame','section','wizard_v','wizard_h','sidenavigation','menu','submenu','subchildmenu','tab','sheet','step','substep', 'advancelistview', 'listview'];

const validControls = {
  "setFocus": ["textbox","password","textarea","datepick","listbox","combo","radio","checkbox","toggle","picklist","button","captcha","sheet","tile","doclist","slider","table","listview","advancelistView","advancelistview"],
  "showGridAddDeleteButtons": ["table","listview","advancelistView","advancelistview"], 
  "loadButtonIcon": ["button"],
  "showGridCheckBoxes": ["table","listview","advancelistView","advancelistview"], 
  "loadSectionIcon": ["frame"],
  "showGridMoreOptionsInHeader": ["table","listview","advancelistView","advancelistview"],
  "setMaskingPattern": ["textbox"],
  "addDataToDoclist": ["doclist","CustomControl"],
  "showHideDocumentTypes": ["doclist"],
  "setValueInDoclist": ["doclist"],
  "mandateDocTypes": ["doclist"],
  "clearDocList" : ["doclist"],
  "setReadOnlyStyleOnTextarea" : ["textarea"],
  "rearrangeTileContents": ["tile"],
  "reOrderControls":["frame"],
  "reOrderColumns": ["table","listview","advancelistView","advancelistview"],
  "disableGridModalButtons": ["listview","advancelistView","advancelistview"],
  "applyGridBatching": ["table","listview","advancelistView","advancelistview"],
  "setCustomPattern": ["textbox"],
  "getSectionState":["frame"],
  "setTileProperty": ["tile","CustomControl"],
  "setCustomMasking": ["textbox"],
  "setCustomMaskingInGrid": ["table","listview","advancelistView","advancelistview"],
  "setSheetCaption": ["tab"],
  "changeSectionCaption": ["frame"],
  "selectSheet": ["tab","menu"],
  "selectSheetByName": ["tab","menu"],
  "getSheetIndex": ["tab","menu"],
  "setPickListHeader": ["picklist"],
  "setDateRange": ["datepick"],
  "executeRouteJourney":["tile","button"],
  "setinputvalidation":["textbox"],
  "showMessageBelow":["textbox","combo","checkbox","doclist"],
  "setCaption":["label","slider","textbox","password","textarea","richtexteditor","datepick","listbox","CustomControl","frame",
  "combo","radio","checkbox","toggle","picklist","paragraph","report","iframe","captcha","tab","frame","sheet","textarea","table","listview","advancelistView","image","imagecarousel","button"],
  "removeError":["textbox","combo","checkbox","datepick","radio","doclist"],
  "helperTextExistsOrNot":["textbox","combo","checkbox","datepick","radio","doclist"],
  "addItemInRadio": ["radio"],
  "addItemInCombo": ["combo","listbox"],
  "removeItemFromCombo": ["combo","listbox"],
  "removeItemFromRadio": ["radio"],
  "getItemCountInCombo": ["combo","listbox"],
  "getComboOptions": ["combo", "listbox"],
  "getItemLabel": ["combo","listbox"],
  "getSelectedItemLabel": ["combo","listbox"],
  "getSelectedItemValue": ["combo","listbox"],
  "clearComboOptions": ["combo","listbox"],
  "clearRadio": ["radio"],
  "refreshFrame": ["frame"],
  "isSectionCompleted": ["frame"],
  "saveRichTextData": ["richtexteditor"],
  "getRichTextData": ["richtexteditor"],
  "setReport":["iframe"],
  "toggleRichTextEditor": ["richtexteditor"],
  "setCellLabelColor": ["listview","advancelistView","advancelistview"],
  "disableCheckboxColumn": ["table","listview","advancelistView","advancelistview"],
  "setCellBackgroundColor": ["listview","advancelistView","advancelistview"],
  "setCellStyle": ["table","listview","advancelistView","advancelistview"],
  "setCellBorderRadius": ["listview","advancelistView","advancelistview"],
  "disableCheckboxColumn": ["table","listview","advancelistView","advancelistview"],
  "setTableCellFocus": ["table","listview","advancelistView","advancelistview"],
  "setListviewModalHeader": ["listview","advancelistView","advancelistview"],
  "setCellButtonBGColor": ["table","listview","advancelistView","advancelistview"], 
  "setCellButtonCaption": ["table","listview","advancelistView","advancelistview"],
  "getCellButtonCaption": ["table","listview","advancelistView","advancelistview"],
  "getValueFromTable": ["table","listview","advancelistView","advancelistview"],
  "getValueFromTableCell": ["table","listview","advancelistView","advancelistview"],
  "setColumnVisible": ["table","listview","advancelistView","advancelistview"],
  "setColumnDisable": ["table","listview","advancelistView","advancelistview"], 
  "sortGridColumn": ["table","listview","advancelistView","advancelistview"], 
  "setColumnStyle": ["table","listview","advancelistView","advancelistview"], 
  "getValueFromColumnName": ["table","listview","advancelistView","advancelistview"],
  "displayTableCells1": ["table","listview","advancelistView","advancelistview"],
  "getSelectedRowsDataFromTable": ["table","listview","advancelistView","advancelistview"],
  "getGridRowCount": ["table","listview","advancelistView","advancelistview"],
  "deleteRowsFromGrid": ["table","listview","advancelistView","advancelistview"],
  "clearTable": ["table","listview","advancelistView","advancelistview"],
  "addBlankRowToTable": ["table","listview","advancelistView","advancelistview"],
  "addDataToGrid": ["table","listview"],
  "addDataToAdvancedGrid": ["advancelistView","advancelistview"],
  "getValue": ["label","slider","textbox","password","textarea","richtexteditor","datepick","listbox","CustomControl",
  "combo","radio","checkbox","toggle","picklist","paragraph","captcha","doclist"],
  "setValue": ["label","textbox","slider","password","textarea","richtexteditor","datepick","listbox","CustomControl",
  "combo","radio","checkbox","toggle","picklist","paragraph","captcha","tile","link"],
  "getFormattedValue" : ["textbox"],
  "clearValue": ["textbox","password","textarea","richtexteditor","datepick","listbox","CustomControl",
  "combo","radio","checkbox","toggle","picklist","paragraph","report","iframe","captcha","tab","frame","sheet","tile","doclist"],
  "setValues": ["label","textbox","password","textarea","richtexteditor","datepick","listbox","CustomControl",
  "combo","radio","checkbox","toggle","picklist","paragraph","link"],
  "setListViewTableData": ["listview","table"],
  "setMultipleTableCellData": ["table","listview","advancelistView","advancelistview"],
  "setTableCellData": ["table","listview","advancelistView","advancelistview"],
  "setTabStyle": ["tab"],
  "setTabStyleByName": ["tab"],
  "setCellDisabled1": ["table","listview","advancelistView","advancelistview"],
  "autoCompleteAPI": ["listbox","combo","textbox"],
  "reloadTabSheet": ["tab"],
  "setCellDisableTable": ["table"],
  "setCellDisabled": ["table","listview","advancelistView","advancelistview"],
  "setCellContentVisible": ["table","listview","advancelistView","advancelistview"],
  "setColumnHeaderVisible": ["table","listview","advancelistView","advancelistview"],
  "setTableColumnName": ["table","listview","advancelistView","advancelistview"],
  "setRowsDisabled": ["table","listview","advancelistView","advancelistview"],
  "setTableCellColor": ["table","listview","advancelistView","advancelistview"],
  "setRowColorInListView": ["table","listview","advancelistView","advancelistview"],
  "displayTableCells": ["table","listview","advancelistView","advancelistview"],
  "setRowSelectionInListView": ["table","listview","advancelistView","advancelistview"],
  "setRowDeSelectionInListView": ["table","listview","advancelistView","advancelistview"],
  "setCellImageInGrid": ["table","listview","advancelistView","advancelistview"],
  "setRowSelectionInGrid": ["table","listview","advancelistView","advancelistview"],
  "setTableCellDateRange": ["table"],
  "addItemInTableCellCombo": ["table","listview","advancelistView","advancelistview"],
  "removeItemFromTableCellCombo": ["table","listview","advancelistView","advancelistview"],
  "clearTableCellCombo": ["table","listview","advancelistView","advancelistview"], 
  "setRowStyle": ["table","listview","advancelistView","advancelistview"],
  "setButtonDropDown": ["button"]
}

const mappingValidation = (form, columnIndex, cellData) => {
  const cellDataType = typeof(cellData);
  const columnDataType = form?.columnList[columnIndex]?.style?.complexFieldType
  if (columnDataType === "String" || columnDataType === "NText" || !columnDataType) {
    return true;
  } else if (columnDataType === "Integer" || columnDataType === "Float" || columnDataType === "Long") {
    if (cellDataType === "number") {
      return true;
    } else if (cellDataType === "string") {
      if(cellData === "") {
        return true;
      }
      const parsedValue = Number(cellData);
      return !isNaN(parsedValue) && isFinite(parsedValue);
    } else if (cellDataType === "boolean") {
      return false ;
    }
  } else if (columnDataType === "Boolean") {
    if (cellDataType === "boolean") {
      return true;
    } else if (cellDataType === "string") {
      return cellData === "true" || cellData === "false";
    } else {
      return false
    }
  } else if (columnDataType === "shortDate" || columnDataType === "Short Date") {
    if(cellData === "") {
      return true;
    }
    if (cellDataType === "string") {
      const momentDateFormat = {
        1: "DD/MM/YYYY",
        2: "MM/DD/YYYY",
        3: "YYYY/MM/DD",
        4: "DD/MMM/YYYY"
      };
      if (moment(cellData, momentDateFormat[form?.columnList[columnIndex]?.style?.DateFormat] || "DD/MM/YYYY").isValid()) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if (columnDataType === "Date") {
    if(cellData === "") {
      return true;
    }
    if (cellDataType === "string") {
      const momentFormat = {
        5: "DD/MM/YYYY hh:mm",
        6: "MM/DD/YYYY hh:mm",
        7: "YYYY/MM/DD hh:mm",
        8: "DD/MMM/YYYY hh:mm"
      };
      if (moment(cellData, momentFormat[form?.columnList[columnIndex]?.style?.DateFormat] || "DD/MM/YYYY hh:mm").isValid()) {
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }
}


//common param types
const stringBools = z.stringbool({
  truthy: ["true"],
  falsy: ["false"],
});

const customBool = z.literal(["true", true, "false", false])

const controlIdSchema = z.string().min(1);

const allowedStyleAttributes = ["disable", "visible", "placeholder", "tooltip", "readonly", "readonlystyle", "lock", "custompattern", "charcase", "mandatory", "backcolor", "fontcolor", "allowdownload", "fontfamily", "sectionstate", "loadsection", "fontweight", "fontstyle", "fontsize", "maxlength", "minlength", "maxdateascurrent", "mindateascurrent", "bordercolor", "inactivestatecolor", "activestatecolor", "minimumvalue", "maximumvalue"]
const allowedTabStyleAttributes = ["backcolor","fontcolor","fontfamily","fontweight","fontstyle","fontsize","visible","disable","readonly","enable","readonlystyle"]
const allowedCellStyleAttributes = ["labelBackgroundColor", "labelFontColor", "labelBorderRadius"]


//define api param validation here in the form of a object
const apiValidationObjects = {
  deleteRowsfromgrid: z.object({
    tableId: controlIdSchema,
    rowIndices: z.array(z.coerce.number())
  }),
  setTileProperty: z.object({
    controlId: controlIdSchema, 
    tileIndex: z.coerce.number(),
    propertyName: z.literal(["title", "image", "description", "points", "button", "linkLabel", "linkUrl"]),
    propertyValue: z.union([z.string(),z.object(),z.array(),z.url()])
  }),
  setReadOnlyStyleOnTextarea : z.object({
    textareaId: controlIdSchema,
    typeOfReadOnly: z.literal([0, 1, 2]), //need to handle case insensitivity
    readOnlyFlag: customBool,
    charactersToBeShown:z.number().min(3).optional(),
  }),
  toggleRichTextEditor: z.object({
    textareaId: controlIdSchema,
    state: z.string().min(1)
  }),
  addDataToDoclist: z.object({
    docControlId: controlIdSchema,
    jsonArray: z.array(z.object({
      documentName: z.string().max(150, "Maximum Length for document type label is 150 characters"),
      UploadOption: z.literal([1,2,3]),
      documentMandatory: z.boolean(),
      commentsMandatory: z.boolean(),
      waiverRequired: z.boolean().optional(),
    })).nonempty()
  }),
  setRowStyle : z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    attributeName: z.literal(["disable", "visible"]), //need to handle case insensitivity
    attributeValue: customBool
  }),
  setValueImpl: z.object({
    controlName: controlIdSchema,
    controlValue: z.union([z.union([z.string(), z.number(), z.boolean()]), z.array(z.union([z.string(), z.number(), z.boolean()]))]),
  }),
  setValues: z.object({
    jsonObj: z.object(),
    sync: customBool.optional()
  }),
  setTableColumnName: z.object({
    tableId: controlIdSchema, 
    columnArray: z.array(z.object({
      columnIndex: z.coerce.number(), 
      columnName: z.string()
    }))
  }),
  reOrderColumns: z.object({
    controlId: controlIdSchema, 
    columnNames: z.array(z.string()).nonempty()
  }),
  setStyle: z.object({
    Id: controlIdSchema, 
    attribute: z.literal(allowedStyleAttributes), 
    value: z.union([z.boolean(), z.string(), z.number()]),
    frameJson: z.object().optional(),
    forcefull: customBool.optional()
  }),
  clearTable: z.object({
    controlId: controlIdSchema, 
    sync: customBool.optional()
  }),
  renameNavigationList: z.object({
    json: z.object(),
  }),
  showSplitMessage: z.object({
    messageTitle: z.string(), 
    message: z.string(), 
    alertType: z.literal(["error", "success", "warning", "info", "confirm"]), 
    isClose: customBool, 
    showIcon: customBool, 
    buttons: z.array(z.any()),
    placement: z.object(),
    duration: z.union([z.number(), z.null()]).optional(),
    styleObj: z.object().optional(),
  }),
  mandateDocTypes: z.object({
    docControlId: controlIdSchema, 
    documentType: z.string(), 
    mandateDocFlag: customBool
  }),
  clearDocList: z.object({
    doclistId: controlIdSchema
  }),
  uploadFilesInDoclist: z.object({
    
  }),
  showHideDocumentTypes: z.object({
    docControlId: controlIdSchema, 
    documentType: z.string(), 
    showHideFlag: customBool
  }),
  setCaption: z.object({
    controlId: controlIdSchema,
    Caption: z.string()
  }),
  setCellBackgroundColor: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    color: z.string()
  }),
  setCellLabelColor: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    color: z.string()
  }),
  setTableCellColor: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    color: z.union([z.string().regex(/^#(?:[0-9a-fA-F]{3}){1,2}$/), 
      z.string().regex(/^#(?:[0-9a-fA-F]{3,4}){1,2}$/),
      z.string().regex(/^(?:[0-9a-fA-F]{3}){1,2}$/), 
      z.string().regex(/^(?:[0-9a-fA-F]{3,4}){1,2}$/)])
  }),
  setCellBorderRadius: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    borderRadius: z.string()
  }), 
  setCellStyle: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    attributeName: z.literal(allowedCellStyleAttributes),
    attributeValue: z.string(),
  }), 
  addZone: z.object({
    zoneName: z.string(), 
    top: z.coerce.number(), 
    left: z.coerce.number(), 
    width: z.coerce.number(), 
    height: z.coerce.number(), 
    controlId: controlIdSchema
  }),
  setRowColorInListView: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    color: z.string()    
  }),
  setSheetCaption: z.object({
    tabId: controlIdSchema, 
    sheetIndex: z.coerce.number(), 
    caption: z.string()
  }),
  setTabStyle: z.object({
    tabId: controlIdSchema,
    index: z.coerce.number(), 
    attribute: z.literal(allowedStyleAttributes), 
    attributeValue: z.union([z.boolean(), z.string()])
  }),
  setStatusTag : z.object({
    controlId: controlIdSchema,
    StatusMsg: z.string(),
    Status: z.string()
  }),
  setColumnVisible: z.object({
    tableId: controlIdSchema,
    colIndex: z.coerce.number(),
    visibleFlag: customBool,
  }),
  setColumnDisable: z.object({
    tableId: controlIdSchema,
    colIndex: z.coerce.number(),
    disableFlag: customBool,
  }),
  sortGridColumn: z.object({
    tableId: controlIdSchema,
    colIndex: z.coerce.number(),
    sortOrder: z.enum(["A", "D"]),
  }),
  setColumnStyle: z.object({
    tableId: controlIdSchema,
    colIndex: z.coerce.number(),
    attributeName: z.string().min(1).max(50),
    attributeValue: z.union([z.string(), z.number(), z.boolean()]),
  }),
  addItemInComboImpl: z.object({
    comboId: controlIdSchema,
    label: z.string(),
    value: z.string(),
    tooltip: z.string().optional(),
    optionControlId: z.string().optional()
  }),
  addItemInRadioImpl: z.object({
    radioId: controlIdSchema,
    label: z.string(),
    value: z.string(),
    tooltip: z.string().optional(),
  }),
  removeItemFromRadioImpl: z.object({
    radioId: controlIdSchema, 
    itemIndexsArray: z.array(z.coerce.number())
  }),
  getComboOptions: z.object({
    comboId: controlIdSchema
  }),
  removeItemFromComboImpl: z.object({
    comboId: controlIdSchema,
    itemIndex: z.coerce.number()
  }),
  clearComboOptionsImpl: z.object({
    controlId: controlIdSchema,
    isClear: customBool,
    isCalledFromBackend: customBool.optional(),
  }),
  addItemInTableCellCombo: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    label: z.string(),
    value: z.string(),
    tooltip: z.string().optional(),
    optionControlId: z.string().optional(),
  }),
  removeItemFromTableCellCombo: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    itemIndex: z.coerce.number(),
  }),
  setCellDisabled: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    flag: customBool
  }),
  setCellContentVisible: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
    flag: customBool
  }),
  setColumnHeaderVisible: z.object({
    tableId: controlIdSchema, 
    columnIndex:  z.coerce.number(), 
    flag: customBool
  }),
  clearTableCellCombo: z.object({
    tableId: controlIdSchema,
    rowIndex: z.coerce.number(),
    colIndex: z.coerce.number(),
  }),
  getItemLabel: z.object({
    comboId: controlIdSchema,
    index: z.coerce.number()
  }),
  setButtonDropDown: z.object({
    controlId: controlIdSchema,
    jsonObj: z.object()
  })
}

const findFrames = (child,arr=[],subform={},frameJSON={},isSubForm=false,isAdvanceListview=false,id='') => {
  for(let item of child){
    if((item.elem_type === "frame" || item.elem_type === "headerframe") && !(item.sheetElementIndex || item.sheetElementIndex === 0 || item.sheetIndex || item.sheetIndex === 0 || item.sheetId || item.sheetId === 0 || item.stepIndex || item.stepIndex === 0 || item.subStepIndex || item.subStepIndex === 0 || item.subChildMenuIndex || item.subChildMenuIndex === 0)){
      if(isSubForm || isAdvanceListview) {
        if(subform[id]) 
          subform[id].push(item.id);
        else subform[id] = [item.id];
        frameJSON[item.id] = {
          isSubForm: isSubForm,
          isAdvanceListview: isAdvanceListview
        }
      }
      else {
        arr.push(item.id);
      }
    }
    if(item.children){
      if(isSubForm || isAdvanceListview) {
        findFrames(item.children,arr,subform,frameJSON,isSubForm,isAdvanceListview,id);
      } else {
        findFrames(item.children,arr,subform,frameJSON,false,false,'');
      }
    }
    if(item?.elem_type?.toLowerCase() === "button" && item.subform){
      findFrames(item.subform.children,arr,subform,frameJSON,true,false,item.id);
    }
    if(item?.listviewFrameLayoutJson && Object.keys(item.listviewFrameLayoutJson)?.length){
      findFrames(item.listviewFrameLayoutJson.children,arr,subform,frameJSON,false,true,item.id)
    }
  }
  return [arr,subform,frameJSON];
}

const findWizard = (child) => {
  var result;
  for(let item of child){
    if(item.id === "wizard"){
      result = item;
    }
  }
  return result;
}

const findFrame = (child,frameId,foundObj = {}) => {
  for(let item of child){
    if(item.id === frameId){
      console.log("ran")
      foundObj = item
      return foundObj
    }
    if(item.children){
      let result =  findFrame(item.children,frameId,foundObj)
      if(result){
        return result
      }
    }
    if(item?.elem_type?.toLowerCase() === "button" && item.subform){
      let result =  findFrame(item.subform.children,frameId,foundObj)
      if(result){
        return result
      }
    }
    if(item?.listviewFrameLayoutJson && Object.keys(item.listviewFrameLayoutJson)?.length){
      let result =  findFrame(item.listviewFrameLayoutJson.children,frameId,foundObj)
      if(result){
        return result
      }
    }
  }
}

const showHideDocumentTypes = (docControlId, documentType, showHideFlag) => {

  if(!validateParams(apiValidationObjects.showHideDocumentTypes, {docControlId, documentType, showHideFlag}, "showHideDocumentTypes")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON = recursiveJsonReader1(formjson,docControlId,'control');
  if(eleJSON) {
    if(validControls.showHideDocumentTypes.includes(eleJSON?.elem_type)) {
      if(eleJSON?.json) {
        if(eleJSON.json.available_doc_types && eleJSON.json.available_doc_types.length > 0) {
          for (let index = 0; index < eleJSON.json.available_doc_types.length; index++) {
              if(eleJSON.json.available_doc_types[index]?.name === documentType) {
                  if(showHideFlag === "true" || showHideFlag === true) 
                    eleJSON.json.available_doc_types[index].hideDocType = true;
                  else if(showHideFlag === "false" || showHideFlag === false) 
                    eleJSON.json.available_doc_types[index].hideDocType = false;

                  eleJSON.style.updateFormState = Date.now();
              }            
          }
          functions.render = true;
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
        }
        else {
          functions.showMess([documentType,"Not_Present"],"error");
        }
      }
      else {
        functions.showMess(["The_Control",docControlId,"Not_Present"],"error");
      }
    } else functions.showMess(["addDataToDoclist","Not_Valid",docControlId],"error");
  } else functions.showMess(["The_Control",docControlId,"Not_Present"],"error");
}

const addDataToDoclist = (docControlId, jsonArray) => {
  // jsonArray -->
  // [
  // {documentName,UploadOption,documentMandatory,commentsMandatory,waiverRequired},
  // {documentName,UploadOption,documentMandatory,commentsMandatory,waiverRequired }
  // ]
  // documentName- documenttype Name
  // UploadOption - 1 for Both camera and browse, 2 for Browse only, 3 for Camera only
  // documentMandatory - true/false
  // commentsMandatory - true/false
  // waiverRequired – true/false  --> not a feature

  if(!validateParams(apiValidationObjects.addDataToDoclist, {docControlId, jsonArray}, "addDataToDoclist")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON = recursiveJsonReader1(formjson,docControlId,'control');
  if(eleJSON) {
    if(validControls.addDataToDoclist.includes(eleJSON?.elem_type)) {
      if(eleJSON?.json) {
        if(eleJSON.json.available_doc_types && jsonArray?.length >0) {
          for (let index = 0; index < jsonArray.length; index++) {
            const docJson = {
              id: `${eleJSON?.json?.available_doc_types?.length + index + 1}`,
              name: jsonArray[index]?.documentName,
              mandatory: jsonArray[index]?.documentMandatory,
              doc_upload_options: {
                google_drive: false,
                camera: jsonArray[index]?.UploadOption === 1 || jsonArray[index]?.UploadOption == 3 ? true : false,
                scan: false,
                omnidocs: false,
                system: jsonArray[index]?.UploadOption === 1 || jsonArray[index]?.UploadOption == 2 ? true : false
              },
              mandatory_comments: jsonArray[index]?.commentsMandatory,
              allow_comment: jsonArray[index]?.commentsMandatory,
              allowed_file_types: [],
              description: "",
              max_file_size: 5000000,
              multiple_upload: true
            };
            eleJSON.json.available_doc_types.push(docJson);
          }
          eleJSON.style.updateFormState = Date.now();   
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }       
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          functions.render = true;
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      else {
        functions.showMess(["The_Control",docControlId,"Not_Present"],"error");
      }
    }
    else {
      functions.showMess(["addDataToDoclist","Not_Valid",docControlId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",docControlId,"Not_Present"],"error");
  }
};

const setValueInDoclist = (docControlId, value = []) => {
  var formjson = functions.getFormJsonFromStore();
  var eleJSON = recursiveJsonReader1(formjson,docControlId,'control');
  if(eleJSON) {
    if(validControls.setValueInDoclist.includes(eleJSON?.elem_type)) {
      eleJSON["value"] = value;
      eleJSON.style.sendUploadCall = Date.now();

      if(!notContainParent(eleJSON) && eleJSON?.id)
        functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
    else {
      functions.showMess(["setValueInDoclist","Not_Valid",docControlId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",docControlId,"Not_Present"],"error");
  }
};

const mandateDocTypes = (docControlId, documentType, mandateDocFlag) => {

  if(!validateParams(apiValidationObjects.mandateDocTypes, {docControlId, documentType, mandateDocFlag}, "mandateDocTypes")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON = recursiveJsonReader1(formjson,docControlId,'control');
  if(eleJSON) {
    if(validControls.showHideDocumentTypes.includes(eleJSON?.elem_type)) {
      if(eleJSON?.json) {
        if(eleJSON.json.available_doc_types && eleJSON.json.available_doc_types.length > 0) {
          for (let index = 0; index < eleJSON.json.available_doc_types.length; index++) {
              if(eleJSON.json.available_doc_types[index]?.name === documentType) {
                  if(mandateDocFlag === "true" || mandateDocFlag === true) 
                    eleJSON.json.available_doc_types[index].mandatory = true;
                  else if(mandateDocFlag === "false" || mandateDocFlag === false) 
                    eleJSON.json.available_doc_types[index].mandatory = false;

                  eleJSON.style.updateFormState = Date.now();
              }            
          }
          functions.render = true;
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
        }
        else {
          functions.showMess([documentType,"Not_Present"],"error");
        }
      }
      else {
        functions.showMess(["The_Control",docControlId,"Not_Present"],"error");
      }
    } else functions.showMess(["mandateDocTypes","Not_Valid",docControlId],"error")
  }
  else functions.showMess(["The_Control",docControlId,"Not_Present"],"error");
}

const clearDocList = (doclistId) => {

  if(!validateParams(apiValidationObjects.clearDocList, {doclistId}, "clearDocList")) return;

  const containerId = getContainerId()
  const contexts = getGlobalContext(containerId);
  const { builderMode } = contexts;
  let formjson = functions.getFormJsonFromStore();
  let eleJSON = recursiveJsonReader1(formjson,doclistId,'control');
  const isPortal = builderMode === "application";
  if(window.callBackFunction) {
    if(eleJSON) {
      if(validControls.clearDocList && validControls.clearDocList.includes(eleJSON?.elem_type)) {
        if(eleJSON?.value) {
          const payload = {
            doc_index: "",
            is_index: "",
            multi_delete: true
          }
          const docIndexTemp = []
          eleJSON.value.forEach((doc, index) => {
            const valueToAdd = isPortal ? doc?.i_s_index : doc?.id
            if(valueToAdd) {
              docIndexTemp.push(valueToAdd);
            }
          })
          payload.doc_index = docIndexTemp.join(",")
          payload.is_index = payload.doc_index;
          
          window.callBackFunction("delete", payload)
        }
        else {
          functions.showMess(["The_Control",doclistId,"Not_Present"],"error");
        }
      } else functions.showMess(["The_Control","Not_Valid",doclistId],"error")
    } else functions.showMess(["The_Control",doclistId,"Not_Present"],"error");
  } else {
    functions.showMess(["The_Control",doclistId,"Not_Present"],"error");
  }
}

const checkAllMandatoryFields = (jsonData, result) => {
  if(jsonData != undefined && jsonData != null)
  {
    if(Array.isArray(jsonData)){
      jsonData.forEach((item,index)=>{
        if(item.elem_type){
          if(item.elem_type === "frame" || item.elem_type === "row" || item.elem_type === "column")
          {
          if(Object.keys(item).includes("children")){
            checkAllMandatoryFields(item.children, result);
          }
          } 
          else if(item.elem_type && (item.elem_type === "tile"))
          {
          if(Object.keys(item).includes("tileContents")){
            checkAllMandatoryFields(item.tileContents, result);
          }
          }
          else if(item.elem_type!==undefined && item.elem_type !== "row" && item.elem_type !== "column"){
            let value;
            if(item.style["Mandatory"] && item.style["Mandatory"] === "true") {
              if(item.elem_type && (item.elem_type === "tile")) 
                value = item.selectedTile;
              else if(item.elem_type && (item.elem_type === "combo")){
                if(item.value) 
                  value = item.value.value;
              }
              else if(item.elem_type && (item.elem_type === "listbox")){
                var valueArr=[];
                if(item.value)
                {
                  var tempList = item.value;
                  for(var i=0;i<tempList.length;i++)
                  {
                    valueArr.push(tempList[i].value);
                  }
                }
                value = valueArr;
              }
              else{
                value = item.value;
              }
              if(value === undefined || value === null || value?.length === 0 || value === ""){
                result = false;
              }
              
            }
          }
        }
      })
    }
  }
  return result;
}

const getAllMandatoryFields = (jsonData, result) => {
  if(jsonData != undefined && jsonData != null)
  {
    const errorState = getErrorState();
    if(Array.isArray(jsonData)){
      jsonData.forEach((item,index)=>{
        if(item.elem_type){
        if(item.elem_type === "frame" || item.elem_type === "row" || item.elem_type === "column" || item.elem_type === "tab")
        {
          if(Object.keys(item).includes("children")){
            getAllMandatoryFields(item.children, result);
          }
        } 
        else if(item.elem_type === "tile")
        {
          if(Object.keys(item).includes("tileContents")){
            getAllMandatoryFields(item.tileContents, result);
          }
        }
        else if(item.elem_type!==undefined && item.elem_type !== "row" && item.elem_type !== "column"){
          let value;
          let res = {};
          const validation = ((item?.style?.Enable !== "false" && item?.style?.Enable !== false) || item?.style?.EnableMandatoryOnDisable === true || item?.style?.EnableMandatoryOnDisable === "true") && ((item?.style?.ReadOnly !== "true" && item?.style?.ReadOnly !== true) || item?.style?.EnableMandatoryOnDisable === true || item?.style?.EnableMandatoryOnDisable === "true") && ((item?.style?.ReadOnlyStyle !== "true" && item?.style?.ReadOnlyStyle !== true) || item?.style?.EnableMandatoryOnDisable === true || item?.style?.EnableMandatoryOnDisable === "true") && (item?.style?.Visible !== false && item?.style?.Visible !== "false");
          if(item?.style?.["Mandatory"] && item?.style?.["Mandatory"] === "true" && validation) {
            res["ControlId"] = item.id;
            if(item.elem_type === "tile"){
              value = item.selectedTile;
            } else if(item.elem_type === "combo") {
              if(item.value) 
                value = item.value;
            } else if(item.elem_type === "listbox") {
              value = item.value;
            }
            else
              value = item.value;
           if (errorState?.length > 0 && errorState?.includes(item.id)) {
                  res["Validate"] = false;
              } else {
                if (
                  value === undefined ||
                  value === null ||
                  value === false ||
                  value?.length === 0 ||
                  value === "" ||
                  value === "false"
                ) {
                  res["Validate"] = false;
                } else {
                  res["Validate"] = true;
                }
              }
            result.push(res);
          }
        }
      }
      })
    }
  }
  return result;
}


const parseAndSetStyleInTabControls = (jsonData,attributeName,attributeValue) => {
  if(jsonData != undefined && jsonData != null)
  {
    if(Array.isArray(jsonData)){
      jsonData.forEach((item,index)=>{
         if(item.elem_type ==="frame" || item.elem_type == "row" || item.elem_type == "column")
         {
          if(Object.keys(item).includes("children")){
            parseAndSetStyleInTabControls(item.children,attributeName,attributeValue);
          }
         } 
         else if(item.elem_type ==="tile")
         {
          if(Object.keys(item).includes("tileContents")){
            parseAndSetStyleInTabControls(item.tileContents,attributeName,attributeValue);
          }
         }
         else if(item.elem_type != "row" && item.elem_type != "column" && validControls.setValues.includes(item.elem_type)){
            if(isValidElement(item.elem_type))
            {
              if(attributeName.toLowerCase()==='enable'){
              if(attributeValue === "true" || attributeValue === true) {
                item.style.Enable = "true";
                item.style.Editable  = "true";
              } else if(attributeValue === "false" || attributeValue === false) {
                item.style.Enable = "false";
                item.style.Editable  = "false";
              } }
              else{
              item.style[attributeName] = attributeValue;
              }
            }
        }
      })
    }
  }
}

const clearValueImpl = async (controlId,sync) =>{
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,controlId,'control');

  if(eleJSON) {
    if(validControls.clearValue.includes(eleJSON?.elem_type)) {
      eleJSON.calledFromAPI = true;

      if(eleJSON?.elem_type === "frame" || eleJSON?.elem_type === "tab" || eleJSON?.elem_type === "sheet") 
      {
         var childAray=eleJSON.children;
         parseChildrenArray(childAray);
      }
      else{
        let isClearValueOfCombo = true;
        if(window.clearComboOnLoad){
          isClearValueOfCombo = window.clearComboOnLoad(controlId);
        }
        if(eleJSON?.elem_type === "combo") {
          if(isClearValueOfCombo) {
            var jsonObj={};
            var value=getClearedValue(eleJSON?.elem_type);
            jsonObj[controlId]=value;
            if(sync)
              await setValuesImpl(jsonObj, sync);
            else setValuesImpl(jsonObj);
          }
        }
        else if(eleJSON?.elem_type === "doclist") {
          let docImageIndex = ''
          eleJSON?.value?.map((item,index) => { docImageIndex += index === eleJSON?.value?.length - 1 ? `${item?.["i_s_index"]}` : `${item?.["i_s_index"]},`});            
          let docIndexes = docImageIndex?.split(",");
          if(docIndexes.length) {
            if(sync){
              const response = deleteDoc({controlId, docImageIndex},sync);
              if(response.status === 200) {
                eleJSON.value = [];
                eleJSON?.json?.["available_doc_types"]?.forEach((item) => {
                  const nextDocManid = (Array.isArray(item?.docManid) ? item.docManid : item?.docManid ? [item.docManid] : []).filter((item2) => !docIndexes.includes(item2));
                  item.docManid = nextDocManid;
                  if (!item?.docManid?.length && item?.mandatory) {
                    item.isUploaded = false;
                  }
                });
              }
             } else {
                deleteDoc({controlId, docImageIndex},sync).then((res) => {
                if(res.status === 200) {
                  eleJSON.value = [];
                  eleJSON?.json?.["available_doc_types"]?.forEach((item) => {
                    const nextDocManid = (Array.isArray(item?.docManid) ? item.docManid : item?.docManid ? [item.docManid] : []).filter((item2) => !docIndexes.includes(item2));
                    item.docManid = nextDocManid;
                    if (!item?.docManid?.length && item?.mandatory) {
                      item.isUploaded = false;
                    }
                  });
                  formStateStore.dispatch(updateStateInRedux({"name": "clearDoclist", value: controlId}));
                }
              })
            }
          }
        }
        else {
          var jsonObj={};
          var value=getClearedValue(eleJSON?.elem_type);
          jsonObj[controlId]=value;
          if(sync)
            await setValuesImpl(jsonObj, sync);
          else setValuesImpl(jsonObj);
        }
      }

      eleJSON.style.updateFormState = Date.now();
      functions.render = true;
    }
    else {
      functions.showMess(["clearValue","Not_Valid",controlId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
}

const isValidElement = (elementType) => {
   const eleArray=[
     'textbox',
     'textarea',
     'richtexteditor',
     'datepick',
     'slider',
     'listbox',
     'combo',
     'tile',
     'checkbox',
     'radio',
     'toggle',
     'picklist',
     'button',
     'label',
     'paragraph',
     'link'
   ];
   if(eleArray.includes(elementType))
   return true;
   else
   return false;
}
const getClearedValue = (elementType) =>{
    if(elementType === "listbox" || elementType === "tile" )
    return [];
    else if(elementType === "checkbox" || elementType === "toggle" || elementType === "tile")
    return false
    else if(elementType === "CustomControl")
    return 0;
    else
    return "";
}
const setValuesImpl = (jsonObj,sync) => {

  if(!validateParams(apiValidationObjects.setValues, {jsonObj, sync}, "setValues")) return;

  var formjson = functions.getFormJsonFromStore();

  var attrTypes ={};
  var customJSON = {};
  var key;
  // var controlIds = {}

  var updatedFormstateJson= {...formjson};
  var labelKeys = new Set();
  
  for(key in jsonObj){   
    var eleJSON=recursiveJsonReader1(formjson,key,'control'); 
    if(eleJSON){
      var attrName = key
    // var attrName = eleJSON?.dataclass;
    // if(attrName == undefined || attrName == null || attrName=="")
    //   attrName = eleJSON.id;
    if(eleJSON?.elem_type=='listbox') {
      // setValueImpl(key, jsonObj[key], undefined, updatedFormstateJson);
      var lbJSON = {};
      for(var i=0;i<jsonObj[key].length;i++){
        lbJSON[i] = jsonObj[key][i];
      }
      customJSON[attrName] = lbJSON;
      attrTypes[attrName] = "listbox";
    }
    else{
      if(eleJSON?.elem_type=='picklist' && eleJSON?.style?.AllowMultipleSection == "true" && jsonObj[key] == "") {
        eleJSON.style.PicklistSelectedAllNames = {}
        eleJSON.style.PicklistSelectedAll = {}
      }
      // setValueImpl(key, jsonObj[key], undefined, updatedFormstateJson);
      customJSON[attrName] = jsonObj[key];
      if(eleJSON?.elem_type?.includes("date"))
      attrTypes[attrName] = "date";
      else{
        attrTypes[attrName] = "text";
      }
    }
  }
  else if(key.endsWith("_label")) {
    labelKeys.add(key);
    functions.setCaption(key.slice(0, -"_label".length), jsonObj[key]);
  }
  else {
    functions.showMess(["The_Control",key,"Not_Present"],"error");
  }
  }
  var jsonString = JSON.stringify(customJSON);
  var attrTypesJSONString =  JSON.stringify(attrTypes);
  var jsonToSend={};
  jsonToSend.jsonString=jsonString;
  jsonToSend.attrTypesJSONString=attrTypesJSONString;
  if(sync) {
    const response = setValues(jsonToSend,sync);
    console.log("setValues sync response1", response);
    if(response && response?.failed && response?.controlName){
      functions.showMess(["The_Control",`${response?.controlName}`, `with ${response?.errorMessage}`, `but given ${response?.controlValue}`],"error");
    }
    else if(response && response?.failed){
      functions.showMess(["There is some error with setValues API"],"error");
    }
    else{
      let key;
      for(key in jsonObj){   
        if(labelKeys.has(key)) continue;
        var eleJSON=recursiveJsonReader1(formjson,key,'control'); 
        if(eleJSON){
          // controlIds[eleJSON?.id] = eleJSON?.value
          var attrName = key
        // var attrName = eleJSON?.dataclass;
        // if(attrName == undefined || attrName == null || attrName=="")
        //   attrName = eleJSON.id;
        if(eleJSON?.elem_type=='listbox') {
          setValueImpl(key, jsonObj[key], undefined, updatedFormstateJson);
        }
        else{
          setValueImpl(key, jsonObj[key], undefined, updatedFormstateJson);
        }
        }
        else {
          functions.showMess(["The_Control",key,"Not_Present"],"error");
        }
      }
    }
  }
  else {
    setValues(jsonToSend).then((response) => {
      console.log("setValues async response2", response)
      if(response && response?.status === 200){
        let key;
        for(key in jsonObj){   
          if(labelKeys.has(key)) continue;
          var eleJSON=recursiveJsonReader1(formjson,key,'control'); 
          if(eleJSON){
            // controlIds[eleJSON?.id] = eleJSON?.value
            var attrName = key
          // var attrName = eleJSON?.dataclass;
          // if(attrName == undefined || attrName == null || attrName=="")
          //   attrName = eleJSON.id;
          if(eleJSON?.elem_type=='listbox') {
            setValueImpl(key, jsonObj[key], undefined, updatedFormstateJson);
          }
          else{
            setValueImpl(key, jsonObj[key], undefined, updatedFormstateJson);
          }
          }
          else {
            functions.showMess(["The_Control",key,"Not_Present"],"error");
          }
        }
      }
      else{
        functions.showMess(["There is some error with setValues API"],"error");
      }
    }).catch(err => {
          console.log("setValues async error response3", err)
          if(err?.response?.status === 400 && err?.response?.data?.error === "true" && err?.response?.data?.controlName){
            functions.showMess(["The_Control",`${err?.response?.data?.controlName}`, `with ${err?.response?.data?.errorMessage}`, `but given ${err?.response?.data?.controlValue}`],"error");
          }
          else{
            functions.showMess(["There is some error with setValues API"],"error");
          }
        }); 
  }
  functions.render = true;
}
const setStatusTagImpl=(controlId,StatusMsg,Status)=>{

  if(!validateParams(apiValidationObjects.setStatusTag, {controlId,StatusMsg,Status}, "setStatusTag")) return;

  var id=controlId+"_statustag";
  if(document.getElementById(id) != null)
  {
      $('#'+id).removeClass();
      Status=Status.toLowerCase();
      if(Status=="positive")
  {
      $('#'+id).addClass('statustagPositive');
     
  }
  else if(Status == "negative")
  {
      $('#'+id).addClass('statustagNegative');
      
  }
  else if(Status=="neutral")
  {
       $('#'+id).addClass('statustagNetural');
     
  }
      $('#'+id).html(StatusMsg);
  }
  else{
  var htmlValue="<span id='"+id+"' class='";
  Status=Status.toLowerCase();
  if(Status=="positive")
  {
      htmlValue=htmlValue+"statustagPositive'>";
  }
  else if(Status == "negative")
  {
      htmlValue=htmlValue+"statustagNegative'>";
  }
  else if(Status=="neutral")
  {
      htmlValue=htmlValue+"statustagNetural'>";
  }
  htmlValue=htmlValue+StatusMsg+"</span>";
 var tempid='#'+controlId+"_label";
 $(tempid).append(htmlValue);
 }
}

function removeIdFromMandatoryControl2(id,value){
  const mandatoryControls = formStateStore.getState()?.mandatoryControls;
  if(mandatoryControls.includes(id)){
    if(value === true || value === "true" || value){
          const newMandatoryList = mandatoryControls.filter((item)=>item !== id)
          setMandatoryControls1([...newMandatoryList])
      }
  }
}

const validDate = (date) => {
  if(date?.includes('.') || date?.includes('/'))
    return false;
  if(date?.includes("-")) {
    const arr = date.split("-");
    if(arr?.length === 3) {
      if (arr[2]?.includes(",")) {
        const days = arr[2]?.split(", ");
        const time = days[1]?.split(":");
        if (
          arr[0]?.length === 4 &&
          arr[1]?.length === 2 &&
          days[0]?.length === 2 &&
          time?.length === 2 &&
          time[0]?.length === 2 &&
          time[1]?.length === 2 &&
          !isNaN(arr[0]) &&
          !isNaN(arr[1]) &&
          !isNaN(days[0]) &&
          !isNaN(time[0]) &&
          !isNaN(time[1])
        )
          return true;
          else {
            return false
          };
      } else {
        if (
          arr[0]?.length === 4 &&
          arr[1]?.length === 2 &&
          arr[2]?.length === 2 &&
          !isNaN(arr[0]) &&
          !isNaN(arr[1]) &&
          !isNaN(arr[2])
        )
          return true;
          else {
            return false
          };
        }
    }
    else {
      return false
    };
  }
  else {
    return false
  };
};
function isDateInRange(eleJSON, newValue, format){
  console.log("isDateInRange", window?.psh_configs?.selectedLanguage)
  moment.locale(window?.psh_configs?.selectedLanguage)
  if(eleJSON?.style?.MaxDateAsCurrent == "false" && eleJSON?.style?.MaxDate == "" && eleJSON?.style?.MinDate == ""){
    return true;
  }
  else
    {
    // let date = moment(newValue, format, true).toDate();
    let momResult = moment(newValue, format, true);
    if(!momResult?.isValid()) {
      console.log("Parsing flags -> ",momResult?.parsingFlags());
    }
	  let date = momResult?.toDate();
    let currMaxDate = new Date(8640000000000000);
    let currMinDate = new Date(new Date(-8640000000000000));
    if((eleJSON.style?.MaxDateAsCurrent == false || eleJSON.style?.MaxDateAsCurrent == "false") && (eleJSON.style?.MaxDate != "")){
      currMaxDate = moment(eleJSON.style?.MaxDate, "YYYY-MM-DD").toDate();
    }
    if(eleJSON.style?.MaxDateAsCurrent == true || eleJSON.style?.MaxDateAsCurrent == "true"){
      currMaxDate = new Date();
      currMaxDate.setHours(0, 0, 0, 0);
    }
    if((eleJSON.style?.MinDate != "") && (eleJSON.style.MinDateAsCurrent == false || eleJSON.style.MinDateAsCurrent == "false")){
      currMinDate = moment(eleJSON.style?.MinDate, "YYYY-MM-DD", true).toDate();
      currMinDate.setHours(0, 0, 0, 0);
    }
    date.setHours(0, 0, 0, 0);
    if (date <= currMaxDate && date >= currMinDate) {
      // eleJSON.value = newValue;
      return true;
    }
    else {
      // functions.showMess(["Invalid_Date_Range"],"error");
      return false;
    }
  }
}
const setValueImpl = (controlName, controlValue,containerId , formjson) => {

  if(!validateParams(apiValidationObjects.setValueImpl, {controlName, controlValue}, "setValue")) return;
  
  if(!formjson){
    formjson = functions.getFormJsonFromStore(containerId);
  }
  var eleJSON=recursiveJsonReader1(formjson,controlName,'control');
  if(eleJSON){
    if(validControls.setValue.includes(eleJSON?.elem_type)) {
      if(eleJSON?.elem_type === "combo") {
        if(eleJSON?.value === controlValue){
          return
        }
        var optionList=eleJSON.options;
        if(controlValue == "")
        {
          eleJSON.value="";
        } else {
          let found = false ;
          for(var i=0;i< optionList.length;i++)
          {
            if(optionList[i]?.value === controlValue){
              eleJSON.value = controlValue;
              found = true;
              console.log("inside setValueImpl1 combo1", optionList, eleJSON)
              break;
            }
          }
           if (!found) {
        functions.showMess(["option_is_not_present_in", controlName], "error");
      }
          console.log("inside setValueImpl1 combo", optionList, eleJSON)
        }
      } 
      else if(eleJSON?.elem_type === "listbox") {
        var optionList=eleJSON.options;
       if(controlValue == "")
        {
          if(eleJSON?.value == controlValue){
            return
          }
          eleJSON.value="";
        } else {
          var valueArr=[];
          for(var j=0;j<controlValue.length;j++) {
            for(var i=0;i< optionList.length;i++) {
              if(optionList[i]?.value === controlValue[j]) {
                valueArr.push(controlValue[j]);
                break;
              }
            }
          }
          if(eleJSON?.value && Array.isArray(eleJSON?.value)){
            let d = eleJSON?.value.length === controlValue.length && eleJSON?.value?.every((val, i) => val === controlValue[i])
            if(d){
              return
            }
          }
          eleJSON.value=valueArr;
        }
      } 
      else if(eleJSON?.elem_type === "label") {
        if(eleJSON.style){
          if(eleJSON.value === controlValue){
            return
          }
          eleJSON.style.Label = controlValue;
          eleJSON.value = controlValue;
        }
    }
    else if(eleJSON?.elem_type === 'link') {
      if(eleJSON.style)
        eleJSON.style.LinkURL = controlValue;
      else {
        eleJSON.style = {};
        eleJSON.style.LinkURL = controlValue;
      }
    }

    else if (eleJSON?.elem_type === "textbox" || eleJSON?.elem_type === "textarea") {
      let d = controlValue + "";
      // Check if the same value already exists
      if(eleJSON?.value === d){
        return
      }
      
      const varType = eleJSON?.datamapVariableType;
      const isInteger = varType === "Integer";
      const isFloat = varType === "Float";
      const isLong = varType === "Long";

      const isValidInteger = controlValue !== undefined && /^-?\d+$/.test(controlValue);
      const isValidFloat = controlValue !== undefined && /^-?\d+(\.\d+)?$/.test(controlValue);
      const isDefined = controlValue !== undefined && controlValue !== null && controlValue !== "";
      if (isInteger) {
        if (!isDefined || isValidInteger) {
          eleJSON.value = isDefined ? (controlValue + "") : "";
        } else {
          eleJSON.value = "";
          functions.showMess(["Invalid_Value"], "error");
          return;
        }
      } else if (isFloat) {
        if (!isDefined || isValidFloat) {
          if (isDefined) {
            const valueStr = controlValue + "";
            const hasDecimal = valueStr.includes('.');
            if (eleJSON?.datamapPercision !== undefined && eleJSON?.datamapPercision !== 0) {
              eleJSON.value = hasDecimal ? valueStr : parseFloat(valueStr).toFixed(eleJSON.datamapPercision);
            } else {
              eleJSON.value = hasDecimal ? valueStr : parseFloat(valueStr).toFixed(2);
            }
          } else {
            eleJSON.value = "";
          }
        } else {
          eleJSON.value = "";
          functions.showMess(["Invalid_Value"], "error");
          return;
        }
      }
      if (isLong) {
        if (!isDefined || isValidInteger) {
          eleJSON.value = isDefined ? (controlValue + "") : "";
        } else {
          eleJSON.value = "";
          functions.showMess(["Invalid_Value"], "error");
          return;
        }
      }
      else {
        eleJSON.value = controlValue + "";
      }

      console.log("inside setValueImpl1 text", eleJSON);

      if (eleJSON?.controlName === "richtexteditor") {
        eleJSON.updateFormStateRichtext = Date.now();
      }

      console.log("inside setValueImpl1 text", eleJSON);
    }
      else if(eleJSON?.elem_type === "datepick") {
        
        let updatedValue = controlValue;
        let newValue = controlValue;
        const formState2 = functions.getFormJsonFromStore(); 
        const controlThemeData = formState2.theme?.['InputStyle']
        let newDateFormat = eleJSON.style["DateFormat"] || (eleJSON?.style?.PickerType === "1" ? controlThemeData?.['ThemeDateFormat'] : eleJSON?.style?.PickerType === "2" ? controlThemeData?.['ThemeDateFormat2'] : controlThemeData?.['ThemeDateFormat']);
        let dateSeprator =controlThemeData?.["DateSeperator"] === "1" ? "/" : controlThemeData?.["DateSeperator"] === "2" ? "-" :controlThemeData?.["DateSeperator"] === "3" ?"." :"/"
        let dateTimeSeprator =controlThemeData?.["DateTimeSeperator"] === "1" ? "/" : controlThemeData?.["DateTimeSeperator"] === "2" ? "-" :controlThemeData?.["DateTimeSeperator"] === "3" ?"." :"/"
        if(updatedValue){
          newValue = isDate(updatedValue, newDateFormat, dateSeprator, dateTimeSeprator)
        }
        if (newValue === null) {
          if(eleJSON?.apiValue === newValue && eleJSON?.value === newValue){
            return
          }
          eleJSON.apiValue = null;  
          eleJSON.value = null;    
      }
       else if(newValue && newValue !== "Invalid_Date") {
        // let a = validDate(newValue) 
        // console.log("validDate", a, newValue)
        // if(validDate(newValue)) {
        //   if(eleJSON?.style?.PickerType == '2') {
        //     if(!newValue.includes(',')) {
        //       if(newValue.includes('.')) {
        //         newValue = newValue.substring(0, newValue.indexOf("."));
        //       }
        //       // else {
        //         const position = newValue.length - 9;
        //         updatedValue = [newValue.slice(0, position), ',', newValue.slice(position)].join('');
        //       // }
        //     }
        //     updatedValue = updatedValue.substring(0, updatedValue.length - 3);
        //   }
        //   eleJSON.apiValue = updatedValue;
        // }
        // else {
            let dateArr = newValue.split(dateSeprator)
            let dateTimeArr = newValue.split(dateTimeSeprator)
            if(newDateFormat === "1"){
              if(moment(newValue, `DD${dateSeprator}MM${dateSeprator}YYYY`).isValid() && isDateInRange(eleJSON, newValue, `DD${dateSeprator}MM${dateSeprator}YYYY`)){
                if(eleJSON?.value === newValue){
                  return
                }  
                eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
            } else if(newDateFormat === "2"){
              if(moment(newValue, `MM${dateSeprator}DD${dateSeprator}YYYY`).isValid() && isDateInRange(eleJSON, newValue, `MM${dateSeprator}DD${dateSeprator}YYYY`)){
                if(eleJSON?.value === newValue){
                  return
                }
                  eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
      
            } else if(newDateFormat === "3"){
              if(moment(newValue, `YYYY${dateSeprator}MM${dateSeprator}DD`).isValid() && isDateInRange(eleJSON, newValue, `YYYY${dateSeprator}MM${dateSeprator}DD`)){
                if(eleJSON?.value === newValue){
                  return
                }  
                eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
            } else if(newDateFormat === "4"){
              const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
              let flag42 = 0
              let q = isNaN(dateArr[0])
              let r = isNaN(dateArr[2])
              for(let i of months){
                if(i === dateArr[1] && !q && (1 <= parseInt(dateArr[0]) <= 12) && !r && dateArr[2].length === 4){
                  flag42 = 1
                }
              }
              if(flag42 === 1 && isDateInRange(eleJSON, newValue, `DD${dateSeprator}MMM${dateSeprator}YYYY`)){
                if(eleJSON?.value === newValue){
                  return
                }  
                eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
            } else if(newDateFormat === "5"){
              if(moment(newValue, `DD${dateTimeSeprator}MM${dateTimeSeprator}YYYY, hh:mm`).isValid() && isDateInRange(eleJSON, newValue, `DD${dateTimeSeprator}MM${dateTimeSeprator}YYYY, hh:mm`)){
                if(eleJSON?.value === newValue){
                  return
                }
                eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
            } else if(newDateFormat === "6"){
              if(moment(newValue, `MM${dateTimeSeprator}DD${dateTimeSeprator}YYYY, hh:mm`).isValid() && isDateInRange(eleJSON, newValue, `MM${dateTimeSeprator}DD${dateTimeSeprator}YYYY, hh:mm`)){
                if(eleJSON?.value === newValue){
                  return
                }  
                eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
            } else if(newDateFormat === "7"){
              if(moment(newValue, `YYYY${dateTimeSeprator}MM${dateTimeSeprator}DD, hh:mm`).isValid() && isDateInRange(eleJSON, newValue, `YYYY${dateTimeSeprator}MM${dateTimeSeprator}DD, hh:mm`)){
                if(eleJSON?.value === newValue){
                  return
                }  
                eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
            } else if(newDateFormat === "8"){
              if(eleJSON?.style?.PickerType === "2"){
                dateTimeArr[2] = dateTimeArr[2]?.replace(",","")
              }
              let dateArrNew = dateTimeArr[2].split(" ")
              let dateArrNew2 = dateArrNew[1].split(":")
              let m = isNaN(dateArrNew2[0])
              let n = isNaN(dateArrNew2[1]) 
              const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
              let flag43 = 0
              let q = isNaN(dateTimeArr[0])
              let r = isNaN(dateArrNew[0])
              for(let i of months){
                if(i === dateTimeArr[1] && !q && (1 <= parseInt(dateTimeArr[0]) <= 12) && !r && dateArrNew[0].length === 4 && !m && !n && (1 <= parseInt(dateArrNew2[0]) <= 24) && (1 <= parseInt(dateArrNew2[1]) <= 60)){
                  flag43 = 1
                }
              }
              if(flag43 === 1 && isDateInRange(eleJSON, newValue, `DD${dateSeprator}MMM${dateSeprator}YYYY, hh:mm`)){
                if(eleJSON?.value === newValue){
                  return
                }  
                eleJSON.value = newValue;
              } else {
                functions.showMess(["Invalid_Date"],"error");
              }
            }
        }
        // } 
        else if(newValue == "" && updatedValue){
            functions.showMess(["Invalid_Date"],"error");
          } 
        else if(newValue === ''){
          if(eleJSON?.value === newValue && !eleJSON?.apiValue){
              return
            }
            eleJSON.value = '';
            eleJSON.apiValue = null;
          }
          else {
            functions.showMess(["Invalid_Date"],"error");
          }
      }     
      else if(eleJSON?.elem_type === "tile"){       
        if(Array.isArray(controlValue)){
         if(eleJSON?.style?.TileSelectionType==="Single Select" && controlValue?.length >1){
           functions.showMess([null,"Array_Length"],"error");
         }
         else {
           eleJSON?.tileContents?.forEach((tileContent,tileIndex)=>{
             if(controlValue?.includes(tileContent?.id)){
               eleJSON.tileContents[tileIndex].value="true"
             }
             else{
               eleJSON.tileContents[tileIndex].value="false"
             }
         })
         }        
        }
       }
      else {
        if(eleJSON?.elem_type === "paragraph"){
          if(eleJSON?.paragraphText === controlValue){
            return
          }
          eleJSON.paragraphText=controlValue;
          eleJSON.style.updateFormStatePara = Date.now();
        }
        if(eleJSON?.elem_type === "picklist"){
          if(eleJSON?.style?.AllowMultipleSection === "true"){
            eleJSON.style.Picklists=controlValue;
          }
          if(eleJSON?.style?.AllowMultipleSection === "false"){
            eleJSON.style.Picklist=controlValue;
          }
        }
        if(eleJSON?.value === controlValue){
          return
        }
        eleJSON.value=controlValue;
        if(controlValue === "" && eleJSON.id.includes("radio")){
          eleJSON.style.DefaultSelect="";
        }
        removeIdFromMandatoryControl2(eleJSON.id,controlValue);
      }
      eleJSON.calledFromAPI = true;
      eleJSON.style.updateFormState = Date.now();
      if(!notContainParent(eleJSON) && eleJSON?.id)
        functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
    else {
      functions.showMess(["setValue","Not_Valid",controlName],"error");
    }
}
}

function isDate(inputDate, formatCode, dateSeparator, dateTimeSeparator) {
  if (!inputDate) return "";

  const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  // Normalize separators to "/"
  let normalized = inputDate.trim().replace(/[.\-]/g, "/");

  // If comma between date and time → replace with space
  normalized = normalized.replace(",", " ").replace(/\s+/, " ");

  // If it’s in ISO format (e.g. "2025-09-26 13:05:05.0"), normalize it
  normalized = normalized.replace(/\.\d+$/, ""); // remove .0 or .123
  normalized = normalized.replace("T", " ");

  const [datePart, timePartRaw] = normalized.split(/\s+/);
  const dateParts = datePart.split("/");

  if (dateParts.length !== 3) return "";

  let day, month, year;

  // Try parsing month name or number
  const parseMonth = (val) => {
    if (/^\d+$/.test(val)) return parseInt(val, 10);
    const idx = monthNames.findIndex(m => m.toLowerCase() === val.toLowerCase());
    return idx !== -1 ? idx + 1 : NaN;
  };

  // Detect and parse formats automatically
  if (dateParts[0].length === 4) {
    // yyyy/mm/dd
    year = parseInt(dateParts[0], 10);
    month = parseMonth(dateParts[1]);
    day = parseInt(dateParts[2], 10);
  } else if (dateParts[2].length === 4) {
    if (isNaN(dateParts[1])) {
      // dd/mmm/yyyy
      day = parseInt(dateParts[0], 10);
      month = parseMonth(dateParts[1]);
      year = parseInt(dateParts[2], 10);
    } else if (formatCode === "1" || formatCode === "5") {
      // dd/mm/yyyy
      day = parseInt(dateParts[0], 10);
      month = parseInt(dateParts[1], 10);
      year = parseInt(dateParts[2], 10);
    } else {
      // mm/dd/yyyy
      month = parseInt(dateParts[0], 10);
      day = parseInt(dateParts[1], 10);
      year = parseInt(dateParts[2], 10);
    }
  } else {
    return "";
  }
  
  console.log(day, month, year)

  // Validate
  const daysInMonth = new Date(year, month, 0).getDate();
  if (month < 1 || month > 12 || day < 1 || day > daysInMonth) return "";

  // Handle time
  let hours = "00", minutes = "00"; // default
  if (timePartRaw) {
    const [hh, mm] = timePartRaw.split(":").map(Number);
    if (hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59) {
      hours = hh.toString().padStart(2, "0");
      minutes = mm.toString().padStart(2, "0");
    }
  }
  
  // Format based on formatCode
  const getFormattedDate = () => {
    if(day && month && year)
    switch (formatCode) {
      case "1": return `${pad(day)}${dateSeparator}${pad(month)}${dateSeparator}${year}`;
      case "2": return `${pad(month)}${dateSeparator}${pad(day)}${dateSeparator}${year}`;
      case "3": return `${year}${dateSeparator}${pad(month)}${dateSeparator}${pad(day)}`;
      case "4": return `${pad(day)}${dateSeparator}${monthNames[month-1]}${dateSeparator}${year}`;
      case "5": return `${pad(day)}${dateTimeSeparator}${pad(month)}${dateTimeSeparator}${year} ${hours}:${minutes}`;
      case "6": return `${pad(month)}${dateTimeSeparator}${pad(day)}${dateTimeSeparator}${year} ${hours}:${minutes}`;
      case "7": return `${year}${dateTimeSeparator}${pad(month)}${dateTimeSeparator}${pad(day)} ${hours}:${minutes}`;
      case "8": return `${pad(day)}${dateTimeSeparator}${monthNames[month-1]}${dateTimeSeparator}${year} ${hours}:${minutes}`;
      default: return "";
    }
    else{
        return ""
    }
  };

  return getFormattedDate();
}

function pad(num) {
  return num.toString().padStart(2, "0");
}


const getSelectedRowsIndexes = (eleJSON = {}) => {
  const rowIndices = new Array();
  const id = getSuggestedId(
    eleJSON?.id,
    eleJSON?.style?.MappingId,
    eleJSON?.style?.CustomId
  );
  const gridElement = document.querySelector(`.rsuite_component_parent [control_id="${id}"]`)

  if(gridElement) {
    let checkBoxes = []
    if(eleJSON.style.multiSelect === "false" || eleJSON.style.multiSelect === false){
      let radioSelected = gridElement.querySelector("[class*='rs-radio-checked']")?.querySelector("[id*='_rowCheckbox']")?.value;
      if(radioSelected){
        rowIndices.push(radioSelected)
        return rowIndices;
      }
    }
    else{
      checkBoxes = gridElement.querySelectorAll("[id*='_rowCheckbox']");
    }
  
    if(checkBoxes.length) {
      for (let i = 0; i < checkBoxes.length; i++) {
        if (checkBoxes[i].checked) {
          rowIndices.push(i);
        }
      }
    }
  }
  return rowIndices;
};

const parseChildrenArray = async(jsonData) =>{
  var jsonObj={};
      if(jsonData != undefined && jsonData != null)
      {
        if(Array.isArray(jsonData)){
          jsonData.forEach((item,index)=>{
             if(item.elem_type ==="frame" || item.elem_type ==="tab" || item.elem_type ==="sheet" || item.elem_type == "row" || item.elem_type == "column")
             {
              if(Object.keys(item).includes("children")){
                parseChildrenArray(item.children);
              }
             } 
             else if(item.elem_type ==="tile" )
             {
              if(Object.keys(item).includes("tileContents")){
                parseChildrenArray(item.tileContents);
              }
             } 
             else if(validControls["clearValue"].includes(item.elem_type)){
                var value=getClearedValue(item.elem_type);
                jsonObj[item.id]=value;
            }
          })
        }
        await setValuesImpl(jsonObj);
      }
      
}


// export const recursiveJsonReader1=(jsonData, selectedID, elemType)=>{
//   var result;
//   if(Array.isArray(jsonData)){
//       jsonData.forEach((item,index)=>{
          
//           var dataC = item?.["dataclass"];
//           if(dataC){
//             dataC = dataC.replaceAll(".","_")
//           }
//          if(item["id"]===selectedID ||  item.style?.["CustomId"]===selectedID || item?.["control_id"]===selectedID || item["dataclass"]===selectedID || dataC === selectedID){
//             console.log(item);            
//             result=item;
//          }
//           if(Object.keys(item).includes("children")){
//              var matched  = recursiveJsonReader1(item, selectedID, elemType)
//              if(matched !== undefined){
//               result=matched;
//              }
//             }
//             else if (Object.keys(item).includes("subform")){
//               var matched  = recursiveJsonReader1(item.subform, selectedID, elemType)
//              if(matched !== undefined){
//               result=matched;
//              }
//             }
//             else if (Object.keys(item).includes("listviewFrameLayoutJson")){
//               var matched;
//               let openCanvasForPreviewAdvance = getOpenCanvasForPreviewAdvance();
//               let openCanvasForPreview = getOpenCanvasForPreview();
//               if(item?.elem_type?.toLowerCase() === "advancelistview" && openCanvasForPreviewAdvance === "advanceListviewPopupInPreview") {
//                   const advJSON =  fetchGridStates()?.currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
//                   if(advJSON) 
//                     matched  = recursiveJsonReader1(advJSON, selectedID, elemType) 
//               } else  if(item?.elem_type?.toLowerCase() === "listview" && openCanvasForPreview === "showDataAdditonSection") {
//                 const advJSON =  getSubFormListviewJsonFromStore()?.listviewFrameLayoutJson;
//                 // if(openCanvasForPreview === "showDataAdditonSection" && openCanvasForPreviewAdvance === "advanceListviewPopupInPreview"){
//                 //   console.log("inside both1", item.listviewFrameLayoutJson)
//                 //   matched  = recursiveJsonReader1(item.listviewFrameLayoutJson, selectedID, elemType)
//                 // }
//                 // else 
//                 if(advJSON) {
//                   console.log("inside both2",advJSON)
//                   matched  = recursiveJsonReader1(advJSON, selectedID, elemType);
//                 }
//               }
//               else matched  = recursiveJsonReader1(item.listviewFrameLayoutJson, selectedID, elemType)
//              if(matched !== undefined){
//               result=matched;
//              }
//             }
//             else if(Object.keys(item).includes("tileContents"))
//             {
//               var matched  = JsonReaderForTile(item["tileContents"], selectedID, elemType)
//              if(matched !== undefined){
//               result=matched;
//              }
//             }
//         })
//   } else{
//           if( jsonData?.["id"]!==selectedID){
//             result= recursiveJsonReader1(jsonData?.["children"], selectedID, elemType);
//           }
//           else if( jsonData?.["control_id"]!==selectedID ){
//             result=recursiveJsonReader1(jsonData["children"], selectedID, elemType);
//           }
//           else {
//                 return jsonData;
//           }
//       }
//       return result;
// }

// export const recursiveJsonReader1 = (jsonData, selectedID) => {
//   if (!jsonData) return undefined;

//   // If jsonData is an array, iterate over its elements
//   if (Array.isArray(jsonData)) {
//     for (const item of jsonData) {
//       if (!item) continue; // Skip null or undefined values

//       let dataC = item?.["dataclass"]?.replaceAll(".", "_");

//       // Check if the current item matches the selected ID
//       if (
//         item["id"] === selectedID ||
//         item.style?.["CustomId"] === selectedID ||
//         item?.["control_id"] === selectedID ||
//         item["dataclass"] === selectedID ||
//         dataC === selectedID
//       ) {
//         return item; // Return immediately when found
//       }

//       // Recursively check nested properties
//       let matched =
//         recursiveJsonReader1(item.children, selectedID) ||
//         recursiveJsonReader1(item.subform, selectedID) ||
//         recursiveJsonReader1(item.listviewFrameLayoutJson, selectedID) ||
//         (item.tileContents ? JsonReaderForTile(item.tileContents, selectedID) : undefined);

//       if (matched) return matched;
//     }
//   } else {
//     // If jsonData is an object, check if it matches the selected ID
//     if (
//       jsonData?.["id"] === selectedID ||
//       jsonData?.["control_id"] === selectedID
//     ) {
//       return jsonData;
//     }

//     // Recursively search in "children" if it's an object
//     return (
//       recursiveJsonReader1(jsonData?.["children"], selectedID) ||
//       recursiveJsonReader1(jsonData?.["subform"], selectedID)
//     );
//   }

//   return undefined; // Return undefined if nothing matches
// };

// ✅ Lookup Function
function findElement1(id) {
  let formJson1 = getFormJsonFromStore();
  const realId = window?.aliasMap?.get(id) || id;  // Convert alias to real ID if needed
  return window?.elementMap?.get(realId) || recursiveJsonReader1(formJson1, id) || undefined;  // Fetch from main map
}

function removeChildrenFromRenderSet(parent) {
    if (!parent?.children) return;

    for (const child of parent.children) {
        if (functions.renderElementsArray.has(child.id)) {
            functions.renderElementsArray.delete(child.id);
        }
    }
}

function propagateVisibility(control, formjson){

    const column = control.parentColumnJson;

    if(!column) return 0;

    let flag81 = 0
    if(functions.renderElementsArray.has(column.id)) {
      flag81 = 1
    }

    let b = recursiveJsonReader1(formjson,column.id);

    if(flag81 === 0){
      const allHidden = b.children.every(
          child => child?.style?.Visible === "false"
      );
  
      if(allHidden && document.getElementById(column?.id)?.style?.display === "block"){
          b.style.Visible = "false"
          // 🚀 Push ONLY when changed
        functions.renderElementsArray.add(column.id);
        flag81 = 1
      }
  
      if(!allHidden && document.getElementById(column?.id)?.style?.display === "none"){
        b.style.Visible = "true"
          // 🚀 Push ONLY when changed
        functions.renderElementsArray.add(column.id);
        flag81 = 1
      }
    }

    // const newValue = allHidden ? "false" : "true";
    // const prevValue = column.style?.Visible;

    //  // 🚀 Only update if changed
    // if (prevValue === newValue) return;

    // column.style.Visible = newValue;

    // 🚀 Push ONLY when changed
    // functions.renderElementsArray.add(column.id);
    if(flag81 === 1){
      removeChildrenFromRenderSet(b);
      // 🚀 propagate only when changed
      propagateRowVisibility(control, formjson);
    }
    return flag81

}

function propagateRowVisibility(control, formjson){

    const row = control.parentRowJson;

    if(!row) return;

    let flag82 = 0
    if(functions.renderElementsArray.has(row.id)) {
      flag82 = 1
    }
    
    if(flag82 === 0){
      let b = recursiveJsonReader1(formjson,row.id);
      const allColumnsHidden = b.children.every(
          col => col?.style?.Visible === "false"
      );
  
      if(allColumnsHidden && document.getElementById(row?.id)?.style?.display === "flex"){
        if(b?.style) {
          b.style.Visible = "false"
        }
          // 🚀 Push ONLY when changed
        functions.renderElementsArray.add(row.id);
        flag82 = 1
      }
  
      if(!allColumnsHidden && document.getElementById(row.id)?.style?.display === "none"){
        if(b?.style) {
          b.style.Visible = "true"
        }
          // 🚀 Push ONLY when changed
        functions.renderElementsArray.add(row.id);
        flag82 = 1
      }
    }

    // const newValue = allColumnsHidden ? "false" : "true";
    // const prevValue = row.style?.Visible;

    // 🚀 Only update if changed
    // if (prevValue === newValue) return;

    // row.style.Visible = newValue;

    // 🚀 Push ONLY when changed
    if(flag82 === 1)
    functions.renderElementsArray.delete(control?.parentColumnJson?.id);

}

export const recursiveJsonReader1 = (jsonData, selectedID, control, isParentDataRequired = true) => {
  if (!jsonData) return undefined;
  if (!selectedID) return undefined;

  // Initialize stack with item + parent context
  let stack = []; 

  if(isParentDataRequired) {
    stack = Array.isArray(jsonData)
      ? jsonData.map((item) => ({ item, parentRow: null, parentColumn: null, parentFrame: null }))
      : [{ item: jsonData, parentRow: null, parentColumn: null, parentFrame: null }];
  } else {
    stack = Array.isArray(jsonData) ? [...jsonData] : [jsonData]; // Initialize stack
  }

  while (stack.length > 0) {
    const context = stack.pop();
    let item = {};
    if(isParentDataRequired) {
      item = context.item;
    } else {
      item = context;
    }
    if (!item) continue;

    let dataC = item?.["dataclass"]?.replaceAll(".", "_");

    // Check if the current item matches the selected ID
    const isMatch =
      item["id"] === selectedID ||
      item.style?.["CustomId"] === selectedID ||
      item?.["control_id"] === selectedID ||
      item["dataclass"] === selectedID ||
      dataC === selectedID;

    if (isMatch) {
      if (isParentDataRequired) {
        if (context?.nextContext?.parentRow?.id) {
          item.parentRowJson = { id: context.nextContext.parentRow.id };
        }
        if (context?.nextContext?.parentColumn?.id) {
          item.parentColumnJson = { id: context.nextContext.parentColumn.id };
        }
        // if (context?.nextContext?.parentFrame?.id) {
        //   item.parentFrameJson = { id: context.nextContext.parentFrame.id };
        // }
      }
      return item;
    }

    let nextContext = { item: null };
    if (isParentDataRequired) {
      const nextParentRow = item.elem_type === "row" ? item : context?.nextContext?.parentRow;
      const nextParentColumn = item.elem_type === "column" ? item : context?.nextContext?.parentColumn;
      nextContext = {
        parentRow: nextParentRow,
        parentColumn: nextParentColumn,
        // parentFrame: item.elem_type === "frame" ? item : context?.nextContext?.parentFrame
      };
    }

    const pushWithContext = (child) => {
      stack.push(isParentDataRequired ? { item: child, nextContext } : child );
    };

    // Push nested elements into the stack for further processing
    if (item.children) {
      if(isParentDataRequired) {
        item.children.forEach(pushWithContext)
      } else {
        stack.push(...item.children)
      }
    };

    if (item.tileContents) {
      if(isParentDataRequired) {
        item.tileContents.forEach(pushWithContext)
      } else {
        stack.push(...item.tileContents)
      }
    };

    if (item.subform) pushWithContext(item.subform);

    if (item.listviewFrameLayoutJson) {
      let openCanvasForPreviewAdvance = getOpenCanvasForPreviewAdvance();
      let openCanvasForPreview = getOpenCanvasForPreview();

      if (
          item?.elem_type?.toLowerCase() === "advancelistview" &&
          openCanvasForPreviewAdvance === "advanceListviewPopupInPreview"
        ) {
        const advJSON = fetchGridStates()?.currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
        if (advJSON) pushWithContext(advJSON);
      } else if (item?.elem_type?.toLowerCase() === "listview" && openCanvasForPreview === "showDataAdditonSection") {
        const advJSON = getSubFormListviewJsonFromStore()?.listviewFrameLayoutJson;
        if (advJSON) pushWithContext(advJSON);
      } else {
        pushWithContext(item.listviewFrameLayoutJson);
      }
    }
  }

  return undefined; // If no match found
};
 

export const getParentIds =(jsonData, selectedID)=>{
  var result;
  if(Array.isArray(jsonData)){
    jsonData.forEach((item,index)=>{
        var dataC = item?.["dataclass"];
        if(item["id"]===selectedID ||  item.style?.["CustomId"]===selectedID || item?.["control_id"]===selectedID || item["dataclass"]===selectedID || dataC === selectedID){
        result={};
      }
      if(Object.keys(item).includes("children")) {
        var matched  = getParentIds(item, selectedID)
        if(matched !== undefined){
          result=matched;
          if(item?.elem_type === "frame" || item?.elem_type === "tab" || item?.elem_type === "sheet"){
            if(result.array === undefined){
              result.array = [];
              result.array.push(item?.id);
            } else {
              result.array.push(item?.id);
            }
          }
        }
      } else if(Object.keys(item).includes("tileContents")) {
        var matched  = getParentIds(item["tileContents"], selectedID);
        if(matched !== undefined){
          result=matched;
        }
      }
      else if (Object.keys(item).includes("subform")){
        var matched  = getParentIds(item["subform"], selectedID);
        if(matched !== undefined){
          result=matched;
        }
      }
      else if (Object.keys(item).includes("listviewFrameLayoutJson")){
        var matched  = getParentIds(item["listviewFrameLayoutJson"], selectedID);
        if(matched !== undefined){
          result=matched;
        }
      }
    })
  } else{
    if(jsonData != undefined && jsonData["id"]!==selectedID){
      result= getParentIds(jsonData["children"], selectedID);
      if(result){
      }
    } else {
      return jsonData;
    }
  }
  return result;
}

const  JsonReaderForTile = (jsonData, selectedID, elemType) => {
  var result;
  if(Array.isArray(jsonData)){
    jsonData.forEach((item,index)=>{

       if(item["id"]===selectedID || item["control_id"]===selectedID || item.style?.["CustomId"]===selectedID){
          
          result=item;
          return result;
       }
    })
  }
  return result;
}
const setTableCellDataFromAPI =(controlId,rowIndex,colIndex,value) =>
{
  var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
    if(eleJSON){
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      eleJSON.rowData[rowIndex][updatedColumnIndex].value = value;
      eleJSON.style.updateFormState = Date.now();
      // if(functions.fromExecuteServerEvent){
        if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
      // }
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
      functions.render = true;
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    } 
}
const setControlsInControlsFromSetValue = (dataArray, renderFlag) =>
{
  var controlId=dataArray.id;
  var type=dataArray.type;  
  const allPrimitiveControlList=["textbox","password","textarea","richtexteditor","datepick","slider","listbox",
  "combo","radio","checkbox","toggle","tile","picklist","link","label","paragraph","CustomControl"];

  if(allPrimitiveControlList.includes(type)){
        var dataValue=dataArray.value;
        setValueImpl(controlId, dataValue);
        // functions.render = true;
    }
  else if(type=="table"||type=="listView"||type=="advancelistView"||type=="advancelistview"){
    if(dataArray.operation=="addDataToGrid"){
      var formjson = functions.getFormJsonFromStore();
      var eleJSON=recursiveJsonReader1(formjson,controlId,type);
      if(eleJSON){
        if(validControls.addDataToGrid.includes(eleJSON?.elem_type)) {
          if(!eleJSON.rowData)
            eleJSON.rowData = [];
         // eleJSON.isCustomData = true;
          eleJSON.rowData.push(...dataArray.value)
          eleJSON.style.updateFormState = Date.now();
          functions.render=true;

          const { setRecordCount } = getReduxContexts();
          if(setRecordCount) {
            setRecordCount(eleJSON.id, true);
          }
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          if (window.addRowPostHook) {
            window.addRowPostHook(getHooksId(eleJSON), "customAPI");
            // if(renderFlag === true || renderFlag === "true")
            functions.updateJSON()
          }
        }
        else {
          functions.showMess(["addDataToGrid","Not_Valid",controlId],"error");
        }
      }
      else functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
   else if(dataArray.operation=="addDataToAdvancedGrid")
    {
      var formjson = functions.getFormJsonFromStore();
      var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
      if(eleJSON){
        if(validControls.addDataToAdvancedGrid.includes(eleJSON?.elem_type)) {
          if(!eleJSON.rowData)
            eleJSON.rowData = [];
                eleJSON.rowData.push(...dataArray.value);
                //eleJSON.isCustomData = true;
                eleJSON.style.updateFormState = Date.now();
                functions.render = true;
                const { setRecordCount } = getReduxContexts();
                if(setRecordCount) {
                  setRecordCount(eleJSON.id, true);
                }
                // if(functions.fromExecuteServerEvent){
                  if(!notContainParent(eleJSON) && eleJSON?.id)
                    functions.renderElementsArray.add(eleJSON?.id)
                // }
                // if(!functions.fromExecuteServerEvent){
                //   updateRenderState(eleJSON?.id);
                // }
                if (window.addRowPostHook) {
                  window.addRowPostHook(getHooksId(eleJSON), "customAPI");
                  // if(renderFlag === true || renderFlag === "true")
                  functions.updateJSON();
                }
        }
        else {
          functions.showMess(["addDataToAdvancedGrid","Not_Valid",controlId],"error");
        }
    } else functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  else if(dataArray.operation=="setTableCellValue"){
    setTableCellDataFromAPI(controlId,dataArray.rowIndex,dataArray.colIndex,dataArray.value);
  }
  else if(dataArray.operation=="clearTable"){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId);
    if(eleJSON) {
      if(validControls.clearTable.includes(eleJSON?.elem_type)) {
            eleJSON.style.gridEmptyMessage = dataArray?.gridEmptyMessage ?? "";
            eleJSON.rowData=[];
            eleJSON.style.updateFormState = Date.now();
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            functions.render = true;
      }
      else functions.showMess(["clearTable","Not_Valid",controlId],"error");
      }
      else {
        functions.showMess(["The_Control",controlId,"Not_Present"],"error");
      }
  }
}	
}

const findRealIndex = (wizardJSON, stepId, subStepId) => {
    let stIndex = -1, sbstIndex = -1;
    for(let i = 0; i < wizardJSON?.children?.length; i++) {
        if(wizardJSON?.children?.[i]?.id === stepId) {
            stIndex = i;  
            if(containsSubsteps(wizardJSON?.children?.[i],"substep")) {
                if(!subStepId) {
                    sbstIndex = 0;  
                    break;
                }
                else {
                    for(let j = 0; j < wizardJSON?.children?.[i]?.children?.length; j++) {
                        if(wizardJSON?.children?.[i]?.children?.[j].id === subStepId) {
                            sbstIndex = j;
                            break;
                        }
                    }
                }
            }
        }
    }
    return [stIndex, sbstIndex];
}
 
export const renderExecuteServerEventAPIData = async({outputArray,isCalledFromDBLinking,event,index,sync, renderFlag,json}) =>{
    window.loading(true);
    var eleJSON=null;
    var formjson; 
    if(json) {
      formjson = json;
      functions.beforeFormLoadJSON = json;
    } else {
      formjson = functions.getFormJsonFromStore();
    }
    let controlObj = {};
    let isClearOptionsFlag=true;
    if(outputArray) {
      for(let i =0;i<outputArray.length;i++){
        try
        {let apiObj=outputArray[i];
          // functions.fromExecuteServerEvent = true
          if(controlObj[apiObj.id]) {
            controlObj[apiObj.id] = {
              clear: true
            };
          } else controlObj[apiObj.id] = {
            clear: false,
          };
        if(apiObj.API==="setRowStyle"){
          functions.setRowStyle(apiObj.tableId, apiObj.rowIndex,apiObj.attributeName, apiObj.attributeValue)
        }
        if(apiObj.API==="setData"){
          if(apiObj.id!=null && apiObj.id!=undefined){
            setControlsInControlsFromSetValue(apiObj, renderFlag);
          }
        }
        if(apiObj.API==="loadStepData"){
          const activeStepId = getActiveStepId();
          const activeSubStepId = getActiveSubStepId();
          const wizardJSON = recursiveJsonReader1(formjson, "wizard", "control");
          const [stepIndex, subStepIndex] = findRealIndex(wizardJSON, activeStepId, activeSubStepId);
          makeChildrenEmpty(wizardJSON,true);
          if(parseInt(subStepIndex) >= 0) {
            wizardJSON.children[stepIndex].children[subStepIndex].children = apiObj.formbuffer.formJson?.children?.[1]?.children;
          } else {
            wizardJSON.children[stepIndex].children = apiObj.formbuffer.formJson?.children?.[1]?.children;
          }
          wizardJSON.callSaveAsTemplate = true;
          functions.renderElementsArray.add(wizardJSON.id);
          functions.render = true;
        }
        if(apiObj.API==="setValue") {
          setValueImpl(apiObj.controlId,apiObj.value)
        }
        if(apiObj.API==="reNameColumnsInGrid") {
          setTableColumnName(apiObj.tableId, apiObj.value)
        }
        if(apiObj.API==="reOrderColumns") {
          reOrderColumns(apiObj.tableId, apiObj.value)
        }
        if(apiObj.API==="setStyle"){
          setStyle({Id : apiObj.controlid, attribute: apiObj.attributename,value : apiObj.attributevalue, ShowHideAddDelete: apiObj.ShowHideAddDelete,frameJson: apiObj.frameJson, formjson: formjson, forcefull : apiObj.forcefull});
        }
        if(apiObj.API === "clearTable") {
          var formjson = functions.getFormJsonFromStore();
          var eleJSON=recursiveJsonReader1(formjson,apiObj.id);
          if(eleJSON) {
            if(validControls.clearTable.includes(eleJSON?.elem_type)) {
                  eleJSON.style.gridEmptyMessage = apiObj?.gridEmptyMessage ?? "";
                  eleJSON.rowData=[];
                  eleJSON.style.updateFormState = Date.now();
                  // if(functions.fromExecuteServerEvent){
                    if(!notContainParent(eleJSON) && eleJSON?.id)
                      functions.renderElementsArray.add(eleJSON?.id)
                  // }
                  functions.render = true;
            }
            else functions.showMess(["clearTable","Not_Valid",apiObj.id],"error");
            }
            else {
              functions.showMess(["The_Control",apiObj.id,"Not_Present"],"error");
            }
        }
        if(apiObj.API === "changeNavigation") {
          const wizardJSON = recursiveJsonReader1(formjson, "wizard", "control");
          if(wizardJSON) {
            if(wizardJSON.elem_type === 'wizard_v'|| wizardJSON.elem_type === 'wizard_h' ||wizardJSON.elem_type === 'sidenavigation'){
              wizardJSON.changeNavigation = apiObj.value;
              // if(functions.fromExecuteServerEvent){
                if(!notContainParent(wizardJSON) && wizardJSON?.id)
            functions.renderElementsArray.add(wizardJSON?.id)
              // }
              functions.render = true;
            } else functions.showMess(["changeNavigation","Not_Valid",apiObj.id],"error");
          } else functions.showMess(["The_Control","wizard","Not_Present"],"error");
        }
        if(apiObj.API === "renameNavigationList") {
          functions.renameNavigationList(apiObj.value);
        }
        if(apiObj.API === "showMessage"){
          if(functions.showAlertMessage){
            // functions.showSplitMessage(apiObj.msg, apiObj.msg, apiObj.msgType, true, true, [])
            functions.showSplitMessage(apiObj.msg, apiObj.msg, apiObj.msgType, apiObj?.isClose, apiObj?.showIcon, apiObj?.buttons, apiObj?.placement, apiObj?.duration)
          }
        }
      if(apiObj.API==="mandateDocTypes"){
        mandateDocTypes(apiObj.DocControlId,apiObj.DocumentType,apiObj.mandateDocFlag)
      }

      if(apiObj.API==="clearDocList"){
        clearDocList(apiObj?.id)
      }

      if(apiObj.API==="uploadFilesInDoclist"){
        if(apiObj?.["resp"]?.["response_list"]) {
          // const resp = {data: {response_list: apiObj?.["resp"]?.["response_list"]}}
          setValueInDoclist(apiObj?.controlId || apiObj?.id, apiObj?.["resp"]?.["response_list"] || []);
          // window.callBackFunction("upload", undefined, resp)
        } else {
          console.log("No valid callback function or api response", apiObj)
        }
      }

      if(apiObj.API==="addDataToDoclist"){
        addDataToDoclist(apiObj.id,apiObj.value)
      }
      
      if(apiObj.API==="loadStepData"){
          const activeStepId = getActiveStepId();
          const activeSubStepId = getActiveSubStepId();
          const wizardJSON = recursiveJsonReader1(formjson, "wizard", "control");
          const [stepIndex, subStepIndex] = findRealIndex(wizardJSON, activeStepId, activeSubStepId);
          makeChildrenEmpty(wizardJSON,true);
          if(parseInt(subStepIndex) >= 0) {
            wizardJSON.children[stepIndex].children[subStepIndex].children = apiObj.formbuffer.formJson?.children?.[1]?.children;
          } else {
            wizardJSON.children[stepIndex].children = apiObj.formbuffer.formJson?.children?.[1]?.children;
          }
          wizardJSON.callSaveAsTemplate = true;
          functions.renderElementsArray.add(wizardJSON.id);
          functions.render = true;
        }

      if(apiObj.API==="showHideDocumentTypes"){
        showHideDocumentTypes(apiObj.id,apiObj.DocumentType,apiObj.ShowHideFlag)
      }
      if(apiObj.API==="addItemInCombo"){
        if(isCalledFromDBLinking){
          if(!controlObj[apiObj.id].clear) {
            let isClearValueOfCombo = true;
            if(window.clearComboOnLoad){
              isClearValueOfCombo = window.clearComboOnLoad(apiObj.id);
            }
            clearComboOptionsImpl(apiObj.id,isClearValueOfCombo,true);
          }
        }
        addItemInComboImpl(apiObj.id,apiObj.label,apiObj.value,apiObj.tooltip);
      }
      if(apiObj.API==="addItemInRadio"){
        addItemInRadioImpl(apiObj.id, apiObj.label,apiObj.value,apiObj.tooltip);
      }
      if(apiObj.API==="removeItemFromRadio"){
        removeItemFromRadioImpl(apiObj.id, apiObj.index);
      }
      else if(apiObj.API==="removeItemFromCombo"){
        removeItemFromComboImpl(apiObj.id, apiObj.index);
      }
      else if(apiObj.API==="clearCombo"){
        if(window.clearComboItems){
           window.clearComboItems(apiObj.id);
        }
        let isClearValueOfCombo = true;
        if(window.clearComboOnLoad){
          isClearValueOfCombo = window.clearComboOnLoad(apiObj.id);
        }
        clearComboOptionsImpl(apiObj.id,isClearValueOfCombo,true);
      }
       else if(apiObj.API==="clearRadio"){
        clearRadioImpl(apiObj.id);
      }
      else if(apiObj.API==="addItemInTableCellCombo"){
        addItemInTableCellCombo(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.label, apiObj.value, apiObj.tooltip, apiObj.optionId);
      }
      else if(apiObj.API==="removeItemFromTableCellCombo"){
        removeItemFromTableCellCombo(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.index);
      }
      else if(apiObj.API==="setCellDisabled"){
        setCellDisabled(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.Disabled);
      }
      else if(apiObj.API==="setCellContentVisible"){
        setCellContentVisible(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.Disabled);
      }
      else if(apiObj.API==="setColumnHeaderVisible"){
        setColumnHeaderVisible(apiObj.id, apiObj.columnIndex, apiObj.Disabled);
      }
      else if(apiObj.API==="clearTableCellCombo"){
        clearTableCellCombo(apiObj.id, apiObj.rowIndex, apiObj.colIndex);
      }
      else if(apiObj.API=== "setCaption"){
        setCaption(apiObj.Id, apiObj.Caption);
      }
      else if (apiObj.API === "setCellBackgroundColor"){
        setCellBackgroundColor(apiObj.tableId, apiObj.rowIndex, apiObj.colIndex, apiObj.color)
      }
      else if (apiObj.API === "disableCheckboxColumn"){
        disableCheckboxColumn(apiObj.tableId, apiObj.flag)
      }
      else if (apiObj.API === "setCellBorderRadius"){
        setCellBorderRadius(apiObj.tableId, apiObj.rowIndex, apiObj.colIndex, apiObj.borderRadius)
      }
      else if (apiObj.API === "disableCheckboxColumn"){
        disableCheckboxColumn(apiObj.tableId, apiObj.flag)
      }
      else if (apiObj.API === "setCellLabelColor"){
        setCellLabelColor(apiObj.tableId, apiObj.rowIndex, apiObj.colIndex, apiObj.color)
      }
      else if (apiObj.API === "setCellStyle") {
        setCellStyle(apiObj.tableId, apiObj.rowIndex, apiObj.colIndex, apiObj.attributename, apiObj.attributevalue)
      }
      else if(apiObj.API==="addZone"){
        addZone(apiObj.zoneName,apiObj.top,apiObj.left,apiObj.width,apiObj.height,apiObj.id);
      }
      else if (apiObj.API==="setRowColorInListView"){
        functions.setRowColorInListView(apiObj.tableId,apiObj.rowIndex,apiObj.color)
      }
      else if (apiObj.API === "setSheetCaption"){
        functions.setSheetCaption(apiObj.tabId, apiObj.sheetIndex, apiObj.caption);
      }
      // else if (apiObj.API === "setRowColorInListView"){
      //   functions.setRowColorInListView(apiObj.tableId, apiObj.rowIndex, apiObj.color)
      // }
      else if(apiObj.API==="setTabStyle"){
        setTabStyle(apiObj.controlid,apiObj.sheetindex,apiObj.attributename,apiObj.attributevalue);
      }
      else if(apiObj.API==="deleteRowsFromGrid"){
        deleteRowsFromGridAction(apiObj.id,apiObj.rowIndices,apiObj.altrowcolor);
      }
      else if(apiObj.API==="setStatusTag"){
        setStatusTagImpl(apiObj.ControlId,apiObj.StatusMsg,apiObj.Status);
      }else if(apiObj.API==="setColumnVisible"){
        setColumnVisible(apiObj.tableId,apiObj.colIndex,apiObj.visibleFlag);
      }
      else if(apiObj.API==="setTableCellColor"){
        setTableCellColor(apiObj.tableId,apiObj.rowIndex, apiObj.colIndex,apiObj.cellColor);
      }else if(apiObj.API==="setColumnDisable"){
        setColumnDisable(apiObj.tableId,apiObj.colIndex,apiObj.disableFlag);
      }       
      else if(apiObj.API==="selectSheet"){
        functions.selectSheet(apiObj.controlId,apiObj.sheetIndex);
      }
      else if(apiObj.API==="reOrderControls"){
        functions.reOrderControls(apiObj.controlId,apiObj.controls);
      }
      else if(apiObj.API==="setTableColumnName"){
        functions.setTableColumnName(apiObj.controlId,apiObj.columnArray);
      }
      else if(apiObj.API==="setInputValidation"){
        functions.setInputValidation(apiObj.controlId,apiObj.attribute,apiObj.attributeValue);
      }
      else if(apiObj.API==="setMaskingPattern"){
        functions.setMaskingPattern(apiObj.controlId,apiObj.pattern);
      }
      else if(apiObj.API === "APIError" && apiObj.FromAPI === "addDataToGrid" && apiObj.fields?.length) {
        functions.showMess([
          "These columns are mandatory",
          " - ", "\n",
          ...apiObj.fields.map((item, index) => `${item}${apiObj.fields.length - 1 === index ? "" : ","}`)
        ], "error");
      } else if(apiObj.API === "APIError") {
        (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? 
        functions.showMess([`يواجه بعض المشاكل. يرجى التحقق من السجلات ${apiObj.FromAPI} واجهة برمجة التطبيقات`], "error" )
        : functions.showMess([`API ${apiObj.FromAPI} is having some issue. Please check logs`], "error" )
      }
      }
      catch(error){ 
        console.log(error);
      }
      
      }
      if(json){
        functions.renderElementsArray = new Set();
        functions.beforeFormLoadJSON = {};
        functions.render = false;
      }
      if(renderFlag === true || renderFlag === "true"){
        functions.beforeFormLoadJSON = {};
        // functions.updateJSON();
      }
      else{
        window.loading(false)
      }
    } 
    if(json){
      functions.renderElementsArray = new Set();
      functions.beforeFormLoadJSON = {};
      functions.render = false;
    }
    // else {
      // if(outputArray)
      // return Promise.all(outputArray).then(function(obj) {
      //   obj.map((apiObj) => {
      //     try {
      //         if(apiObj.API==="setData"){
      //     if(apiObj.id!=null && apiObj.id!=undefined){
      //       functions.render = true;
      //       setControlsInControlsFromSetValue(apiObj, renderFlag);
      //     }
      //   }
      //   if(apiObj.API==="setRowStyle"){
      //     functions.setRowStyle(apiObj.tableId, apiObj.rowIndex,apiObj.attributeName, apiObj.attributeValue)
      //   }
      //   if(apiObj.API==="loadStepData"){
      //     const activeStepId = getActiveStepId();
      //     const activeSubStepId = getActiveSubStepId();
      //     var formjson; 
      //     if(json) {
      //       formjson = json;
      //       functions.beforeFormLoadJSON = json;
      //     } else {
      //       formjson = functions.getFormJsonFromStore();
      //     }
      //     const wizardJSON = recursiveJsonReader1(formjson, "wizard", "control");
      //     const [stepIndex, subStepIndex] = findRealIndex(wizardJSON, activeStepId, activeSubStepId);
      //     makeChildrenEmpty(wizardJSON,true);
      //     if(parseInt(subStepIndex) >= 0) {
      //       wizardJSON.children[stepIndex].children[subStepIndex].children = apiObj.formbuffer.formJson?.children?.[1]?.children;
      //     } else {
      //       wizardJSON.children[stepIndex].children = apiObj.formbuffer.formJson?.children?.[1]?.children;
      //     }
      //     wizardJSON.callSaveAsTemplate = true;
      //     functions.renderElementsArray.push(wizardJSON.id);
      //     functions.render = true;
      //   }
      //   if(apiObj.API==="setValue") {
      //     functions.render = true;
      //     setValueImpl(apiObj.controlId,apiObj.value)
      //   }
      //   if(apiObj.API==="reNameColumnsInGrid") {
      //     setTableColumnName(apiObj.tableId, apiObj.value)
      //   }
      //   if(apiObj.API==="reOrderColumns") {
      //     reOrderColumns(apiObj.tableId, apiObj.value)
      //   }
      //   if(apiObj.API==="setStyle"){
      //     functions.render = true;
      //     setStyle({Id : apiObj.controlid,attribute : apiObj.attributename,value : apiObj.attributevalue,ShowHideAddDelete : apiObj.ShowHideAddDelete,frameJson : apiObj.frameJson, formjson : formjson});
      //   }
      //   if(apiObj.API === "clearTable") {
      //     var formjson = functions.getFormJsonFromStore();
      //     var eleJSON=recursiveJsonReader1(formjson,apiObj.id);
      //     if(eleJSON) {
      //       if(validControls.clearTable.includes(eleJSON?.elem_type)) {
      //             eleJSON.rowData=[];
      //             eleJSON.style.updateFormState = Date.now();
      //             functions.render = true;
      //           }
      //       }
      //       else {
      //         functions.showMess(["clearTable","Not_Valid",apiObj.id],"error");
      //       }
      //   }
      //   if(apiObj.API === "changeNavigation") {
      //     const wizardJSON = recursiveJsonReader1(formjson, "wizard", "control");
      //     wizardJSON.changeNavigation = apiObj.value;
      //     functions.render = true;
      //   }
      //   if(apiObj.API === "renameNavigationList") {
      //     functions.renameNavigationList(apiObj.value);
      //   }
      //   if(apiObj.API === "showMessage"){
      //     if(functions.showAlertMessage){
      //       functions.showSplitMessage(apiObj.msg, apiObj.msg, apiObj.msgType, apiObj?.isClose, apiObj?.showIcon, apiObj?.buttons, apiObj?.placement, apiObj?.duration)
      //     }
      //   }
      //   if(apiObj.API==="mandateDocTypes"){
      //     functions.render = true;
      //     mandateDocTypes(apiObj.DocControlId,apiObj.DocumentType,apiObj.mandateDocFlag)
      //   }

      //   if(apiObj.API==="clearDocList"){
      //     clearDocList(apiObj?.id)
      //   }

      //   if(apiObj.API==="uploadFilesInDoclist"){
      //     if(window.callBackFunction && apiObj?.["resp"]?.["response_list"]) {
      //       const resp = {data: {response_list: apiObj?.["resp"]?.["response_list"]}}
      //       window.callBackFunction("upload", undefined, resp)
      //     } else {
      //       console.log("No valid callback function or api response", apiObj)
      //     }
      //   }
        
      //   if(apiObj.API==="addDataToDoclist"){
      //     addDataToDoclist(apiObj.id,apiObj.value)
      //   }

      //   if(apiObj.API==="showHideDocumentTypes"){
      //     showHideDocumentTypes(apiObj.id,apiObj.DocumentType,apiObj.ShowHideFlag)
      //   }
      
      // if(apiObj.API==="addItemInCombo"){
      //   addItemInComboImpl(apiObj.id,apiObj.label,apiObj.value,apiObj.tooltip);
      // }
      // if(apiObj.API==="addItemInRadio"){
      //   addItemInRadioImpl(apiObj.id, apiObj.label,apiObj.value,apiObj.tooltip);
      // }
      // if(apiObj.API==="removeItemFromRadio"){
      //   removeItemFromRadioImpl(apiObj.id, apiObj.index);
      // }
      
      // else if(apiObj.API==="removeItemFromCombo"){
      //   removeItemFromComboImpl(apiObj.id, apiObj.index);
      // }
      // else if(apiObj.API==="clearCombo"){
      //   if(window.clearComboItems){
      //     window.clearComboItems(apiObj.id)
      //   }
      //   let isClearValueOfCombo = true;
      //   if(window.clearComboOnLoad){
      //     isClearValueOfCombo = window.clearComboOnLoad(apiObj.id);
      //   }
      //   clearComboOptionsImpl(apiObj.id,isClearValueOfCombo,true);
      // }
      // else if(apiObj.API==="addItemInTableCellCombo"){
      //   addItemInTableCellCombo(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.label, apiObj.value, apiObj.tooltip, apiObj.optionId);
      // }
      // else if(apiObj.API==="removeItemFromTableCellCombo"){
      //   removeItemFromTableCellCombo(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.index);
      // }
      // else if(apiObj.API==="setCellDisabled"){
      //   setCellDisabled(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.Disabled);
      // }
      // else if(apiObj.API==="setCellContentVisible"){
      //   setCellContentVisible(apiObj.id, apiObj.rowIndex, apiObj.colIndex, apiObj.Disabled);
      // }
      // else if(apiObj.API==="setColumnHeaderVisible"){
      //   setColumnHeaderVisible(apiObj.id, apiObj.columnIndex, apiObj.Disabled);
      // }
      // else if(apiObj.API==="clearTableCellCombo"){
      //   clearTableCellCombo(apiObj.id, apiObj.rowIndex, apiObj.colIndex);
      // }
      // else if(apiObj.API=== "setCaption"){
      //   setCaption(apiObj.Id, apiObj.Caption);
      // }
      // else if (apiObj.API === "setCellBackgroundColor"){
      //   setCellBackgroundColor(apiObj.tableId, apiObj.rowIndex, apiObj.colIndex, apiObj.color)
      // }
      // else if (apiObj.API === "setCellBorderRadius"){
      //   setCellBorderRadius(apiObj.tableId, apiObj.rowIndex, apiObj.colIndex, apiObj.borderRadius)
      // }
      //  else if (apiObj.API === "disableCheckboxColumn"){
      //   disableCheckboxColumn(apiObj.tableId, apiObj.flag)
      // }
      // else if (apiObj.API === "setCellLabelColor"){
      //   setCellLabelColor(apiObj.tableId, apiObj.rowIndex, apiObj.colIndex, apiObj.color)
      // }
      // else if(apiObj.API==="addZone"){
      //   addZone(apiObj.zoneName,apiObj.top,apiObj.left,apiObj.width,apiObj.height,apiObj.id);
      // }
      // else if (apiObj.API==="setRowColorInListView"){
      //   functions.setRowColorInListView(apiObj.tableId,apiObj.rowIndex,apiObj.color)
      // }
      // else if (apiObj.API === "setSheetCaption"){
      //   functions.setSheetCaption(apiObj.tabId, apiObj.sheetIndex, apiObj.caption);
      // }
      // else if (apiObj.API === "setRowColorInListView"){
      //   functions.setRowColorInListView(apiObj.tableId, apiObj.rowIndex, apiObj.color)
      // }
      // else if(apiObj.API==="setTabStyle"){
      //   setTabStyle(apiObj.controlid,apiObj.sheetindex,apiObj.attributename,apiObj.attributevalue);
      // }
      // else if(apiObj.API==="deleteRowsFromGrid"){
      //   deleteRowsFromGridAction(apiObj.id,apiObj.rowIndices,apiObj.altrowcolor);
      // }
      // else if(apiObj.API==="setStatusTag"){
      // setStatusTagImpl(apiObj.ControlId,apiObj.StatusMsg,apiObj.Status);
      // }else
      // if(apiObj.API==="setColumnVisible"){
      // setColumnVisible(apiObj.tableId,apiObj.colIndex,apiObj.visibleFlag);
      // }
      // else if(apiObj.API==="setTableCellColor"){
      //   setTableCellColor(apiObj.tableId,apiObj.rowIndex, apiObj.colIndex,apiObj.cellColor);
      // }
      // else if(apiObj.API==="setColumnDisable"){
      // setColumnDisable(apiObj.tableId,apiObj.colIndex,apiObj.disableFlag);
      // } else if(apiObj.API === "APIError" && apiObj.FromAPI === "addDataToGrid" && apiObj.fields?.length) {
      //   functions.showMess([
      //     "These columns are mandatory",
      //     " - ", "\n",
      //     ...apiObj.fields.map((item, index) => `${item}${apiObj.fields.length - 1 === index ? "" : ","}`)
      //   ], "error");
      // } 
      
      //     }
      //     catch(error) {
      //       console.log(error);
      //     }
      //   })
      // });
    // }
  }

const addItemInComboImpl =(comboId,label,value,tooltip,optionControlId) => {

    if(!validateParams(apiValidationObjects.addItemInComboImpl, {comboId,label,value,tooltip,optionControlId}, "addItemInCombo")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,comboId,'combo');
    if(eleJSON){
      let ComboOptions;
      if(validControls.addItemInCombo.includes(eleJSON?.elem_type)) {
          ComboOptions = eleJSON?.options || eleJSON?.style?.options || [];
          const optionExists = ComboOptions.some(opt => opt.label === label && opt.value === value);
 
      if (optionExists) {
        // if(functions.showAlertMessage){
        // functions.showMess(["addItemInCombo", "Duplicate_Option", label], "error");
        // }
        return;
      }
        var NewOption={
          'label':label,
          'value':value,
          'id':optionControlId,
          'tooltip':tooltip
        };
        if (Array.isArray(eleJSON?.options)) {
          eleJSON.options.push(NewOption);
        } else {
          eleJSON.options = [...ComboOptions, NewOption];
        }
        eleJSON.style.valueFromAddItemInCombo = Date.now();
        eleJSON.calledFromAPI = true;
        eleJSON.style.updateFormState = Date.now();
        functions.render = true;
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        // }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
      }
      else {
        functions.showMess(["addItemInCombo","Not_Valid",comboId],"error");
      }
  }
  else {
      functions.showMess(["The_Control",comboId,"Not_Present"],"error");
  }
}

const addItemInRadioImpl =(radioId,label,value,tooltip) => {

  if(!validateParams(apiValidationObjects.addItemInRadioImpl, {radioId,label,value,tooltip}, "addItemInRadioImpl")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,radioId,'radio');
  if(eleJSON){
    if(validControls.addItemInRadio.includes(eleJSON?.elem_type)) {
      if(eleJSON?.options?.some(opt => opt.value === value || opt.label === label)) {
        functions.showMess(["addItemInRadio", "Duplicate_Option", label], "error");
        return;
      }
      var NewOption={
        'label':label,
        'value':value,
        'tooltip':tooltip
      };           
      eleJSON.calledFromAPI = true;
      eleJSON.style.updateFormState = Date.now();
      eleJSON?.options?.push(NewOption);
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
    else {
      functions.showMess(["addItemInRadio","Not_Valid",radioId],"error");
    }
}
else {
    functions.showMess(["The_Control",radioId,"Not_Present"],"error");
}
}

Date.prototype.yyyymmdd = function(sep) {
  var yyyy = this.getFullYear();
  yyyy+=sep;
  var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
  mm+=sep;
  var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
  return "".concat(yyyy).concat(mm).concat(dd);
};

Date.prototype.ddmmyyyy = function(sep) {
  var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
  dd+=sep;
  var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
  mm+=sep;
  var yyyy = this.getFullYear();
  return "".concat(dd).concat(mm).concat(yyyy);
};

Date.prototype.mmddyyyy = function(sep) {
  var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
  mm+=sep;
  var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
  dd+=sep;
  var yyyy = this.getFullYear();
  return "".concat(mm).concat(dd).concat(yyyy);
};

Date.prototype.monthNames = [
  "January", "February", "March",
  "April", "May", "June",
  "July", "August", "September",
  "October", "November", "December"
];

Date.prototype.getMonthName = function() {
  return this.monthNames[this.getMonth()];
};
Date.prototype.getShortMonthName = function () {
  return this.getMonthName()?.substr(0, 3);
};

Date.prototype.ddmmmyyyy = function(sep) {
  var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
  dd+=sep;
  var mm= this.getShortMonthName();
  mm+=sep;
  var yyyy = this.getFullYear();
  return "".concat(dd).concat(mm).concat(yyyy);
};

Date.prototype.yyyymmddhhmm = function(sep) {
  var yyyymmdd = this.yyyymmdd(sep);
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  min+=":";
  var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

  return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
};

Date.prototype.ddmmyyyyhhmm = function(sep) {
  var yyyymmdd = this.ddmmyyyy(sep);
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  min+=":";
  var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

  return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
}

Date.prototype.mmddyyyyhhmm = function(sep) {
var yyyymmdd = this.mmddyyyy(sep);
yyyymmdd+=", ";
var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
hh+=":";
var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
min+=":";
var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
}


Date.prototype.ddmmmyyyyhhmm = function(sep) {
var yyyymmdd = this.ddmmmyyyy(sep);
yyyymmdd+=", ";
var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
hh+=":";
var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
min+=":";
var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
}


export function getValue(controlId) {
  var formjson = functions.getFormJsonFromStore();
  
  var eleJSON=recursiveJsonReader1(formjson,controlId,'control');
  if(eleJSON){
    if( eleJSON?.elem_type === "tile")
      return eleJSON.selectedTile;
    else if( eleJSON?.elem_type === "combo"){
      if(eleJSON.value)
      return eleJSON.value.value;
    }
    else if(eleJSON?.elem_type === "listbox"){
      var valueArr=[];
      if(eleJSON.value)
      {
            var tempList=eleJSON.value;
            for(var i=0;i<tempList.length;i++)
            {
              valueArr.push(tempList[i].value);
            }
      }
      return valueArr;
    }
    else
      return eleJSON.value;
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
  return ;
  
}
const removeItemFromComboImpl = (comboId,itemIndex) =>
  {

    if(!validateParams(apiValidationObjects.removeItemFromComboImpl, {comboId,itemIndex}, "removeItemFromComboImpl")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,comboId,'combo');
    if(eleJSON){
      if(validControls.removeItemFromCombo.includes(eleJSON?.elem_type)) {
        if(eleJSON.options) {
          eleJSON.options.splice(itemIndex,1);
        eleJSON.calledFromAPI = true;
        eleJSON.style.updateFormState = Date.now();
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        // }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          functions.render = true;
        } else functions.showMess([comboId," does not have any option with index: ",itemIndex], "error");
      }
      else {
        functions.showMess(["removeItemFromCombo","Not_Valid",comboId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",comboId,"Not_Present"],"error");
    }
  } 
  const removeItemFromRadioImpl = (radioId, itemIndexsArray) => {

    if(!validateParams(apiValidationObjects.removeItemFromRadioImpl, {radioId, itemIndexsArray}, "removeItemFromRadioImpl")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, radioId, 'radio');
    if (eleJSON) {
      if (validControls.removeItemFromRadio.includes(eleJSON?.elem_type)) {
        // const arrayLength = itemIndexsArray?.length
        if (itemIndexsArray.length > 0) {
          itemIndexsArray.sort();
          itemIndexsArray.reverse();
          itemIndexsArray.forEach((index) => {
            if(eleJSON.options[index])
              eleJSON.options.splice((index), 1);
            else functions.showMess([radioId," does not have any option with index: ",index], "error");
          })
          eleJSON.calledFromAPI = true;
          eleJSON.style.updateFormState = Date.now();
          functions.render = true;
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
        } else functions.showMess(["Index Array is empty"], "error");
      }
      else {
        functions.showMess(["removeItemFromRadio", "Not_Valid", radioId], "error");
      }
    }
    else {
      functions.showMess(["The_Control", radioId, "Not_Present"], "error");
    }
  }
  
const clearComboOptionsImpl =(controlId,isClear,isCalledFromBackend) =>
  {

    if(!validateParams(apiValidationObjects.clearComboOptionsImpl, {controlId,isClear,isCalledFromBackend}, "clearComboOptionsImpl")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'combo');
    if(eleJSON){
      if(validControls.clearComboOptions.includes(eleJSON?.elem_type)) {
        eleJSON.options.splice(0,eleJSON.options.length);
        if(window.keepSelectOptionInDBLinkingOptions){
          if(window.keepSelectOptionInDBLinkingOptions(getHooksId(eleJSON))){
            eleJSON.options.push({label: 'Select', value: ''})
          }
        }

        eleJSON.calledFromAPI = true;
        if(isClear==null || isClear==undefined || isClear==true || isClear=="true") {
          if(isCalledFromBackend) {
            var value=getClearedValue(eleJSON?.elem_type);
            eleJSON.value=value;
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
          }
          else  clearValueImpl(controlId, true);
        }
        functions.render = true;
        eleJSON.style.updateFormState = Date.now();
      }
      else {
        functions.showMess(["clearComboOptions","Not_Valid",controlId],"error");
      }
  }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
}

const clearRadioImpl = (controlId) => {
  var formjson = functions.getFormJsonFromStore();
  var eleJSON = recursiveJsonReader1(formjson, controlId, 'radio');

  if(eleJSON) {
    if(validControls.clearRadio.includes(eleJSON?.elem_type)) {
      eleJSON.calledFromAPI = true;
      eleJSON.clearedByAPI = true;
      eleJSON.value = getClearedValue(eleJSON?.elem_type);
      if (eleJSON?.style?.DefaultSelect !== undefined) {
        eleJSON.style.DefaultSelect = "";
      }
      eleJSON.options = [];
      eleJSON.style.updateFormState = Date.now();
      if(!notContainParent(eleJSON) && eleJSON?.id)
        functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
    else {
      functions.showMess(["clearRadio","Not_Valid",controlId],"error");
    }
  }
  else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
}
  const addItemInTableCellCombo = (tableId,rowIndex,colIndex,label,value,tooltip,optionControlId) =>
  {

    if(!validateParams(apiValidationObjects.addItemInTableCellCombo, {tableId,rowIndex,colIndex,label,value,tooltip,optionControlId}, "addItemInTableCellCombo")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){  
      if(validControls.addItemInTableCellCombo.includes(eleJSON?.elem_type)) {
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        if(eleJSON?.columnList?.[updatedColumnIndex]?.style?.ColumnType === "combo") {
          const options={
            'label':label,
            'value':value,
            'tooltip':tooltip,
            'optionId':optionControlId
          }
          if(eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex]) {
            eleJSON.calledFromAPI = true;
            eleJSON.style.updateFormState = Date.now();
            if(eleJSON.rowData[rowIndex][updatedColumnIndex].extraOptions) {
              eleJSON.rowData[rowIndex][updatedColumnIndex].extraOptions.push(options);
            }
            else {
              eleJSON.rowData[rowIndex][updatedColumnIndex].extraOptions = [];
              eleJSON.rowData[rowIndex][updatedColumnIndex].extraOptions.push(options);
            }
            eleJSON.style.updateFormState = Date.now();
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            functions.render = true;
          }
          else functions.showMess(["Invalid_Operation"],"error");
        }
        else functions.showMess(["Invalid_Operation"],"error");
      }
      else {
        functions.showMess(["addItemInTableCellCombo","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }

  }
  const removeItemFromTableCellCombo = (tableId,rowIndex,colIndex,itemIndex) =>
  {

    if(!validateParams(apiValidationObjects.removeItemFromTableCellCombo, {tableId,rowIndex,colIndex,itemIndex}, "removeItemFromTableCellCombo")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.removeItemFromTableCellCombo.includes(eleJSON?.elem_type)) {
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        if(eleJSON?.columnList?.[updatedColumnIndex]?.style?.ColumnType === "combo") { 
          if(eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex]) {
            if(eleJSON.rowData[rowIndex][updatedColumnIndex]?.removeOptionIndex?.length) {
              eleJSON.rowData[rowIndex][updatedColumnIndex].removeOptionIndex.push(itemIndex);
            } else {
              eleJSON.rowData[rowIndex][updatedColumnIndex].removeOptionIndex = [itemIndex];
            }
            eleJSON.style.updateFormState = Date.now();
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            functions.render = true;
          }
          else functions.showMess(["Invalid_Operation"],"error");
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      else {
        functions.showMess(["removeItemFromTableCellCombo","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  }
  const clearTableCellCombo =(tableId,rowIndex,colIndex) => {

    if(!validateParams(apiValidationObjects.clearTableCellCombo, {tableId,rowIndex,colIndex}, "clearTableCellCombo")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){  
      if(validControls.clearTableCellCombo.includes(eleJSON?.elem_type)) {
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        if(eleJSON?.columnList?.[updatedColumnIndex]?.style?.ColumnType === "combo") {
          if(eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex]) {
            eleJSON.rowData[rowIndex][updatedColumnIndex].clearCombo = true;
            eleJSON.rowData[rowIndex][updatedColumnIndex].clearComboNew = true;
            if(eleJSON.elem_type !== "table") {
              eleJSON.rowData[rowIndex][updatedColumnIndex].value = '';
            }
            if(eleJSON.rowData[rowIndex][updatedColumnIndex].extraOptions)
              eleJSON.rowData[rowIndex][updatedColumnIndex].extraOptions = [];
            if(eleJSON.rowData[rowIndex][updatedColumnIndex].removeOptionIndex)
              eleJSON.rowData[rowIndex][updatedColumnIndex].removeOptionIndex = [];
            eleJSON.style.updateFormState = Date.now();
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            functions.render = true;
          }
         // else functions.showMess(["Invalid_Operation"],"error");
        }
        else functions.showMess(["Invalid_Operation"],"error");
      }
      else {
        functions.showMess(["clearTableCellCombo","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  }
  const addZone = (zoneName, top, left, width, height, controlId)  => {
    if(!validateParams(apiValidationObjects.addZone, {zoneName, top, left, width, height, controlId}, "addZone")) return;
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    
    var result = true;
    if(eleJSON){
    if(formjson.Zonelist) {
      let zoneList = formjson.Zonelist
      let zone = {};
      zone["name"] = zoneName;
      zone["Top"] = top;
      zone["Left"] = left;
      zone["Width"] = width;
      zone["Height"] = height;
      let obj = zoneList.find(o => o.name === zoneName)
      
      if(obj === undefined){
        zoneList.push(zone);
      } else {
        result = false;
      }
    }
    if(eleJSON && eleJSON.style ){
      eleJSON.style.Zone = zoneName; 
    }
    // if(functions.fromExecuteServerEvent){
      if(!notContainParent(eleJSON) && eleJSON?.id)
        functions.renderElementsArray.add(eleJSON?.id)
    // }
    // if(!functions.fromExecuteServerEvent){
    //   updateRenderState(eleJSON?.id);
    // }
    functions.render = true;
  }
  else {
    functions.showMess(["The_Control",controlId,"Not_Present"],"error");
  }
    return(result);
  }
  const deleteRowsFromGridAction = (tableId , rowIndices , altrrowcolor) =>{
    var formjson = functions.getFormJsonFromStore();
      var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
      if(eleJSON){
        if(rowIndices){
          var rowData=eleJSON.rowData;
          let a = rowIndices?.split(",")?.sort((a, b) => b - a);
          for (var i = 0; i < a.length; i++) {
            var rowIndex = a[i];
            // for(var row=rowIndex.length -1; row >= 0; row--)
            // {
            rowData.splice(Number(rowIndex), 1);
            // }
          }
          eleJSON.style.updateFormState = Date.now();
          eleJSON.style.updateFormState1 = Date.now();
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          functions.render = true;
        }
      }
      else {
        functions.showMess(["The_Control",tableId,"Not_Present"],"error");
      }
  }
  const setColumnStyle =(tableId, colIndex, attributeName = "", attributeValue = "") =>
  {
    if(!validateParams(apiValidationObjects.setColumnStyle, {tableId,colIndex,attributeName, attributeValue}, "setColumnStyle")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON && attributeName) {
      if(validControls.setColumnStyle.includes(eleJSON?.elem_type)) {
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        if(eleJSON.columnList && eleJSON.columnList[updatedColumnIndex] && eleJSON.columnList[updatedColumnIndex].style){
          const propertyName = attributeName?.toString()?.toLowerCase();

          if(propertyName === "fixedcolumn") {
            if(attributeValue !== "left" && attributeValue !== "right" && attributeValue !== true && attributeValue !== "true" && attributeValue !== false && attributeValue !== "false") {
              functions.showMess(["Invalid_Attribute_Value", attributeValue], "error");
              return;
            }

            const oldValue = eleJSON.columnList[updatedColumnIndex].style["FixedColumn"];
            eleJSON.columnList[updatedColumnIndex].style["FixedColumn"] = attributeValue;

            if(attributeValue === "left" || attributeValue === true || attributeValue === "true") {
              for(let i = 0; i < eleJSON.columnList.length; i++) {
                if(i < updatedColumnIndex) {
                  eleJSON.columnList[i].style["FixedColumn"] = "left";
                }
              }
            } else if(attributeValue === "right") {
              for(let i = 0; i < eleJSON.columnList.length; i++) {
                if(i > updatedColumnIndex) {
                  eleJSON.columnList[i].style["FixedColumn"] = "right";
                }
              }
            } else if(attributeValue === "false" || attributeValue === false) {
              if(oldValue === "left") {
                for(let i = 0; i < eleJSON.columnList.length; i++) {
                  if(i < updatedColumnIndex) {
                    eleJSON.columnList[i].style["FixedColumn"] = false;
                  }
                }
              } else if(oldValue === "right") {
                for(let i = 0; i < eleJSON.columnList.length; i++) {
                  if(i > updatedColumnIndex) {
                    eleJSON.columnList[i].style["FixedColumn"] = false;
                  }
                }
              }
            }
          }

          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)

          functions.render = true;
        }
      }
      else {
        functions.showMess(["setColumnStyle","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  }

  const sortGridColumn = (tableId, colIndex, sortOrder) => {
    if(!validateParams(apiValidationObjects.sortGridColumn, {tableId,colIndex,sortOrder}, "sortGridColumn")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, tableId, "table");
    if (eleJSON) {
      if (validControls.sortGridColumn.includes(eleJSON?.elem_type)) {
        if (tableId && colIndex !== undefined && sortOrder) {
          const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
          const column = eleJSON.columnList[updatedColumnIndex];
          if (column?.style) {
            if (
              column?.style?.SortingType &&
              column.style.SortingType === "true" &&
              !(
                eleJSON?.elem_type?.toLowerCase() === "advancelistview" &&
                (column?.style?.ColumnType === "datepick" || column?.style?.ColumnType === "datetimepick")
              )
            ) {
              eleJSON["sortDetails"] = { colIndex: updatedColumnIndex, sortOrder, trigger: Date.now() };
  
              eleJSON.style.updateFormState = Date.now();
  
              if (!notContainParent(eleJSON) && eleJSON?.id) functions.renderElementsArray.add(eleJSON?.id);
              functions.render = true;
            } else {
              functions.showMess([column?.style?.ColumnName, "is not sortable in", tableId], "error");
            }
          }
        } else {
          functions.showMess(["sortGridColumn", "Invalid Parameters", tableId], "error");
        }
      } else {
        functions.showMess(["sortGridColumn", "Not_Valid", tableId], "error");
      }
    } else {
      functions.showMess(["The_Control", tableId, "Not_Present"], "error");
    }
  };

  const setColumnDisable =(tableId,colIndex,disableFlag,sync) =>
  {
    if(!validateParams(apiValidationObjects.setColumnDisable, {tableId,colIndex,disableFlag}, "setColumnDisable")) return;
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
    if(eleJSON){
      if(validControls.setColumnVisible.includes(eleJSON?.elem_type)) {
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        if(eleJSON.columnList && eleJSON.columnList[updatedColumnIndex] && eleJSON.columnList[updatedColumnIndex].style){
          // if(eleJSON?.rowData?.length > 0){
          // for(let i = 0; i < eleJSON?.rowData?.length; i++){
          if(disableFlag === "true" || disableFlag === true){
            eleJSON.columnList[updatedColumnIndex].style["isDisable"]=true;
            // eleJSON.rowData[i][colIndex].style.Disabled=true;
          }else if(disableFlag === "false" || disableFlag === false){
            eleJSON.columnList[updatedColumnIndex].style["isDisable"]=false;
            // eleJSON.rowData[i][colIndex].style.Disabled=false;
          }
          // }
          eleJSON.style.updateFormState = Date.now();
          // if(eleJSON.elem_type === "table"){
          //   updateRenderState(eleJSON);
          // }
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          functions.render = true;
        } else functions.showMess([tableId," does not have any cell with column index: ",updatedColumnIndex],"error");
        // if(eleJSON?.hideColumns) {
        //   if(disableFlag === "true" || disableFlag === true){
        //     eleJSON.hideColumns.push(colIndex);
        //   } else {
        //     const index = eleJSON.hideColumns.indexOf(colIndex);
        //     if (index > -1) {
        //       eleJSON.hideColumns.splice(index, 1);
        //     }
        //   }
        // } else {
        //   if(disableFlag === "true" || disableFlag === true){
        //     eleJSON.hideColumns = [];
        //     eleJSON.hideColumns.push(colIndex);
        //   }
        // }
        // }
      }
      else {
        functions.showMess(["setColumnDisable","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  }

  const setColumnVisible = (tableId,colIndex,visibleFlag) =>
    {
      if(!validateParams(apiValidationObjects.setColumnVisible, {tableId,colIndex,visibleFlag}, "setColumnVisible")) return;
      var formjson = functions.getFormJsonFromStore();
      var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
      if(eleJSON){
        if(validControls.setColumnVisible.includes(eleJSON?.elem_type)) {
          const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
          if(parseInt(updatedColumnIndex) === -1) {
            if(visibleFlag === "true" || visibleFlag === true){
              eleJSON.style["ShowSerialNumber"] = "true";
            } else if(visibleFlag === "false" || visibleFlag === false){
              eleJSON.style["ShowSerialNumber"] = "false";
            }
          } else if(parseInt(updatedColumnIndex) === -2) {
            if(visibleFlag === "true" || visibleFlag === true){
              eleJSON.style["ShowCheckbox"] = "true";
            } else if(visibleFlag === "false" || visibleFlag === false){
              eleJSON.style["ShowCheckbox"] = "false";
            }
          }

          if(eleJSON.columnList && eleJSON.columnList[updatedColumnIndex] && eleJSON.columnList[updatedColumnIndex].style){
            if(visibleFlag === "true" || visibleFlag === true){
              eleJSON.columnList[updatedColumnIndex].style["isVisible"]=true;
              eleJSON.columnList[updatedColumnIndex].style["VisibleOnTable"]=true;
            }else if(visibleFlag === "false" || visibleFlag === false){
              eleJSON.columnList[updatedColumnIndex].style["isVisible"]=false;
              eleJSON.columnList[updatedColumnIndex].style["VisibleOnTable"]=false;
            }
            eleJSON.style.updateFormState = Date.now();
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            functions.render = true;
          }

          eleJSON.style.updateFormState = Date.now();
          if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          }
          if(!functions.fromExecuteServerEvent){
            updateRenderState(eleJSON?.id);
          }
          functions.render = true;
        }
        else {
          functions.showMess(["setColumnVisible","Not_Valid",tableId],"error");
        }
      }
      else {
        functions.showMess(["The_Control",tableId,"Not_Present"],"error");
      }
    }

  const setTableCellColor = (tableId,rowIndex,colIndex,color) => {
    if(!validateParams(apiValidationObjects.setTableCellColor, {tableId, rowIndex, colIndex, color}, "setTableCellColor")) return;
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
    if(eleJSON){
      if(validControls.setTableCellColor.includes(eleJSON?.elem_type)) {
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        eleJSON.rowData[rowIndex][updatedColumnIndex].style.BackColor="#"+color;
        eleJSON.style.updateFormState = Date.now();
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        // }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
        functions.render = true;
      }
      else {
        functions.showMess(["setTableCellColor","Not_Valid",tableId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tableId,"Not_Present"],"error");
    }
  }
  const setTabStyle = (tabId, index, attribute, attributeValue)  => { 
    if(!validateParams(apiValidationObjects.setTabStyle, {tabId, index, attribute, attributeValue}, "setTabStyle")) return;
    var formjson = functions.getFormJsonFromStore();
    var newJSON=recursiveJsonReader1(formjson,tabId,'control');
    if(newJSON){
      if(validControls.setTabStyle.includes(newJSON?.elem_type)) {
        var eleJSON=newJSON.children[index];
        if(attribute.toLowerCase() == "backcolor")
        {
          attribute="BackColor";
        }
        if(attribute.toLowerCase() == "fontcolor")
        {
          attribute="FontColor";
        }
        if(attribute.toLowerCase() == "fontfamily")
        {
          attribute="FontFamily";
        }
        if(attribute.toLowerCase() == "fontweight")
        {
          attribute="FontWeight";
        }
        if(attribute.toLowerCase() == "fontstyle")
        {
          attribute="FontStyle";
        }
        if(attribute.toLowerCase() == "fontsize")
        {
          attribute="FontSize";
        }
        if(attribute.toLowerCase() == "visible")
        {
          attribute="Visible";
        }
        if(attribute.toLowerCase() == "disable")
        {
          attribute="Enable";
          attributeValue= (attributeValue == "true" || attributeValue == true) ? false : true;
          attributeValue=attributeValue +"";
        }
        if(attribute.toLowerCase() == "readonly"){
          attribute="ReadOnly";
          attributeValue=attributeValue+"";
        }
        if(attribute.toLowerCase()==="visible"){
          
          const sheet=document.getElementById(eleJSON.id);
          if(attributeValue===false||attributeValue==="false"){
            if(newJSON.style && newJSON.style.VisibleArr) {
              if(newJSON.style.VisibleArr?.indexOf(parseInt(index)) === -1)
                newJSON.style.VisibleArr.push(parseInt(index));
              if(newJSON?.children?.length === newJSON.style.VisibleArr?.length){
                newJSON.style.Visible = false
                newJSON.style.fromSetTabStyle = true;
              }
            }
            else {
              if(!newJSON.style) {
                newJSON.style = {};
                newJSON.style.VisibleArr = [];
              }
              if(newJSON.style && !newJSON.style.VisibleArr)
                newJSON.style.VisibleArr = [];
              newJSON.style.VisibleArr.push(parseInt(index));
              if(newJSON?.children?.length === newJSON?.style?.VisibleArr?.length){
                newJSON.style.Visible = false
                newJSON.style.fromSetTabStyle = true;
              }
            }
            // if the sheet being hidden is the one currently selected, move selection to the first still-visible sheet
            const activeSheetIndex = (newJSON.currentActiveIndex || newJSON.currentActiveIndex === 0) ? parseInt(newJSON.currentActiveIndex) : 0;
            if(parseInt(index) === activeSheetIndex) {
              redirectActiveSheetIfHidden(newJSON);
            }
          }else{
            if(newJSON.style && newJSON.style.VisibleArr) {
              const wasFullyHidden = newJSON.style.fromSetTabStyle === true;
              const ind = newJSON.style.VisibleArr?.indexOf(parseInt(index));
              if(ind !== -1){
                newJSON.style.VisibleArr.splice(ind,1);
              }
              if(wasFullyHidden){
                newJSON.style.Visible = true;
                // tab was fully hidden, select the first sheet that is now visible instead of the previously active (hidden) one
                redirectActiveSheetIfHidden(newJSON);
              }
            }
          }
        }else{
          if(attribute.toLowerCase() === 'enable' || attribute.toLowerCase() === "readonly" || attribute.toLowerCase() === "readonlystyle") { 
            if(eleJSON.style) {
              eleJSON.style[attribute] = attributeValue;
            }
            else {
              eleJSON.style = {};
              eleJSON.style[attribute] = attributeValue;
            }
            // if(attribute === "Enable") {
              // eleJSON.style["previousEnable"] = attributeValue;
              eleJSON.style.isChangeFromAPI = true;
            // }
            // if(attribute === "ReadOnlyStyle") {
            //   eleJSON.style["previousReadOnly"] = attributeValue;
            // }
            // if(attribute === "ReadOnly") {
            //   eleJSON.style["previousReadOnlyValue"] = attributeValue;
            // }
            changeControlProperty(attributeValue,attribute,eleJSON);
          }
          else {
            newJSON.style[`${attribute}sheetIndex`] = index;
            newJSON.style[attribute] = attributeValue;
          }          
        }
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(newJSON) && newJSON?.id)
            functions.renderElementsArray.add(newJSON?.id)
          if(newJSON.style.fromSetTabStyle && (attributeValue===true||attributeValue==="true")) {
            if(document.getElementById(tabId)?.closest(`[elem_type=column]`)) {
              const colID = document.getElementById(tabId)?.closest(`[elem_type=column]`).getAttribute('id');
              if(!functions.renderElementsArray?.has(colID))
                functions.renderElementsArray.add(colID);
            }
            // clear the flag now that the fully-hidden -> visible transition has been handled, so it doesn't re-trigger on later calls
            delete newJSON.style.fromSetTabStyle
          }
        // }
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(newJSON?.id);
        // }
        functions.render = true;
      }
      else {
        functions.showMess(["setTabStyle","Not_Valid",tabId],"error");
      }
  }
  else {
    functions.showMess(["The_Control",tabId,"Not_Present"],"error");
  }
  }
  const setTabStyleByName = (tabId, name, attribute, attributeValue) => {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,tabId,'control');
    if(eleJSON){      
      if(validControls.setTabStyleByName.includes(eleJSON?.elem_type)) {
        eleJSON = eleJSON.children.filter(ele => ele.tabChildName === name);
        setTabStyle(tabId, eleJSON[0].sheetIndex, attribute, attributeValue);
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
        functions.render = true;
      }
      else {
        functions.showMess(["setTabStyleByName","Not_Valid",tabId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",tabId,"Not_Present"],"error");
    }
  }

  const setButtonDropDown = (controlId, jsonObj = {}) => {

    if(!validateParams(apiValidationObjects.setButtonDropDown, {controlId, jsonObj}, "setButtonDropDown")) return;

    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId);
    if(!eleJSON) {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
      return;
    }
    
    if(!validControls.setButtonDropDown.includes(eleJSON?.elem_type)) {
      functions.showMess(["setButtonDropDown","Not_Valid",controlId],"error");
      return;
    }

    eleJSON.isButtonDropDown = true;
    eleJSON.buttonOptionsJSON = jsonObj;

    if(!notContainParent(eleJSON) && eleJSON?.id)
      functions.renderElementsArray.add(eleJSON?.id)
    functions.render = true;
  }

  const controlsNotApplicable = ["report","captcha","imagecarousel","richtexteditor","password"];
  const mandatoryNotApplicable = ["button", "label", "link", "listview", "advancelistview", "image", "tab", "paragraph", "report","captcha","imagecarousel","richtexteditor", "frame", "table"];

  const openExternalForm = (folderName, cabinetName) => {
    let containerId = getContainerId()
    const contexts = getGlobalContext(containerId);
    const { setExternalFormOpen } = contexts;
    const jsonToSend = {
      "folderName": folderName,
      "cabinetName": cabinetName,
      'openInWI': window?.openedFromWorkSpace ? window?.openedFromWorkSpace() ? "Y" : "N" : "N",
    }
    const url = new URL(window.location.href);
    const authorization = url.searchParams.get('authorization');
    if(authorization) {
      axios.defaults.headers.common["Authorization"] = authorization;   
      secureSessionStorage.setItem("Authorization",authorization);
    }
    axios.post("/viewform/openInterface", jsonToSend, { withCredentials: true }).then((response) => {
      let containerID = containerId || "default"
      const state = formStateStore.getState();
      if(containerId===undefined){
        containerId=state.containerInfo.containerId;
      }
      const setFormState2 = (state.data.find(json => json.key === containerId))?.contexts?.setFormState2;
      const wiValue = response?.data?.witoken || getWIToken();
      const gdValue = response?.data?.gdtoken || getGdToken();
      if(response?.data?.authorizationBypass) {
        const keyValue = JSON.stringify({
          token: response?.data?.authorizationBypass || "",
        });
        secureLocalStorage.setItem(window.isPortalLive ?  `launchpadKey_${window.applicationName}` : "launchpadKey", keyValue);
        axios.defaults.headers.common["Authorization"] = response?.data?.authorizationBypass;
      }
      if(response?.headers?.ngsmtoken){
        secureLocalStorage.setItem("ngsmtoken" , response?.headers?.ngsmtoken);
        axios.defaults.headers.common["ngsmtoken"] = response?.headers?.ngsmtoken || "";
      }
      formStateStore.dispatch(updateStore({ name: "witoken", value: wiValue, key: containerID}))
      formStateStore.dispatch(updateStore({ name: "gdtoken", value: gdValue, key: containerID}))
      setFormState2(JSON.parse(response?.data?.formBuffer));
      formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: new Date()}));
      setExternalFormOpen(true)
    }).catch((error) => {
      console.log(error)
    })
  }

  const getInterfaceData = async () => {
    let result = "";
    const jsonToSend = {
      "gdtoken":getGdToken(),
      "witoken": getWIToken(),
      "isSaveFlag": false
      }
    await axios.post("/viewform/getAttributeXml", jsonToSend, { withCredentials: true}).then((response) =>{
      result = response?.data?.AttributeXml
    }).catch((error) => {
      console.log(error)
    })
    return result
  }

  const loadImageFromUrl = (controlId, URL) => {
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,controlId,'control');

    if(eleJSON){
      eleJSON.style.imageUrl = URL;
      eleJSON.style.uploadType = 'url';
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
  }

  const hideAlertMessage = (toshow = false) => {
    functions.showAlertMessage = toshow;
  }
  // const hideAlertMessage = () => {
  //   functions.showAlertMessage = false
  // }

  const saveApplicationData = (isSubmit, cleanSession , eventSource, silentFlag) => {
    const containerId = getContainerId()
    let formjson = functions.getFormJsonFromStore();
    const contexts = getGlobalContext(containerId);
    const {activeApplication, openingAsApplication, microFrontendData, appname, activePage} = contexts
    const activeStepIndex = getStepIndex(containerId);
    const activeSubStepIndex = getSubStepIndex(containerId);
    const wizardJSON = formjson?.children[1]?.children[1]?.children;
    const subformName = (activeSubStepIndex && activeSubStepIndex?.toString() !== "-1") || activeSubStepIndex == 0 ? wizardJSON?.[activeStepIndex]?.children?.[activeSubStepIndex]?.subformName : wizardJSON?.[activeStepIndex]?.subformName;
    const applicationId =activeApplication?.applicationId || openingAsApplication?.applicationId || microFrontendData?.applicationId ;
    const applicationName = activeApplication?.applicationName || openingAsApplication?.applicationName || microFrontendData?.applicationName || appname;
    
  
    const applicationDataJson = {
      "applicationId": applicationId,
      "applicationName": applicationName,
      "formName": subformName || "",
      "isBackClicked": false,
      "stepIndex": activeStepIndex || "0",
      "stepSubIndex": activeSubStepIndex || "0",
      "submitApplication": isSubmit || "N",
      "gdtoken": getGdToken(),
      "witoken": getWIToken(),
      "cleanSession" : cleanSession || "",
      "eventSource" : eventSource || ""
    }

    const response = saveApplicationData1(applicationDataJson,true);
    if(response?.status === 200 && !silentFlag){
      functions.showMess(["Data saved successfully."],"success");
    }
    if (response?.headers?.error === "1"){
      functions.showMess(["We encountered an issue while submitting your application. Please try again after some time."], "error");

    }
    else if (response?.headers?.error === "2"){
      functions.showMess(["We encountered an issue while submitting your application. Please try again after some time."], "error");

    }
    else if (response?.headers?.error === "3"){
      functions.showMess(["We encountered an issue while submitting your application. Please try again after some time."], "error");

    }
    else if(response?.data?.error === "Y") {
        functions.showMess(["There is some issue at server end. Kindly check with system administrator."],"error");
    }
    if (
      response?.headers?.workitemlist !== undefined &&
      response?.headers?.workitemlist !== ""
    ) {
      // shivam_review correction needed @parth (workitemlist message stopped coming )
      if (window.showSuccessMessageInApplication) {
        window.showSuccessMessageInApplication(response.headers.workitemlist);
      }else{
        functions.showMess([`${response.headers.workitemlist} ${"saved successfully"}`], "success")
      }
    }

    try {
      if(window?.postSaveApplication) {
          window.postSaveApplication();
          functions.updateJSON()
      }
    } catch(err){
        console.log("postSaveApplication error", err);
    }

  }

  const reOrderColumns = (controlId = "", columnNames = []) => {

    if(!validateParams(apiValidationObjects.reOrderColumns, {controlId, columnNames}, "reOrderColumns")) return;

    const formjson = functions.getFormJsonFromStore();
    let eleJSON = recursiveJsonReader1(formjson, controlId, 'control');

    if(eleJSON){
      if(validControls.reOrderColumns.includes(eleJSON?.elem_type)) {
          let dupedVals = new Set(columnNames).size !== columnNames.length
          if(dupedVals) {console.error("Duplicate column names found."); return;}
          let newColObj = {};
          for(let i = 0; i < eleJSON?.columnList?.length; i++) {
            if(columnNames?.includes(eleJSON.columnList[i]?.style.ColumnName)) {
                newColObj[eleJSON.columnList[i]?.style.ColumnName] = eleJSON.columnList[i];
                eleJSON?.columnList?.splice(i--,1);
            }
          }
          for(let i = columnNames?.length - 1; i >= 0; i--) {
            eleJSON?.columnList?.unshift(newColObj[columnNames[i]]);
          }
          if(eleJSON?.elem_type?.toLowerCase() === "listview") {
            const row = eleJSON.listviewFrameLayoutJson?.children?.[0]?.children?.[0]?.children?.[0]?.children || [];  
            if(row?.length) {
              let newControlObj = {};
              for(let i = 0; i < row?.length; i++) {
                if(columnNames?.includes(row[i].children?.[0]?.style?.ColumnName)) {
                    newControlObj[row[i].children?.[0]?.style?.ColumnName] = row[i];
                    row?.splice(i--,1);
                }
              }
              for(let i = columnNames?.length - 1; i >= 0; i--) {
                row?.unshift(newControlObj[columnNames[i]]);
              }   
              eleJSON.listviewFrameLayoutJson.children[0].children[0].children[0].children = row;
              eleJSON.style.columnChanges = new Date();
            }
          }
          // if(functions.fromExecuteServerEvent){
            if(!notContainParent(eleJSON) && eleJSON?.id)
              functions.renderElementsArray.add(eleJSON?.id)
          // }
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
          functions.render = true;
      }
      else {
        functions.showMess(["reOrderColumns","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  }
  function setinputvalidation(Id, attribute, value){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,Id,'control');

    if(eleJSON && !controlsNotApplicable.includes(eleJSON.elem_type)){
      eleJSON.calledFromAPI = true;
      if(!eleJSON.style)
        eleJSON.style = {};
      eleJSON.style.updateFormState = Date.now();
    
      if(attribute === "numerals") {
        if(value === true || value === "true" || value === "false" || value === false) {
          if(eleJSON.style.Numerals !== value){
          if(value === true || value === "true" )
          {
            eleJSON.style.Numerals = "true";
          }
          else if(value === false || value === "false"){
            eleJSON.style.Numerals = "false";
          }
        }
      }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      if(attribute === "alphabets") {
        if(value === true || value === "true" || value === "false" || value === false) {
          if(eleJSON.style.Alphabets !== value){
          if(value === true || value === "true" )
          {
            eleJSON.style.Alphabets = "true";
          }
          else if(value === false || value === "false"){
            eleJSON.style.Alphabets = "false";
          }
        }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      if(attribute === "specialchar") {
        if(value === true || value === "true" || value === "false" || value === false) {
          if(eleJSON.style.AllowSpecialChars !== value){
          if(value === true || value === "true" )
          {
            eleJSON.style.AllowSpecialChars = "true";
          }
          else if(value === false || value === "false"){
            eleJSON.style.AllowSpecialChars = "false";
          }
        }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      if(attribute === "spaces") {
        if(value === true || value === "true" || value === "false" || value === false) {
          if(eleJSON.style.Spaces !== value){
          if(value === true || value === "true" )
          {
            eleJSON.style.Spaces = "true";
          }
          else if(value === false || value === "false"){
            eleJSON.style.Spaces = "false";
          }
        }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      if(attribute === "maxvalue") {
        if(value) {
          if(eleJSON.style.MaxValue !== value){
          eleJSON.style.MaxValue = value;
          }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      if(attribute === "maxlength") {
        if(value) {
          if(eleJSON.style.MaxLength !== value){
          eleJSON.style.MaxLength = value;
          }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      if(attribute === "minvalue") {
        if(value) {
          if(eleJSON.style.MinValue !== value){
          eleJSON.style.MinValue = value;
          }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
  }
  else {
    if(functions.showAlertMessage){
      functions.showMess(["The_Control",Id,"Not_Present"],"error");
    }
  }
  }
  function removeError(controlId){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, 'control');
    if (eleJSON){
    eleJSON.style.removeError = "true";
    if(eleJSON.style.helpertext)
    {
      delete eleJSON.style.helpertext
    }
    eleJSON.style.updateFormState1 = Date.now();
    delete eleJSON.style.bordercolortext;
    // if(!functions.fromExecuteServerEvent){
    //   updateRenderState(eleJSON?.id);
    // }
      if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
    functions.render = true;
    }
  }
  function setCaption(controlId, Caption) {
    if(!validateParams(apiValidationObjects.setCaption, {controlId, Caption}, "setCaption")) return;
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, 'control');
    if (eleJSON) {
        if (validControls.setCaption.includes(eleJSON?.elem_type)) {
            eleJSON.calledFromAPI = true;
            eleJSON.style.Label = Caption;
            // if(functions.fromExecuteServerEvent){
              if(!notContainParent(eleJSON) && eleJSON?.id)
                functions.renderElementsArray.add(eleJSON?.id)
            // }
            // eleJSON.style.updateFormState = Date.now();
            // if(!functions.fromExecuteServerEvent){
            //   updateRenderState(eleJSON?.id);
            // }
            functions.render = true;
        } else {
            functions.showMess(["setCaption", "Not_Valid", controlId], "error");
        }
    } else {
        functions.showMess(["The_Control", controlId, "Not_Present"], "error");
    }
}

function showMessageBelow(controlId,helpertextmessage,color)
{
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, "control");
    if (eleJSON){
      eleJSON.style.helpertext = helpertextmessage;
      eleJSON.style.bordercolortext = color;
      // eleJSON.style.bordercolororiginal = eleJSON.style.BorderColor;
      //eleJSON.style.ValidationMessage = helpertextmessage;
      eleJSON.style.removeError ="";
      eleJSON.style.updateFormState2 = Date.now();
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }

}

  function applyGridBatching(controlId, action) {
    const formjson = functions.getFormJsonFromStore();
    let eleJSON = recursiveJsonReader1(formjson, controlId, 'control');

    if(eleJSON){
      if(validControls.applyGridBatching.includes(eleJSON?.elem_type)) {
        if(action === "previous") {
          eleJSON.batchingAction = "previous";
        } else if(action === "next") {
          eleJSON.batchingAction = "next";
        }
        functions.render = true;
        eleJSON.calledFromAPI = true;
      }
      else {
        functions.showMess(["applyGridBatching","Not_Valid",controlId],"error");
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  }

  function helperTextExistsOrNot(controlId){
    var formjson = functions.getFormJsonFromStore();
    var eleJSON = recursiveJsonReader1(formjson, controlId, 'control');
    if (eleJSON){
      if(validControls.helperTextExistsOrNot.includes(eleJSON?.elem_type)) {
        return eleJSON?.style?.helpertext
      }
      else {
        functions.showMess(["helperTextExistsOrNot","Not_Valid",controlId],"error");     
      }
    }
    else {
      functions.showMess(["The_Control",controlId,"Not_Present"],"error");
    }
  }

  const setRadioOptionsHideOrShow =(Id, attribute, value, optionIndex) =>{
    var formjson = functions.getFormJsonFromStore();
    var eleJSON=recursiveJsonReader1(formjson,Id,'control');
    if(eleJSON && eleJSON.elem_type==="radio"){
      if(attribute.toLowerCase() === "visible"){
        if(value === true || value === "true" || value === "false" || value === false) {
          if(eleJSON?.options?.length>0)
          {
          eleJSON?.options?.some((option,index)=>{
            if(optionIndex.includes(index)){
              eleJSON.options[index].Visible=value;
            }
          })
          // if(!functions.fromExecuteServerEvent){
          //   updateRenderState(eleJSON?.id);
          // }
            if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
          functions.render = true;
        }
      }
    }
    else{
      functions.showMess(["Invalid_Operation"],"error");
    }
    }
    else{
      functions.showMess(["Invalid_Operation"],"error");
    }
  }

  const setStyle = ({Id, attribute, value,frameJson,forcefull})=>{
    attribute = attribute.toLowerCase()
    if(!validateParams(apiValidationObjects.setStyle, {Id, attribute, value,frameJson,forcefull}, "setStyle")) return;

    if(getFormMataData() && attribute === "disable" && functions.getWorkItemData("mode")=== "R"){
      (forcefull === "true" || forcefull === true) && setStyle2({Id, attribute, value,frameJson})
    } 
    else setStyle2({Id, attribute, value,frameJson})
  } 
  const setStyle2 = ({Id, attribute, value,frameJson})  =>{
    var formjson = functions.getFormJsonFromStore();
    const isVisibleAttribute = (attribute || "").toLowerCase() === "visible";
    let visibleFlag = 0
    var eleJSON=recursiveJsonReader1(formjson,Id,'control', isVisibleAttribute);
    const isListviewFrame = eleJSON && eleJSON.isInsideListview && eleJSON.id.includes("_frameLV");
    if(isListviewFrame && isVisibleAttribute) {
      functions.showMess(["The_Attribute",attribute,"Not_Valid_Control",Id],"error");
      return;
    }
    if(eleJSON && !controlsNotApplicable.includes(eleJSON.elem_type)){
      if(!eleJSON.style)
        eleJSON.style = {};
    if(eleJSON.elem_type === "link") {
      if(attribute.toLowerCase()=== "visible") {
        if(value === true || value === "true" || value === "false" || value === false) {
          value = value + ""
          if(eleJSON.style.Visible !== value){
            eleJSON.style.Visible=value+"";
            visibleFlag = 1
          }
          else{
            return
          }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      else if(attribute.toLowerCase() === "disable") {
        if(value === true || value === "true" || value === "false" || value === false) {
          value = value + ""
          if(value === "true" || value === true) {
            let d = eleJSON.style.Enable + ""
            eleJSON.style.isChangeFromAPI = true;
            if(d === "false" && value === "true"){
              return
            }
            eleJSON.style.Enable = "false";
            eleJSON.style.Editable  = "false";
            // eleJSON.style.previousEnable = "false";
          } else if(value === "false" || value === false) {
            let d = eleJSON.style.Enable + ""
            eleJSON.style.isChangeFromAPI = true;
            if(d === "true" && value === "false"){
              return
            }
            eleJSON.style.Enable = "true";
            eleJSON.style.Editable  = "true";
            // eleJSON.style.previousEnable = "true";
          } 
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
    }
    else if (eleJSON.elem_type === 'tile') {
      if(attribute.toLowerCase() === "disable") {
        if(value === "true" || value === "false" || value === true || value === false) {
          value = value + "";
          // for(let i = 0; i < eleJSON.tileContents.length; i++) {
            if(value === "true" || value === true) {
              let d = eleJSON?.style?.Enable + "";
              eleJSON.style.isChangeFromAPI = true;
              if(d === "false" && value === "true"){
                return
              }
              eleJSON.style.Enable = "false";
              eleJSON.style.Editable  = "false";
              // eleJSON.style.previousEnable = "false";
            } else if(value === "false" || value === false) {
              let d = eleJSON?.style?.Enable + "";
              eleJSON.style.isChangeFromAPI = true;
              if(d === "true" && value === "false"){
                return
              }
              eleJSON.style.Enable = "true";
              eleJSON.style.Editable  = "true";
              // eleJSON.style.previousEnable = "true";
            } 
          // }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
      else if (attribute.toLowerCase() === 'visible') {
        if(value === true || value === "true" || value === "false" || value === false) {
          value = value + "";
          if(eleJSON.style.Visible !== value){
            eleJSON.style.Visible=value+"";
            visibleFlag = 1
          }
          else{
            return
          }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
    }
    else if (attribute.toLowerCase() === "placeholder") {
      if(value){
        eleJSON.style.Placeholder = value;
      }     
     else {
        functions.showMess(["The_Attribute", attribute, "Not_Valid_Control", Id], "error");
    }
  }
    else if (attribute.toLowerCase() === "tooltip") {
      if(value){
        eleJSON.style.ToolTip = value;
      }     
     else {
        functions.showMess(["The_Attribute", attribute, "Not_Valid_Control", Id], "error");
    }
  }
    else if(eleJSON.elem_type === 'label' && attribute.toLowerCase() === "disable") {
      if(value === true || value === "true" || value === "false" || value === false) {
        value = value + "";
        if(value === "true" || value === true) {
          let d = eleJSON?.style?.Enable + "";
          eleJSON.style.isChangeFromAPI = true;
          if(d === "false" && value === "true"){
            return
          }
          eleJSON.style.Enable = "false";
          eleJSON.style.Editable  = "false";
          // eleJSON.style.previousEnable = "false";
        } else if(value === "false" || value === false) {
          let d = eleJSON?.style?.Enable + "";
          eleJSON.style.isChangeFromAPI = true;
          if(d === "true" && value === "false"){
            return
          }
          eleJSON.style.Enable = "true";
          eleJSON.style.Editable  = "true";
          // eleJSON.style.previousEnable = "true";
        } 
      }
      else {
        functions.showMess(["Invalid_Operation"],"error");
      }
    }
    else if (attribute.toLowerCase() === 'visible') {
      if(value === true || value === "true" || value === "false" || value === false) {
        value = value + "";
        if(eleJSON.style.Visible !== value){
          eleJSON.style.Visible=value+"";
          visibleFlag = 1
          if(eleJSON.elem_type === "doclist") {
            eleJSON.style.updateFormState = Date.now();
          }
        }
        else{
          return
        }
      }
      else {
        functions.showMess(["Invalid_Operation"],"error");
      }
    }
    else if (attribute.toLowerCase() === 'disable') {
      if(eleJSON.controlName=== "tile" && !eleJSON?.tileContents){
          functions.showMess(["Invalid_Operation"],"error");
      }
      else{
      if(value === true || value === "true" || value === "false" || value === false) {
        value = value + "";
        if(value === "true" || value === true) {
          let d = eleJSON?.style?.Enable + ""
          eleJSON.style.isChangeFromAPI = true;
          if(d === "false" && value === "true"){
            return
          }
          eleJSON.style.Enable = "false";
          eleJSON.style.Editable  = "false";
          if(eleJSON.elem_type === "textbox") {
            eleJSON.style.prevAutoComplete = eleJSON.style.AutoComplete;
            eleJSON.style.AutoComplete = false;
          }
          // eleJSON.style.previousEnable = "false";
        } else if(value === "false" || value === false) {
          let d = eleJSON?.style?.Enable + ""
          eleJSON.style.isChangeFromAPI = true;
          if(d === "true" && value === "false"){
            return
          }
          if(eleJSON.elem_type === "textbox" && eleJSON.style.prevAutoComplete) {
            eleJSON.style.AutoComplete = eleJSON.style.prevAutoComplete;
          }
          eleJSON.style.Enable = "true";
          eleJSON.style.Editable  = "true";
          // eleJSON.style.previousEnable = "true";
        } 
        if(eleJSON.elem_type === "doclist") {
          eleJSON.style.updateFormState = Date.now();
        }
        if(eleJSON.elem_type === "frame") {
          eleJSON.style.EnableUpdatedFromAPI = eleJSON.style.Enable;
        }
        if(validChangeControlElemType?.includes(eleJSON?.elem_type?.toLowerCase())){
          if(eleJSON?.elem_type?.toLowerCase() === "listview"){
            const advJSON =  getSubFormListviewJsonFromStore()?.listviewFrameLayoutJson;
            changeControlProperty(eleJSON.style.Enable,"Enable",advJSON); 
          }
          else if(eleJSON?.elem_type?.toLowerCase() === "advancelistview"){
            const advJSON =  fetchGridStates()?.currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
            changeControlProperty(eleJSON.style.Enable,"Enable",advJSON); 
          }
          else{
            changeControlProperty(eleJSON.style.Enable,"Enable",eleJSON);
          }
        }
      }
      else {
        functions.showMess(["Invalid_Operation"],"error");
      }  
      }         
    }
    else if (attribute?.toLowerCase() === 'readonly') {
      if(value === true || value === "true" || value === "false" || value === false) {
        value = value + "";
        if(value === true || value === "true")
        {
          let d = eleJSON?.style?.ReadOnly + "";
          if(d === "true" && value === "true"){
            return
          }
          eleJSON.style.ReadOnly = true;
          if(eleJSON.elem_type === "textbox")
            eleJSON.style.AutoComplete = false;

          if((eleJSON.elem_type === "table" || eleJSON.elem_type === "listview" || eleJSON.elem_type === "advancelistView" || eleJSON.elem_type === "advancelistview" || eleJSON.elem_type === "doclist")){
              eleJSON.style.Enable = "false";
          }
          // eleJSON.style.previousReadOnlyValue = true;
        }
        else if(value === false || value === "false")
        {
          let d = eleJSON?.style?.ReadOnly + "";
          if(d === "false" && value === "false"){
            return
          }
          eleJSON.style.ReadOnly = false;
          if((eleJSON.elem_type === "table" || eleJSON.elem_type === "listview" || eleJSON.elem_type === "advancelistView" || eleJSON.elem_type === "advancelistview" || eleJSON.elem_type === "doclist")){
              eleJSON.style.Enable = "true";
          }
          // eleJSON.style.previousReadOnlyValue = false;
        }
        if(validChangeControlElemType?.includes(eleJSON?.elem_type?.toLowerCase())){
          if(eleJSON?.elem_type?.toLowerCase() === "advancelistview" || eleJSON?.elem_type?.toLowerCase() === "listview"){
            changeControlProperty(eleJSON.style.ReadOnly,"ReadOnly",eleJSON?.listviewFrameLayoutJson); 
          }
          else{
            changeControlProperty(eleJSON.style.ReadOnly,"ReadOnly",eleJSON);
          }
        }
      }
      else {
        functions.showMess(["Invalid_Operation"],"error");
      }
      
    }
    else if (attribute?.toLowerCase() === 'readonlystyle') {
      if(value === true || value === "true" || value === "false" || value === false) {
        if(value === true || value === "true")
        {
          eleJSON.style.ReadOnlyStyle = true;
          if(eleJSON.elem_type === "textbox")
            eleJSON.style.AutoComplete = false;

          if((eleJSON.elem_type === "table" || eleJSON.elem_type === "listview" || eleJSON.elem_type === "advancelistView" || eleJSON.elem_type === "advancelistview")){
              eleJSON.style.Enable = "false";
          }
          // eleJSON.style.previousReadOnly = true;
          // eleJSON.style.Enable = "false";
          // eleJSON.style.Editable  = "false";
          // eleJSON.style.ControlStyle="Style4";
        }
        else if(value === false || value === "false")
        {
          eleJSON.style.ReadOnlyStyle = false;

          if((eleJSON.elem_type === "table" || eleJSON.elem_type === "listview" || eleJSON.elem_type === "advancelistView" || eleJSON.elem_type === "advancelistview")){
              eleJSON.style.Enable = "true";
          }
          // eleJSON.style.previousReadOnly = false;
          // eleJSON.style.Enable = "true";
          // eleJSON.style.Editable  = "true";
          // eleJSON.style.ControlStyle="Style1";
        }
        if(validChangeControlElemType?.includes(eleJSON?.elem_type?.toLowerCase())){
          if(eleJSON?.elem_type?.toLowerCase() === "advancelistview" || eleJSON?.elem_type?.toLowerCase() === "listview"){
            changeControlProperty(eleJSON.style.ReadOnlyStyle,"ReadOnlyStyle",eleJSON?.listviewFrameLayoutJson); 
          }
          else{
            changeControlProperty(eleJSON.style.ReadOnlyStyle,"ReadOnlyStyle",eleJSON);
          }
        }
      }
      else {
        functions.showMess(["Invalid_Operation"],"error");
      }
      
    }
    else if (attribute.toLowerCase() === 'lock') {
      if(eleJSON.elem_type === "frame")
        eleJSON.style.DisableCollapse=value; 
      else {
        functions.showMess(["The_Attribute",attribute,"Not_Valid_Control",Id],"error");
      }
    }
    else if(attribute.toLowerCase() === 'custompattern') {
      functions.setCustomPattern(Id,value,true);
    }
    else if (attribute.toLowerCase() === 'charcase') {
      if(value === "up")
      value ="UpperCase";
      else if(value === "low")
      value="lowercase";
      eleJSON.style.CharacterSet=value;
    }
    else if (attribute.toLowerCase() === 'mandatory' ) {
      if((value === true || value === "true") && mandatoryNotApplicable.includes(eleJSON?.elem_type)){
        return
      }
      else if(value === true || value === "true" || value === "false" || value === false) {
          value = value + "";
          if(eleJSON?.style?.Mandatory !== value){
            eleJSON.style.Mandatory=value+"";
            if(eleJSON.elem_type === "doclist") {
              eleJSON.style.updateFormState = Date.now();
            }
            if(eleJSON?.isInsideListview) {
              const [tableId, columnName] = eleJSON?.id?.split(/_(.*)/s);
              const tableJSON = functions.readJson(formjson, tableId);
              tableJSON?.columnList?.map((column) =>  {
                if(column.style.ColumnName === columnName){
                  column.style.mandatory = eleJSON.style.Mandatory === "true" ? 'Y' : 'N';
                }
              })
            }
          }
          else{
            return
          }
      }
      else {
        functions.showMess(["Invalid_Operation"],"error");
      }
    }
   else if(attribute.toLowerCase() == "backcolor")
    {
      if(eleJSON.elem_type === "button"){
        eleJSON.style.BackgroundColor=value+"";
      }
      else if(eleJSON.elem_type !== "CustomControl" || eleJSON.elem_type !== "toggle" || eleJSON.elem_type !== "checkbox" || eleJSON.elem_type !== "button") {
          eleJSON.style.BackColor=value+"";
      }      
      else {
        functions.showMess(["The_Attribute",attribute,"Not_Valid_Control",Id],"error");
      }
    }
   else if(attribute.toLowerCase() == "fontcolor")
    {
        if(eleJSON.elem_type === "CustomControl") {
          eleJSON.style.color = value+"";
          eleJSON.style.FontColorSlider = value + "";
        }
        if(eleJSON.elem_type === "combo"){
          eleJSON.style.ValueFontColor=value+"";
        } else {
          eleJSON.style.FontColor=value+"";
        }
    }
    else if(attribute.toLowerCase() == "allowdownload")
      {
        const isControlGrid = isGrid(eleJSON.elem_type);
  
        if(isControlGrid) {
          eleJSON.style["AllowDownload"] = value + "";
        }
      }
   else if(attribute.toLowerCase() == "fontfamily")
    {
      if(eleJSON.elem_type === "combo"){
        eleJSON.style.ValueFontFamily=value+"";
      } else {
        eleJSON.style.FontFamily=value+"";
      }
    }
   else if(attribute.toLowerCase() == "sectionstate") {
      if(value === "expanded" ) {
          eleJSON.style.changeSectionState = true;
          if( eleJSON.style.forcefullychangestate ){
            eleJSON.style.forcefullychangestate = false;
          }
          else{
            eleJSON.style.forcefullychangestate = true;
          }
          eleJSON.style.sectionState = "expanded";
          if (
            !eleJSON.style.callOnlyOnce && !eleJSON.loadSection &&
            (eleJSON.style?.FrameState === true ||
              eleJSON.style?.FrameState === "true") &&
              !eleJSON.style.callOnlyOnce && (eleJSON?.style?.DataOnDemand === "true" ||
              eleJSON?.style?.DataOnDemand === true)
          ) {
              eleJSON.style.callOnlyOnce = true;
              eleJSON.style.FrameState = false;
              functions.refreshFrame(eleJSON?.id, true, false);
          }
      }
      else if(value === "collapsed") {
          eleJSON.style.sectionState = "collapsed";
          if( eleJSON.style.forcefullychangestate ){
            eleJSON.style.forcefullychangestate = false;
          }
          else{
            eleJSON.style.forcefullychangestate = true;
          }
          eleJSON.style.changeSectionState = true;
      }      
   }
   else if(attribute.toLowerCase() === "loadsection" && frameJson) {
    eleJSON = {...frameJson, style: eleJSON.style};
    eleJSON.loadSection = true;
    updatePartialJSON(eleJSON.id,eleJSON);
  }
   else if(attribute.toLowerCase() == "fontweight")
    {
        const weightVal = ["regular italic","semibold","bold","regular","normal","bold italic","light italic","italic","semibold italic","light"]
        const newVal = value + "";
        if(weightVal.includes(newVal.toLowerCase())) {
          if(eleJSON.elem_type === "combo"){
            eleJSON.style.ValueFontWeight=value;
          } else {
            eleJSON.style.FontWeight=value; 
          }     
          eleJSON.style.LabelFontWeight=value; 
        }
        else {
          functions.showMess(["Invalid_Operation"],"error")
        }
      }
   else if(attribute.toLowerCase() == "fontstyle")
    {
      eleJSON.style.FontStyle=value+"";
    }
   else if(attribute.toLowerCase() == "fontsize")
    {
        if(value.includes('px')) {
            const size = parseInt(value.replace("px", "").trim(), 10);
            if(size <= 30) {
              if(eleJSON.elem_type === "combo"){
                eleJSON.style.ValueFontSize = value + "";
              } else {
                eleJSON.style.FontSize = value + "";
              }
            } else {
                functions.showMess(["Font size cannot be greater than 30px"], "error");
            }
        }
        else {
            functions.showMess(["Invalid_Operation"],"error");
        }
    }
   else if(attribute.toLowerCase() == "maxlength")
    {
        if(isNaN(value))
          functions.showMess(["Invalid_Operation"],"error");
        else
          eleJSON.style.MaxLength=isNaN(value) ? value: parseInt(value);
    }
    else if(attribute?.toLowerCase() == "minlength")
    {
        if(isNaN(value))
          functions.showMess(["Invalid_Operation"],"error");
        else
          eleJSON.style.MinLength=isNaN(value) ? value: parseInt(value);
    }
    else if(attribute.toLowerCase() == "maxdateascurrent" && eleJSON.elem_type === "datepick")
      {
        if(value === true || value === "true" || value === "false" || value === false) {
          if(value === true || value === "true")
          {
            eleJSON.style.MaxDateAsCurrent = "true";
          }
          else if((value === false || value === "false") && (eleJSON.style.MaxDateAsCurrent === true || eleJSON.style.MaxDateAsCurrent === "true"))
          {
            eleJSON.style.MaxDateAsCurrent = "false";
            // eleJSON.style.MaxDate = "";
            eleJSON.style.fromSetStyleApi = true
          }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
    else if(attribute.toLowerCase() == "mindateascurrent" && eleJSON.elem_type === "datepick")
      {
        if(value === true || value === "true" || value === "false" || value === false) {
          if(value === true || value === "true")
          {
            eleJSON.style.MinDateAsCurrent = "true";
          }
          else if((value === false || value === "false") && (eleJSON.style.MinDateAsCurrent === true || eleJSON.style.MinDateAsCurrent === "true"))
          {
            eleJSON.style.MinDateAsCurrent = "false";
            // eleJSON.style.MinDate = "";
            eleJSON.style.fromSetStyleApi = true
          }
        }
        else {
          functions.showMess(["Invalid_Operation"],"error");
        }
      }
    else if(attribute.toLowerCase() == "bordercolor"){
      eleJSON.style.BorderColor = value;
    }
    else if(attribute.toLowerCase() == "inactivestatecolor" && eleJSON.elem_type === "checkbox"){
      eleJSON.style.InActiveStateColor = value
    }
    else if(attribute.toLowerCase() == "activestatecolor" && eleJSON.elem_type === "checkbox"){
      eleJSON.style.ActiveStateColor = value
    }
    else if((attribute.toLowerCase() === "minimumvalue" || attribute.toLowerCase() === "maximumvalue") && (eleJSON.elem_type === "slider")) {
      const checkInvalidNum = Number.isNaN(parseInt(value));
      if(checkInvalidNum) {
        functions.showMess(["Invalid_Operation"],"error");
        return;
      }
      if(attribute.toLowerCase() === "minimumvalue") {
        if((parseInt(value) >= parseInt(eleJSON?.style?.MaximumValue)) || 
        ("value" in eleJSON && parseInt(value) > parseInt(eleJSON?.value))) {
          functions.showMess(["Invalid_Operation"],"error");
          return;
        } else {
          eleJSON.style.MinimumValue = parseInt(value);
          if(parseInt(value) > parseInt(eleJSON?.style?.DefaultValueSlider)) {
            eleJSON.style.DefaultValueSlider = parseInt(value);
          }
        }
      } else if(attribute.toLowerCase() === "maximumvalue") {
        if((parseInt(value) <= parseInt(eleJSON?.style?.MinimumValue)) || 
        ("value" in eleJSON && parseInt(value) < parseInt(eleJSON?.value))) {
          functions.showMess(["Invalid_Operation"],"error");
          return;
        } else {
          eleJSON.style.MaximumValue = parseInt(value);
          if(parseInt(value) < parseInt(eleJSON?.style?.DefaultValueSlider)) {
            eleJSON.style.DefaultValueSlider = parseInt(value);
          }
        }
      }
    } else {
      functions.showMess(["The_Attribute",attribute,"Not_Valid_Control",Id],"error");
    }
    // if(functions.fromExecuteServerEvent){
      if(attribute?.toLowerCase() === "visible"){
        if(visibleFlag === 1){
          eleJSON.style.updateFormState = Date.now();
          eleJSON.calledFromAPI = true;
          const c = propagateVisibility(eleJSON, formjson);
          console.log("returnvalue from propagateVisibility", c)
          if(!notContainParent(eleJSON) && eleJSON?.id && c === 0)
            functions.renderElementsArray.add(eleJSON?.id)
        }
      }
      else{
        eleJSON.style.updateFormState = Date.now();
        eleJSON.calledFromAPI = true;
        if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        }
    functions.render = true;
    }
    else {
      if(functions.showAlertMessage){
        functions.showMess(["The_Control",Id,"Not_Present"],"error");
      }
    }
  }

const checkElementInDOMForMandatory = (item) => {
  if (document.getElementById(item?.id) || document.getElementById(item?.controlId) || document.getElementById(item?.dataclass)) {
    return true
  }
  else
    return false
}  

const childControls = ["row","column","tab","sheet","frame"];

const invalidMandatoryControlsInGrids = ["label","button","link","tile","customcontrol"];

const validCheck = (json) => {
  if(json?.style?.Visible === false || json?.style?.Visible === "false")
    return false;
  else return true;
}

export const checkForAllNonFilledMandatoryFields = (jsonData, mandatoryControlsArray, obj = {}, type, extraDetails = {}) => {
  let result = true;
  if(jsonData !== undefined && jsonData != null)
  {
    if(type === "listviewSubform" && !extraDetails?.skipControlValidation?.includes(jsonData?.validationId)) {
      const mandatoryColumns = jsonData.columnList.filter(column => column.style.mandatory === "Y");
      mandatoryColumns.forEach(column => {
        const listviewControlValue = extraDetails.currentListviewColumnInfo.get(column.style.ColumnName);
        if(!listviewControlValue && listviewControlValue !== false) {
          const controlId = `${jsonData.id}_${column.style?.ColumnName}`;
          if(!extraDetails.skipControlValidation.includes(controlId)) {
            const formjson = functions.getFormJsonFromStore();
            const controlJSON = functions.readJson(formjson, controlId);
            if((controlJSON?.style.Mandatory === true || controlJSON?.style.Mandatory === "true") && (!invalidMandatoryControlsInGrids?.includes(controlJSON?.elem_type)) && ((controlJSON?.style?.Enable !== "false" && controlJSON?.style?.Enable !== false) || controlJSON?.style?.EnableMandatoryOnDisable === true || controlJSON?.style?.EnableMandatoryOnDisable === "true") && ((controlJSON?.style?.ReadOnly !== "true" && controlJSON?.style?.ReadOnly !== true) || controlJSON?.style?.EnableMandatoryOnDisable === true || controlJSON?.style?.EnableMandatoryOnDisable === "true") && ((controlJSON?.style?.ReadOnlyStyle !== "true" && controlJSON?.style?.ReadOnlyStyle !== true) || controlJSON?.style?.EnableMandatoryOnDisable === true || controlJSON?.style?.EnableMandatoryOnDisable === "true") && (controlJSON?.style?.Visible !== false && controlJSON?.style?.Visible !== "false")) {
              mandatoryControlsArray.push(controlId);
              console.log("mandatoryArr inside checkforAll", mandatoryControlsArray)
            }
          }
        } 
      })
    } else {
        if(jsonData?.children) {
          for(let i = 0; i < jsonData.children.length; i++) {
              if(jsonData.children[i].style && jsonData.children[i].id !== 'GroupInfo' && jsonData.children[i].id !== 'Event') {
                const shouldCheckValidation = !extraDetails?.skipControlValidation?.includes(jsonData.children[i]?.id) && !window.hideSteps?.includes(jsonData.children[i]?.id) && !window.hideSubSteps?.includes(jsonData.children[i]?.id);
                  if(jsonData.children[i].elem_type === "doclist" && shouldCheckValidation && (jsonData.children[i]?.style?.Enable === "true" || jsonData.children[i]?.style?.Enable === true ) && (jsonData.children[i]?.style?.ReadOnly === "false" || jsonData.children[i]?.style?.ReadOnly === false) && (jsonData.children[i]?.style?.ReadOnlyStyle === "false" || jsonData.children[i]?.style?.ReadOnlyStyle === false) && (jsonData.children[i]?.style?.Visible === true || jsonData.children[i]?.style?.Visible === "true")) { 
                    if(jsonData.children[i]?.json?.available_doc_types?.length) {
                      let enableMandatory = true;
                      jsonData.children[i]?.json?.available_doc_types.forEach(doc => {
                        if(doc?.mandatory && !doc?.isUploaded && !doc.hideDocType) {
                          if(enableMandatory){
                            mandatoryControlsArray.push(`${jsonData.children[i]?.id}`);
                            enableMandatory=false
                          }
                          mandatoryControlsArray.push(`${doc?.name}_${jsonData.children[i]?.id}`);
                        }
                      });
                    }
                  }
                  if((jsonData.children[i].style.Mandatory === true || jsonData.children[i].style.Mandatory === "true") && shouldCheckValidation && (jsonData.children[i]?.style?.Enable === "true" || jsonData.children[i]?.style?.Enable === true || jsonData.children[i]?.style?.EnableMandatoryOnDisable === true || jsonData.children[i]?.style?.EnableMandatoryOnDisable === "true") && (jsonData.children[i]?.style?.ReadOnly === "false" || jsonData.children[i]?.style?.ReadOnly === false || jsonData.children[i]?.style?.EnableMandatoryOnDisable === true || jsonData.children[i]?.style?.EnableMandatoryOnDisable === "true") && (jsonData.children[i]?.style?.ReadOnlyStyle === undefined || jsonData.children[i]?.style?.ReadOnlyStyle === "false" || jsonData.children[i]?.style?.ReadOnlyStyle === false || jsonData.children[i]?.style?.EnableMandatoryOnDisable === true || jsonData.children[i]?.style?.EnableMandatoryOnDisable === "true") && (jsonData.children[i]?.style?.Visible === true || jsonData.children[i]?.style?.Visible === "true")) {
                    if(jsonData.children[i].elem_type === "doclist") {
                      if(shouldCheckValidation && !jsonData.children[i]?.value?.length)
                        mandatoryControlsArray.push(jsonData.children[i].id);
                    } else if(jsonData.children[i].elem_type === "tile") {
                      let flag = false;
                      for(let j = 0; j < jsonData.children[i].tileContents.length; j++){
                        if(jsonData.children[i].tileContents[j]?.value === "true"){
                          flag = true;
                        }
                      }
                      if(!flag)
                        mandatoryControlsArray.push(jsonData.children[i].id);
                    } else if(jsonData.children[i].elem_type === 'checkbox' || jsonData.children[i].elem_type === 'toggle') {
                      if(jsonData.children[i].value === "false" || !jsonData.children[i].value || jsonData.children[i].value === '' || jsonData.children[i].value?.length === 0)
                        mandatoryControlsArray.push(jsonData.children[i].id);
                    }
                    else if(!jsonData.children[i].value || jsonData.children[i].value === '' || jsonData.children[i].value?.length === 0) {
                      if(jsonData.children[i]?.style?.Enable === "false" && jsonData.children[i]?.elem_type === "textbox" && jsonData.children[i]?.style?.EnableMandatoryOnDisable === "true"){
                        obj[jsonData.children[i].id] = true;
                      }
                      mandatoryControlsArray.push(jsonData.children[i].id);
                    }
                  }
                  if(childControls?.includes(jsonData.children[i]?.elem_type)) {
                    if(validCheck(jsonData.children[i]))
                      checkForAllNonFilledMandatoryFields(jsonData.children[i],mandatoryControlsArray,obj,type,extraDetails);    
                  }
                  else if (shouldCheckValidation)
                    checkForAllNonFilledMandatoryFields(jsonData.children[i],mandatoryControlsArray,obj,type,extraDetails);    
              }
              else {
                if(childControls?.includes(jsonData.children[i]?.elem_type)) {
                  if(validCheck(jsonData.children[i]))
                    checkForAllNonFilledMandatoryFields(jsonData.children[i],mandatoryControlsArray,obj,type,extraDetails);    
                }
                else 
                  checkForAllNonFilledMandatoryFields(jsonData.children[i],mandatoryControlsArray,obj,type,extraDetails);
              }
          }
      }
    }
  }
  return result;
}

const setCellDisableTable =(tableId,rowIndex,colIndex,disableFlag) =>  {
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'table');
  if(eleJSON){
    if(validControls.setCellDisableTable.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      if(eleJSON?.rowData && eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex] && eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex]?.style) {
        if(disableFlag === "true" || disableFlag === true)
          eleJSON.rowData[rowIndex][updatedColumnIndex].style.Disabled=true;
        else if(disableFlag === "false" || disableFlag === false)
          eleJSON.rowData[rowIndex][updatedColumnIndex].style.Disabled=false;
        eleJSON.style.updateFormState = Date.now();
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
    }
    else {
      functions.showMess(["setCellDisable","Not_Valid",tableId],"error")
    }
}
else {
  functions.showMess(["The_Control",tableId,"Not_Present"],"error");
}
}

const setCellImageInGrid = function(tableId,rowIndex,colIndex,image)
{
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellImageInGrid.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      if(image && eleJSON.rowData?.[rowIndex]?.[updatedColumnIndex]?.style) {
        eleJSON.rowData[rowIndex][updatedColumnIndex].style["TableButtonImageFile"]=image;
        eleJSON.style.updateFormState = Date.now();
        functions.render = true;
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      }

    }
    else {
      functions.showMess(["setCellImageInGrid","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setCellDisabled = function(tableId,rowIndex,colIndex,flag)
{

  if(!validateParams(apiValidationObjects.setCellDisabled, {tableId,rowIndex,colIndex,flag}, "setCellDisabled")) return;

  var formjson = functions?.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellDisabled.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      const disabled = flag === true || flag === "true";

      if (eleJSON.rowData?.[rowIndex]?.[updatedColumnIndex]) {
        eleJSON.rowData[rowIndex][updatedColumnIndex].style.Disabled = disabled
      } else if (eleJSON.columnList?.[updatedColumnIndex]?.style?.ColumnType === "button") {
        eleJSON.rowData[rowIndex][updatedColumnIndex] = {
          name: eleJSON.columnList?.[updatedColumnIndex]?.style?.ColumnName || eleJSON.columnList?.[updatedColumnIndex]?.style?.ButtonLabel,
          style: { Disabled: disabled },
          value: ""
        };
      }
      eleJSON.style.updateFormState = Date.now();

          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
    }
    else {
      functions.showMess(["setCellDisabled","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setCellContentVisible = function(tableId,rowIndex,colIndex,flag)
{

  if(!validateParams(apiValidationObjects.setCellContentVisible, {tableId,rowIndex,colIndex,flag}, "setCellContentVisible")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellContentVisible.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      if(flag == "true" || flag == true)
        eleJSON.rowData[rowIndex][updatedColumnIndex].style.ShowCellData=true;
      else if(flag == "false" || flag == false)
        eleJSON.rowData[rowIndex][updatedColumnIndex].style.ShowCellData=false;

        eleJSON.style.updateFormState = Date.now();
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
    }
    else {
      functions.showMess(["setCellContentVisible","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setColumnHeaderVisible = function(tableId, columnIndex, flag)
{

  if(!validateParams(apiValidationObjects.setColumnHeaderVisible, {tableId, columnIndex, flag}, "setColumnHeaderVisible")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setColumnHeaderVisible.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, columnIndex);
      if(flag == "true" || flag == true)
        eleJSON.columnList[updatedColumnIndex].style.ShowHeaderLabel=true;
      else if(flag == "false" || flag == false)
        eleJSON.columnList[updatedColumnIndex].style.ShowHeaderLabel=false;

        eleJSON.style.updateFormState = Date.now();
        if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
    }
    else {
      functions.showMess(["setColumnHeaderVisible","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setCellButtonCaption = function(tableId,rowIndex,colIndex,newCaption)
{
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellButtonCaption.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      if(newCaption){
        if(eleJSON.rowData?.[rowIndex]?.[updatedColumnIndex]) {
          eleJSON.rowData[rowIndex][updatedColumnIndex].style["ButtonLabel"]=newCaption;
        } else if(eleJSON.columnList?.[updatedColumnIndex]?.style?.ColumnType === "button") {
          eleJSON.rowData[rowIndex][updatedColumnIndex] = {
            name: eleJSON.columnList?.[updatedColumnIndex]?.style?.ColumnName || eleJSON.columnList?.[updatedColumnIndex]?.style?.ButtonLabel,
            style: { ButtonLabel: newCaption },
            value: ""
          };
        }
      }
      eleJSON.style.updateFormState = Date.now();
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
    else {
      functions.showMess(["setCellButtonCaption","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const getCellButtonCaption = function(tableId,rowIndex,colIndex)
{
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.getCellButtonCaption.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      const caption = eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex]?.style?.["ButtonLabel"] || eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex]?.value || eleJSON?.columnList?.[updatedColumnIndex]?.style?.ButtonLabel
      // console.log("API caption",caption)
      return caption;
    }
    else {
      functions.showMess(["getCellButtonCaption","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setCellLabelColor = function(tableId, rowIndex, colIndex, color){
  if(!validateParams(apiValidationObjects.setCellLabelColor, {tableId, rowIndex, colIndex, color}, "setCellLabelColor")) return;
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellLabelColor.includes(eleJSON?.elem_type)) {
      if (color){
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        eleJSON.rowData[rowIndex][updatedColumnIndex].style["LabelColor"]=color;
        eleJSON.style.updateFormState = Date.now();
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        // }
        functions.render = true;
      }
    }
    else {
      functions.showMess(["setCellLabelColor","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setCellBackgroundColor = function(tableId, rowIndex, colIndex, color){
  if(!validateParams(apiValidationObjects.setCellBackgroundColor, {tableId, rowIndex, colIndex, color}, "setCellBackgroundColor")) return;
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellBackgroundColor.includes(eleJSON?.elem_type)) {
      if (color){
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        eleJSON.rowData[rowIndex][updatedColumnIndex].style["BackColor"]=color;
        eleJSON.style.updateFormState = Date.now();
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        // }
        functions.render = true;
      }
    }
    else {
      functions.showMess(["setCellBackgroundColor","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const attributeKeyMap = {   
  "labelBackgroundColor": "BackgroundColor",
  "labelFontColor": "LabelColor",
  "labelBorderRadius": "BorderRadius"
}

const setCellStyle = function(tableId, rowIndex, colIndex, attributeName, attributeValue) {
  if(!validateParams(apiValidationObjects.setCellStyle, {tableId, rowIndex, colIndex, attributeName, attributeValue}, "setCellStyle")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');

  if (eleJSON) {
    if (validControls.setCellStyle.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      if (attributeName && 
          attributeValue !== undefined &&
          attributeValue !== null &&
          eleJSON?.rowData && 
          eleJSON.rowData?.[rowIndex]?.[updatedColumnIndex]) {

        const key = attributeKeyMap[attributeName]
        
        if (!key) {
          return;
        }
  
        const value =
          attributeValue === "true"
            ? true
            : attributeValue === "false"
              ? false
              : attributeValue;

        eleJSON.rowData[rowIndex][updatedColumnIndex].style ??= {};
        eleJSON.rowData[rowIndex][updatedColumnIndex].style[key]=value;
        eleJSON.style.updateFormState = Date.now();
        if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
    } else {
      functions.showMess(["setCellStyle","Not_Valid",tableId],"error");
    }
  } else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setCellBorderRadius = function(tableId, rowIndex, colIndex, borderRadius){
  if(!validateParams(apiValidationObjects.setCellBorderRadius, {tableId, rowIndex, colIndex, borderRadius}, "setCellBorderRadius")) return;
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellBorderRadius.includes(eleJSON?.elem_type)) {
      if (borderRadius){
        const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
        if(eleJSON?.rowData?.[rowIndex]?.[updatedColumnIndex]) {
        eleJSON.rowData[rowIndex][updatedColumnIndex].style["BorderRadius"]=borderRadius;
        eleJSON.style.updateFormState = Date.now();
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
        // if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        // }
        functions.render = true;
        } else functions.showMess([tableId," does not have any cell with row index: ",rowIndex," and column index: ",updatedColumnIndex],"error");
      }
    }
    else {
      functions.showMess(["setCellBorderRadius","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const disableCheckboxColumn = function(tableId, flag){
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if (eleJSON){
    if (validControls.disableCheckboxColumn.includes(eleJSON?.elem_type)){
      if (flag === "true" || flag === true) {
        eleJSON.style["disableCheckboxColumn"] = true
      } else if (flag === "false" || flag === false) {
        eleJSON.style["disableCheckboxColumn"] = false
      }
      eleJSON.style.updateFormState = Date.now();
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
        if(functions.fromExecuteServerEvent){
          if(!notContainParent(eleJSON) && eleJSON?.id)
          functions.renderElementsArray.add(eleJSON?.id)
        }
        functions.render = true;
    } else {
      functions.showMess(["setCellBorderRadius","Not_Valid",tableId],"error");
    }
  } else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
} 

const setTableCellFocus = function(tableId, rowIndex, colIndex){
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellBackgroundColor.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      const t_id = eleJSON?.id
      const cellToFocus = document.getElementById(`${t_id}_${rowIndex}_${updatedColumnIndex}`)
      if (cellToFocus){
        cellToFocus.focus()
        // document.activeElement.closest(".rs-table-row")?.scrollIntoView({
        //   behavior: "auto",
        //   block: "nearest"
        // });
        document.getElementById(t_id)?.scrollIntoView();
      } else {
        console.error(`Element with ID ${t_id}_${rowIndex}_${updatedColumnIndex} not found`);
      }
    }
    else {
      functions.showMess(["setTableCellFocus","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setListviewModalHeader = function(tableId, header){
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setListviewModalHeader.includes(eleJSON?.elem_type)) {
      if (header){
        if(eleJSON.popupStyle)
        eleJSON.popupStyle["AdvlistviewTitle"]=header;
        else{
          if(!eleJSON?.popupStyle){
            eleJSON.popupStyle = ThemeJSON?.advancelistviewPopup || {};
            eleJSON.popupStyle["AdvlistviewTitle"]=header;
          }
        }
        eleJSON.style.updateFormState = Date.now();
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        functions.render = true;
      }
    }
    else {
      functions.showMess(["setListviewModalHeader","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setCellButtonBGColor = function(tableId,rowIndex,colIndex,bgColor)
{
  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setCellButtonBGColor.includes(eleJSON?.elem_type)) {
      const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, colIndex);
      if(bgColor){
        eleJSON.rowData[rowIndex][updatedColumnIndex].style["TableButtonBGColor"] = bgColor;
      }

      eleJSON.style.updateFormState = Date.now();
      // if(!functions.fromExecuteServerEvent){
      //   updateRenderState(eleJSON?.id);
      // }
        if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
      functions.render = true;
    }
    else {
      functions.showMess(["setCellButtonBGColor","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const setTableColumnName = function(tableId, columnArray = [])
{

  if(!validateParams(apiValidationObjects.setTableColumnName, {tableId, columnArray}, "setTableColumnName")) return;

  var formjson = functions.getFormJsonFromStore();
  var eleJSON=recursiveJsonReader1(formjson,tableId,'control');
  if(eleJSON){
    if(validControls.setTableColumnName.includes(eleJSON?.elem_type)) {

      if(eleJSON.columnList?.length && columnArray.length) {
        columnArray.forEach((newColumn => {
          const { columnIndex, columnName } = newColumn;
          const updatedColumnIndex = getUpdatedColumnIndex(eleJSON, formjson, columnIndex);
          const existingColumn = eleJSON.columnList.find(column => column.style.ColumnName === columnName);
  
          if(eleJSON.columnList[updatedColumnIndex]?.style?.ColumnName && !existingColumn) {
            eleJSON.columnList[updatedColumnIndex].style.ColumnNameAPI = columnName;
          } else {
            functions.showMess(["COLUMN_EXIST"],"error");
          }
        }))
        // if(!functions.fromExecuteServerEvent){
        //   updateRenderState(eleJSON?.id);
        // }
          if(!notContainParent(eleJSON) && eleJSON?.id)
            functions.renderElementsArray.add(eleJSON?.id)
        eleJSON.style.updateFormState = Date.now();
        functions.render = true;
      } else {
        functions.showMess([tableId," does not contain any column"],"error");
      }
    }
    else {
      functions.showMess(["setTableColumnName","Not_Valid",tableId],"error");
    }
  }
  else {
    functions.showMess(["The_Control",tableId,"Not_Present"],"error");
  }
}

const findTheControlFrom = (formJson, controlId, elemType) => {
  if(formJson !== undefined && formJson != null)
  {
    if(Array.isArray(formJson)){
      if(formJson.length>0){
        let controls = formJson.map((item) => {
          if(item?.id===controlId){
            return item;
          } else {
            let controlFound = findTheControlFrom(item, controlId, elemType);
            if(controlFound!==undefined) return controlFound;
          }
        });
        if(controls!==undefined && controls!==null && controls.length>0) {
          if(Array.isArray()){
            controls = controls.filter(function( element ) {
              return element !== undefined;
            });
            return controls[0] || controls;
          } else if(controls!==undefined) {
            return controls;
          }
        }
      }
    } else {
      if(formJson?.id===controlId){
        return formJson;
      } else {
        let controlFound = findTheControlFrom(formJson?.children, controlId, elemType);
        if(controlFound!==undefined) return controlFound;
      }
    }
  }
}

function isGrid(elem_type = "") {
  const elemType = elem_type.toLowerCase();
  if(elemType === "table" || elemType === "listview" || elemType === "advancelistview") {
    return true;
  } else {
    return false;
  }
}

function checkForSectionCollapse(sectionId, collapseMap){
  return collapseMap[sectionId];
}

function getFamilyTreePath(formState, controlId){
  let familyTreePath='';
  let familyTreeElemPath='';
  if(formState!==undefined && controlId!==undefined && controlId!==''){
    if(formState?.children){
      formStateLoop:
      for (let i = 0; i < formState.children.length; i++) {
        let greatGrandFather = formState.children[i];
        if(greatGrandFather?.id===controlId){
          familyTreePath = controlId;
          familyTreeElemPath = greatGrandFather.elem_type;
          break formStateLoop;
        } else {
          if(greatGrandFather?.children){
          greatGrandFatherLoop:
          for (let j = 0; j < greatGrandFather.children.length; j++) {
            let grandFather = greatGrandFather.children[j];
            if(grandFather?.id===controlId){
              familyTreePath = greatGrandFather?.id+'|'+grandFather?.id;
              familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type;
              break formStateLoop;
            } else {
              if(grandFather?.children){
                grandFatherLoop:
                for(let k=0;k<grandFather?.children.length;k++){
                  let father = grandFather?.children[k];
                  if(father?.id===controlId){
                    familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id;
                    familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type;
                    break formStateLoop;
                  } else {
                    if(father?.children){
                      fatherLoop:
                      for(let l=0;l<father.children.length; l++){
                        let presentGen = father.children[l];
                        if(presentGen?.id===controlId){
                          familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen?.id;
                          familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen?.elem_type;
                          break formStateLoop;
                        } else {
                          if(presentGen?.children){
                            presentGenLoop:
                            for(let m=0;m<presentGen?.children.length; m++){
                              let son = presentGen.children[m];
                              if(son?.id===controlId){
                                familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id;
                                familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type;
                                break formStateLoop;
                              } else {
                                if(son?.children){
                                  sonLoop:
                                  for(let n=0; n<son.children.length;n++){
                                    let grandSon = son.children[n];
                                    if(grandSon.id===controlId){
                                      familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id;
                                      familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type;
                                      break formStateLoop;
                                    } else {
                                      if(son?.children){
                                        grandSonLoop:
                                        for(let o=0; o<grandSon.children.length;o++){
                                          let greatGrandSon = grandSon.children[o];
                                          if(greatGrandSon.id===controlId){
                                            familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id;
                                            familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type;
                                            break formStateLoop;
                                          } else {
                                            if(grandSon?.children){
                                              greatGrandSonLoop:
                                              for(let p=0; p<greatGrandSon.children.length;p++){
                                                let greatGreatGrandSon = greatGrandSon.children[p];
                                                if(greatGreatGrandSon.id===controlId){
                                                  familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id;
                                                  familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type;
                                                  break formStateLoop;
                                                } else {
                                                  if(greatGreatGrandSon?.children){
                                                    greatGrandSonLoop2:
                                                    for(let q=0; q<greatGreatGrandSon.children.length;q++){
                                                      let greatGreatGrandSon2 = greatGreatGrandSon.children[q];
                                                      if(greatGreatGrandSon2.id===controlId){
                                                        familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id+'|'+greatGreatGrandSon2.id;
                                                        familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type+'|'+greatGreatGrandSon2.elem_type;
                                                        break formStateLoop;
                                                      } else {
                                                        if(greatGreatGrandSon2?.children){
                                                          greatGrandSonLoop3:
                                                          for(let r=0; r<greatGreatGrandSon2.children.length;r++){
                                                            let greatGreatGrandSon3 = greatGreatGrandSon2.children[r];
                                                            if(greatGreatGrandSon3.id===controlId){
                                                              familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id+'|'+greatGreatGrandSon2.id+'|'+greatGreatGrandSon3.id;
                                                              familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type+'|'+greatGreatGrandSon2.elem_type+'|'+greatGreatGrandSon3.elem_type;
                                                              break formStateLoop;
                                                            } else {
                                                              if(greatGreatGrandSon3?.children){
                                                                greatGrandSonLoop4:
                                                                for(let s=0; s<greatGreatGrandSon3.children.length;s++){
                                                                  let greatGreatGrandSon4 = greatGreatGrandSon3.children[s];
                                                                  if(greatGreatGrandSon4.id===controlId){
                                                                    familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id+'|'+greatGreatGrandSon2.id+'|'+greatGreatGrandSon3.id+'|'+greatGreatGrandSon4.id;
                                                                    familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type+'|'+greatGreatGrandSon2.elem_type+'|'+greatGreatGrandSon3.elem_type+'|'+greatGreatGrandSon4.elem_type;
                                                                    break formStateLoop;
                                                                  } else {
                                                                    if(greatGreatGrandSon4?.children){
                                                                      greatGrandSonLoop5:
                                                                      for(let t=0; t<greatGreatGrandSon4.children.length;t++){
                                                                        let greatGreatGrandSon5 = greatGreatGrandSon4.children[t];
                                                                        if(greatGreatGrandSon5.id===controlId){
                                                                          familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id+'|'+greatGreatGrandSon2.id+'|'+greatGreatGrandSon3.id+'|'+greatGreatGrandSon4.id+'|'+greatGreatGrandSon5.id;
                                                                          familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type+'|'+greatGreatGrandSon2.elem_type+'|'+greatGreatGrandSon3.elem_type+'|'+greatGreatGrandSon4.elem_type+'|'+greatGreatGrandSon5.elem_type;
                                                                          break formStateLoop;
                                                                        } else {
                                                                          if(greatGreatGrandSon5?.children){
                                                                            greatGrandSonLoop6:
                                                                            for(let u=0; u<greatGreatGrandSon5.children.length;u++){
                                                                              let greatGreatGrandSon6 = greatGreatGrandSon5.children[u];
                                                                              if(greatGreatGrandSon6.id===controlId){
                                                                                familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id+'|'+greatGreatGrandSon2.id+'|'+greatGreatGrandSon3.id+'|'+greatGreatGrandSon4.id+'|'+greatGreatGrandSon5.id+'|'+greatGreatGrandSon6.id;
                                                                                familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type+'|'+greatGreatGrandSon2.elem_type+'|'+greatGreatGrandSon3.elem_type+'|'+greatGreatGrandSon4.elem_type+'|'+greatGreatGrandSon5.elem_type+'|'+greatGreatGrandSon6.elem_type;
                                                                                break formStateLoop;
                                                                              } else {
                                                                                if(greatGreatGrandSon6?.children){
                                                                                  greatGrandSonLoop7:
                                                                                  for(let v=0; v<greatGreatGrandSon6.children.length;v++){
                                                                                    let greatGreatGrandSon7 = greatGreatGrandSon6.children[v];
                                                                                    if(greatGreatGrandSon7.id===controlId){
                                                                                      familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id+'|'+greatGreatGrandSon2.id+'|'+greatGreatGrandSon3.id+'|'+greatGreatGrandSon4.id+'|'+greatGreatGrandSon5.id+'|'+greatGreatGrandSon6.id+'|'+greatGreatGrandSon7.id;
                                                                                      familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type+'|'+greatGreatGrandSon2.elem_type+'|'+greatGreatGrandSon3.elem_type+'|'+greatGreatGrandSon4.elem_type+'|'+greatGreatGrandSon5.elem_type+'|'+greatGreatGrandSon6.elem_type+'|'+greatGreatGrandSon7.elem_type;
                                                                                      break formStateLoop;
                                                                                    } else {
                                                                                      if(greatGreatGrandSon7?.children){
                                                                                        greatGrandSonLoop8:
                                                                                        for(let w=0; w<greatGreatGrandSon7.children.length;w++){
                                                                                          let greatGreatGrandSon8 = greatGreatGrandSon7.children[w];
                                                                                          if(greatGreatGrandSon8.id===controlId){
                                                                                            familyTreePath = greatGrandFather?.id+'|'+grandFather?.id+'|'+father?.id+'|'+presentGen.id+'|'+son.id+'|'+grandSon.id+'|'+greatGrandSon.id+'|'+greatGreatGrandSon.id+'|'+greatGreatGrandSon2.id+'|'+greatGreatGrandSon3.id+'|'+greatGreatGrandSon4.id+'|'+greatGreatGrandSon5.id+'|'+greatGreatGrandSon6.id+'|'+greatGreatGrandSon7.id+'|'+greatGreatGrandSon8.id;
                                                                                            familyTreeElemPath = greatGrandFather?.elem_type+'|'+grandFather?.elem_type+'|'+father?.elem_type+'|'+presentGen.elem_type+'|'+son.elem_type+'|'+grandSon.elem_type+'|'+greatGrandSon.elem_type+'|'+greatGreatGrandSon.elem_type+'|'+greatGreatGrandSon2.elem_type+'|'+greatGreatGrandSon3.elem_type+'|'+greatGreatGrandSon4.elem_type+'|'+greatGreatGrandSon5.elem_type+'|'+greatGreatGrandSon6.elem_type+'|'+greatGreatGrandSon7.elem_type+'|'+greatGreatGrandSon8.elem_type;
                                                                                            break formStateLoop;
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  let obj = {};
  obj.familyTreeElemPath = familyTreeElemPath;
  obj.familyTreePath=familyTreePath;
  return obj;
  }
}

function setFocusOnElement(elementToFocusJson ,formjson){
  const actualControlId = elementToFocusJson.id;
  let mappingId = elementToFocusJson["style"] && elementToFocusJson["style"]["MappingId"];
  let userDefinedId = elementToFocusJson["style"] && elementToFocusJson["style"]["CustomId"];

  //getting the suggested ID, that would be rendered in the HTML DOM
  let suggestedId = getSuggestedId(actualControlId, mappingId, userDefinedId);
  //getting the path upto that control from formstate
  let familyTreeJson = getFamilyTreePath(formjson, actualControlId);
  // will have to apply conditions here in case of Tab and other type of containers, except section
}

export function getSuggestedId(actualControlId, mappingId, userDefinedId) {
  let suggestedId;
  let IdPrecedence = (formStateStore.getState())?.contexts?.IdPrecedence;
  const isIBPSClient = window?.psh_configs?.isIBPSClient || false;
  if (IdPrecedence === undefined || IdPrecedence === null) {
    IdPrecedence = 0;
  }
  if (IdPrecedence === 0) {
    if (mappingId) {
      suggestedId = mappingId;
    } else if (userDefinedId) {
      suggestedId = userDefinedId;
    } else {
      suggestedId = actualControlId;
    }
  } else {
    if (userDefinedId) {
      suggestedId = userDefinedId;
    } else if (mappingId) {
      suggestedId = mappingId;
    } else {
      suggestedId = actualControlId;
    }
  }
  //This id would be rendered on the HTML
  return suggestedId === mappingId && isIBPSClient ? suggestedId?.replaceAll(".", "_") : suggestedId;
}
function executeRouteJourney(FormName, DecisionField, controlId) {
  var formjson = functions.getFormJsonFromStore();
  var eleJSON = recursiveJsonReader1(formjson, controlId, 'control');
  const reduxContexts={}
  reduxContexts.contexts=getReduxContexts();
  reduxContexts.gdtoken=getGdToken();
  reduxContexts.witoken=getWIToken();
  if (eleJSON) {
      if (validControls.executeRouteJourney.includes(eleJSON?.elem_type)) {
          eleJSON.calledFromAPI = true;
          functions.render = true;

        executeRouteJourney1(FormName, DecisionField, controlId,eleJSON,reduxContexts,"routejourney");
      } else {
          functions.showMess(["executeRouteJourney", "Not_Valid", controlId], "error");
      }
  } else {
      functions.showMess(["The_Control", controlId, "Not_Present"], "error");
  }
}


//funtion to verify wether a given SQL query (potentially any query since we are only consuming an API) is valid or not.
//expects the query to be encrypted by default, if it is not, then first encrypt and then consume API
export async function validateSqlQuery(query, isEncrypted = true) {
  let validationResult = {
    error: false,
    errorMessage: ""
  }
  
  try {
    let queryToSend = query;
    if(!isEncrypted) {
      queryToSend = await encrypt(query);
    }
  
    
    return await axios.post("/idesign/validateQuery", 
      {query: queryToSend}, 
      { withCredentials: true}
    ).then(resp => {
      if(resp.data?.status === "0") {
        validationResult.error = true;
        validationResult.errorMessage = resp.data?.error;
      } else if(resp.data?.status === "2" || resp?.status === 500) {
        validationResult.error = true;
        validationResult.errorMessage = "There is some issue at server end";
      }
      return validationResult;
    })
  
  } catch(error) {
    validationResult.error = true;
    validationResult.errorMessage = "There was some issue while validating the query";
    return validationResult;
  }

}

//utility function to check if a given query contains the supplied keyword
export function queryContainsKeyword(query = "", keyword = "orderby") {
  if(keyword === "" || query === "") return false;

  const normalized = query.replace(/\s+/g, ' ').trim();

  let keyRegex = /\border\s+by\b/i;
  
  if(keyword === "orderby") {
  }


  return !!keyRegex.test(normalized);

}


export const generalError_fn = async (exception, error_msg, type = "error", duration) => {
  let mode = window.psh_configs?.developer_mode;

  if (mode === "development") {

    // to show popup error msg on UI 
    functions.showSplitMessage("", error_msg, type, true, true, [], {vertical: "top", horizontal: "center"}, duration);
    console.error("Error message:", error_msg);
    console.error("Exception details:", exception);

  }

  // to log errors in backend server
  const jsonToSend = {
    "logs": typeof exception === 'string'
    ? exception
    : typeof exception === 'object'
      ? JSON.stringify(exception)
      : String(exception),

  }

  try {
    const response = await axios.post("/viewform/generateLogs", jsonToSend, { withCredentials: true });
    console.log('response', response);
  }
  catch (error) {
    console.log(error)
  }
}

//function that returns true if the given params are valid based on the given schema, this schema is currently based on zod schemas. 
//if show error is false return the zod error obj or show error and report there was a error
export const validateParams = (validator, params, apiName, showError = true) => {
  try {
    const validationObj = validator.safeParse(params);
    if(showError) {
      if(!validationObj?.success) {
        const errorMsg = z.prettifyError(validationObj?.error);
        if(functions.apiErrors[apiName]) {
          functions.apiErrors[apiName].push(errorMsg)
        } else {
          functions.apiErrors[apiName] = [errorMsg];
        }
        return false
      }
    }
    return validationObj;
  } catch {
    console.log("Error in validating parameters")
  }
}